export const listSVGIcon01 = {
  menuReport1: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
    >
      <path d="M280-320q17 0 28.5-11.5T320-360q0-17-11.5-28.5T280-400q-17 0-28.5 11.5T240-360q0 17 11.5 28.5T280-320Zm-40-120h80v-200h-80v200Zm160 80h320v-80H400v80Zm0-160h320v-80H400v80ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z" />
    </svg>
  ),
  menuReport2: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
    >
      <path d="M240-160q-33 0-56.5-23.5T160-240q0-33 23.5-56.5T240-320q33 0 56.5 23.5T320-240q0 33-23.5 56.5T240-160Zm0-240q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm0-240q-33 0-56.5-23.5T160-720q0-33 23.5-56.5T240-800q33 0 56.5 23.5T320-720q0 33-23.5 56.5T240-640Zm240 0q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Zm240 0q-33 0-56.5-23.5T640-720q0-33 23.5-56.5T720-800q33 0 56.5 23.5T800-720q0 33-23.5 56.5T720-640ZM480-400q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm40 240v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T863-380L643-160H520Zm300-263-37-37 37 37ZM580-220h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" />
    </svg>
  ),
  menuReport3: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
    >
      <path d="M120-120v-80l80-80v160h-80Zm160 0v-240l80-80v320h-80Zm160 0v-320l80 81v239h-80Zm160 0v-239l80-80v319h-80Zm160 0v-400l80-80v480h-80ZM120-327v-113l280-280 160 160 280-280v113L560-447 400-607 120-327Z" />
    </svg>
  ),
  cameraUpload: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="43"
      viewBox="0 0 42 43"
      fill="none"
    >
      <path
        d="M39.375 31.8008C39.375 33.2505 38.1997 34.4258 36.75 34.4258H5.25C3.80025 34.4258 2.625 33.2505 2.625 31.8008V16.0508C2.625 14.601 3.80025 13.4258 5.25 13.4258H8.32538C10.414 13.4258 12.417 12.5961 13.8938 11.1192L16.0685 8.94462C16.5607 8.45234 17.2284 8.17578 17.9246 8.17578H24.0754C24.7716 8.17578 25.4393 8.45234 25.9315 8.94463L28.1062 11.1192C29.583 12.5961 31.586 13.4258 33.6746 13.4258H36.75C38.1997 13.4258 39.375 14.601 39.375 16.0508V31.8008ZM5.25 10.8008C2.35051 10.8008 0 13.1513 0 16.0508V31.8008C0 34.7003 2.35051 37.0508 5.25 37.0508H36.75C39.6495 37.0508 42 34.7003 42 31.8008V16.0508C42 13.1513 39.6495 10.8008 36.75 10.8008H33.6746C32.2822 10.8008 30.9469 10.2477 29.9623 9.26309L27.7877 7.08847C26.8031 6.1039 25.4678 5.55078 24.0754 5.55078H17.9246C16.5322 5.55078 15.1969 6.1039 14.2123 7.08847L12.0377 9.26309C11.0531 10.2477 9.71777 10.8008 8.32538 10.8008H5.25Z"
        fill="white"
      />
      <path
        d="M21 29.1758C17.3756 29.1758 14.4375 26.2376 14.4375 22.6133C14.4375 18.9889 17.3756 16.0508 21 16.0508C24.6244 16.0508 27.5625 18.9889 27.5625 22.6133C27.5625 26.2376 24.6244 29.1758 21 29.1758ZM21 31.8008C26.0741 31.8008 30.1875 27.6874 30.1875 22.6133C30.1875 17.5392 26.0741 13.4258 21 13.4258C15.9259 13.4258 11.8125 17.5392 11.8125 22.6133C11.8125 27.6874 15.9259 31.8008 21 31.8008Z"
        fill="white"
      />
      <path
        d="M7.875 17.3633C7.875 18.0882 7.28737 18.6758 6.5625 18.6758C5.83763 18.6758 5.25 18.0882 5.25 17.3633C5.25 16.6384 5.83763 16.0508 6.5625 16.0508C7.28737 16.0508 7.875 16.6384 7.875 17.3633Z"
        fill="white"
      />
    </svg>
  ),
  "printer-receipt": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.875 1.5C6.83947 1.5 6 2.33947 6 3.375V6.36564C5.5736 6.41799 5.1489 6.47583 4.72596 6.53912C3.27191 6.75668 2.25 8.02163 2.25 9.45569V15.75C2.25 17.4069 3.59315 18.75 5.25 18.75H5.51963L5.36461 20.4552C5.26479 21.5533 6.12935 22.5 7.23191 22.5H16.7681C17.8706 22.5 18.7352 21.5533 18.6354 20.4552L18.4804 18.75H18.75C20.4069 18.75 21.75 17.4069 21.75 15.75V9.45569C21.75 8.02163 20.7281 6.75668 19.274 6.53912C18.8511 6.47583 18.4264 6.41799 18 6.36564V3.375C18 2.33947 17.1605 1.5 16.125 1.5H7.875ZM16.5 6.20498V3.375C16.5 3.16789 16.3321 3 16.125 3H7.875C7.66789 3 7.5 3.16789 7.5 3.375V6.20498C8.98198 6.06931 10.483 6 12 6C13.517 6 15.018 6.06931 16.5 6.20498ZM16.2834 14.4696C16.4607 14.4879 16.5996 14.6298 16.6158 14.8073L17.1415 20.591C17.1615 20.8107 16.9886 21 16.7681 21H7.23191C7.0114 21 6.83849 20.8107 6.85845 20.591L7.38425 14.8073C7.40039 14.6298 7.53926 14.4879 7.71659 14.4696C9.12438 14.3244 10.5534 14.25 12 14.25C13.4466 14.25 14.8756 14.3244 16.2834 14.4696ZM17.25 10.5C17.25 10.0858 17.5858 9.75 18 9.75H18.0075C18.4217 9.75 18.7575 10.0858 18.7575 10.5V10.5075C18.7575 10.9217 18.4217 11.2575 18.0075 11.2575H18C17.5858 11.2575 17.25 10.9217 17.25 10.5075V10.5ZM15 9.75C14.5858 9.75 14.25 10.0858 14.25 10.5V10.5075C14.25 10.9217 14.5858 11.2575 15 11.2575H15.0075C15.4217 11.2575 15.7575 10.9217 15.7575 10.5075V10.5C15.7575 10.0858 15.4217 9.75 15.0075 9.75H15Z"
        fill="white"
      />
    </svg>
  ),
  "update-receipt": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3.75C7.44366 3.75 3.75 7.44366 3.75 12C3.75 16.5563 7.44366 20.25 12 20.25C14.2784 20.25 16.3399 19.3274 17.8336 17.8336C18.1265 17.5407 18.6014 17.5407 18.8943 17.8336C19.1872 18.1265 19.1872 18.6014 18.8943 18.8943C17.1307 20.6579 14.6922 21.75 12 21.75C6.61524 21.75 2.25 17.3848 2.25 12C2.25 6.61524 6.61524 2.25 12 2.25C14.6922 2.25 17.1307 3.34212 18.8943 5.10572M18.8943 5.10572C19.3237 5.5351 19.9945 6.26432 20.5484 6.87504C20.8275 7.18275 21.0804 7.46428 21.2635 7.66887C21.3551 7.77119 21.4293 7.85433 21.4807 7.91195L21.5604 8.00158L20.4392 8.99799L20.3608 8.90993C20.3101 8.85303 20.2366 8.77071 20.1459 8.6693C19.9643 8.46643 19.7136 8.18742 19.4373 7.88276C18.8804 7.26876 18.2332 6.566 17.8336 6.16638C16.3399 4.6726 14.2784 3.75 12 3.75M21.498 9.0608C21.1883 9.33584 20.7142 9.30771 20.4392 8.99799L21.5604 8.00158C21.8355 8.3113 21.8077 8.78577 21.498 9.0608Z"
        fill="white"
      />
      <path
        d="M21 3.25C21.4142 3.25 21.75 3.58579 21.75 4V8.5C21.75 8.91421 21.4142 9.25 21 9.25H16.5C16.0858 9.25 15.75 8.91421 15.75 8.5C15.75 8.08579 16.0858 7.75 16.5 7.75H20.25V4C20.25 3.58579 20.5858 3.25 21 3.25Z"
        fill="white"
      />
    </svg>
  ),
  "preview-question": (
    <svg
      width="109"
      height="108"
      viewBox="0 0 109 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.9551 33.8348C50.2272 29.2217 58.7749 29.2217 64.047 33.8348C69.319 38.4479 69.319 45.9271 64.047 50.5402C63.1294 51.3431 62.1125 52.0063 61.031 52.5297C57.6754 54.1537 54.501 57.0221 54.501 60.75V64.125M95 54C95 76.3675 76.8675 94.5 54.5 94.5C32.1325 94.5 14 76.3675 14 54C14 31.6325 32.1325 13.5 54.5 13.5C76.8675 13.5 95 31.6325 95 54ZM54.5 77.625H54.5338V77.6588H54.5V77.625Z"
        stroke="#F7BB86"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  coin: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C17.5238 2 22.0119 6.4881 22 12.006C21.994 17.5238 17.5178 22 12 22C6.48214 22 1.99405 17.5119 2.00001 11.994C2.00596 6.47619 6.48214 2 12 2ZM20.5833 11.9881C20.5714 7.23214 16.744 3.42262 11.9762 3.42262C7.27976 3.42857 3.44048 7.27976 3.44048 11.9881C3.44048 16.7262 7.29762 20.5714 12.0357 20.5655C16.7559 20.5595 20.5893 16.7083 20.5833 11.9881Z"
        fill="#333"
      />
      <path
        d="M10.4585 9.94015C10.4585 9.34604 10.9155 8.97391 11.5358 8.9021V10.9978C11.4705 10.9847 11.4117 10.9651 11.353 10.9456C10.7588 10.7497 10.4585 10.4102 10.4585 9.94015ZM13.7228 14.014C13.7228 14.6538 13.2332 15.0782 12.5412 15.1369V12.8846C12.5869 12.8976 12.6326 12.9107 12.6717 12.9172C13.4029 13.1196 13.7228 13.4787 13.7228 14.014ZM12.5542 17.3763L12.5477 16.5471C14.3365 16.3774 15.4725 15.3915 15.4725 13.8377C15.4725 12.2578 14.4083 11.5919 13.0961 11.3112L12.5412 11.1936V8.91515C13.2332 9.02614 13.6184 9.54843 13.638 10.0707H15.3093C15.2832 8.71277 14.219 7.68124 12.5673 7.50497V6.65625H11.5096V7.49844C9.92971 7.64207 8.68928 8.51038 8.68928 10.0772C8.68928 11.5592 9.75997 12.3166 10.9743 12.5842L11.5358 12.7083V15.1369C10.7001 15.0259 10.2627 14.5232 10.23 13.9226H8.51953C8.53259 15.1304 9.34214 16.4035 11.5031 16.5602L11.4966 17.3763H12.5542Z"
        fill="#333"
      />
    </svg>
  ),
  "description-viewer": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2835_21091)">
        <path
          d="M18.8448 23.9998C18.5137 23.9998 18.1888 23.9998 17.8576 23.9998C17.8138 23.9873 17.7701 23.9686 17.7264 23.9623C15.7769 23.7061 14.3335 22.7061 13.3775 20.9998C13.2963 20.8561 13.2213 20.8436 13.0838 20.8748C10.3783 21.4998 7.79771 21.1498 5.36709 19.7936C1.06196 17.3873 -1.0125 12.1373 0.480864 7.43106C2.09919 2.34981 7.13538 -0.731443 12.3903 0.149807C18.37 1.15606 22.3127 7.11856 20.888 13.0373C20.8443 13.2186 20.8631 13.3061 21.038 13.3998C22.5314 14.2311 23.4749 15.4811 23.8623 17.1498C23.9185 17.3811 23.9498 17.6248 23.9935 17.8623C23.9935 18.1936 23.9935 18.5186 23.9935 18.8498C23.981 18.9186 23.9622 18.9811 23.9498 19.0498C23.5998 21.2998 22.3627 22.8498 20.2382 23.6686C19.8008 23.8311 19.3135 23.8936 18.8448 23.9998ZM16.9703 10.5936C16.9266 10.2061 16.9016 9.81856 16.8329 9.43106C16.208 5.90606 12.6777 3.57481 9.19734 4.38731C5.7045 5.19981 3.59255 8.61856 4.41734 12.1061C5.28586 15.7686 9.31606 17.8936 12.8339 16.5311C12.9464 16.4873 13.0651 16.3686 13.1151 16.2623C13.7399 14.7811 14.7896 13.7311 16.2768 13.1061C16.3767 13.0623 16.4829 12.9623 16.5204 12.8623C16.8079 12.1373 16.9453 11.3811 16.9703 10.5936ZM19.4822 12.7936C20.3569 9.65606 19.3322 5.24981 15.4207 2.78106C11.8279 0.512307 6.94168 1.11231 4.01119 4.19356C0.943243 7.41856 0.549596 12.2686 3.04895 15.8186C5.65452 19.5186 9.95965 20.2998 12.7964 19.4748C12.7589 19.0123 12.7214 18.5498 12.6902 18.0811C8.04764 19.4811 3.06144 16.0061 2.8365 10.9248C2.64905 6.53106 6.14189 2.81856 10.6095 2.83106C12.8526 2.83731 14.7771 3.67481 16.2892 5.33731C18.2137 7.44981 18.7386 9.93731 18.0888 12.6873C18.5512 12.7186 19.0073 12.7561 19.4822 12.7936ZM22.5939 18.3686C22.6001 16.0373 20.7068 14.1248 18.3825 14.1123C16.0456 14.0998 14.1211 15.9998 14.1148 18.3373C14.1086 20.6623 16.0018 22.5811 18.3262 22.5936C20.6756 22.6061 22.5876 20.7061 22.5939 18.3686Z"
          fill="black"
        />
        <path
          d="M9.89768 7.075C9.89768 6.75625 9.89768 6.4625 9.89768 6.15625C10.3663 6.15625 10.8162 6.15625 11.2973 6.15625C11.2973 6.4 11.3036 6.6375 11.2911 6.875C11.2848 7.0375 11.3286 7.1 11.4973 7.1375C12.3595 7.35 13.0094 8.1375 13.0719 9.025C13.0781 9.06875 13.0656 9.1125 13.0656 9.175C12.6032 9.175 12.1533 9.175 11.7035 9.175C11.4848 8.5625 11.3598 8.475 10.6975 8.475C10.535 8.475 10.3663 8.46875 10.2039 8.48125C9.79771 8.5 9.50404 8.79375 9.49779 9.175C9.49154 9.56875 9.79771 9.875 10.2101 9.89375C10.5913 9.90625 10.9787 9.875 11.3536 9.9375C12.3345 10.1 13.0531 10.9375 13.0844 11.9C13.1218 12.9312 12.4845 13.8063 11.491 14.05C11.3223 14.0938 11.2848 14.1625 11.2911 14.3188C11.3036 14.55 11.2911 14.7812 11.2911 15.0312C10.8224 15.0312 10.3726 15.0312 9.88519 15.0312C9.88519 14.7937 9.87894 14.5563 9.88519 14.3188C9.89144 14.1625 9.85395 14.0938 9.68524 14.05C8.74798 13.825 8.06066 12.9375 8.1169 12.05C8.57303 12.05 9.02291 12.05 9.47904 12.05C9.63525 12.575 9.81646 12.7125 10.3726 12.7125C10.5725 12.7125 10.7787 12.7187 10.9787 12.7125C11.3785 12.7 11.6722 12.3938 11.6722 12.0063C11.6722 11.6188 11.3785 11.3188 10.9787 11.3C10.61 11.2875 10.2413 11.3125 9.87894 11.2625C8.86046 11.1187 8.13564 10.2938 8.08566 9.25625C8.03567 8.28125 8.698 7.4 9.6665 7.1375C9.74148 7.1125 9.81021 7.09375 9.89768 7.075Z"
          fill="black"
        />
        <path
          d="M17.5638 19.2261C17.9075 18.8823 18.2386 18.5511 18.5698 18.2136C19.1634 17.6198 19.757 17.0261 20.3506 16.4323C20.563 16.2198 20.8442 16.1948 21.0567 16.3698C21.2566 16.5323 21.2941 16.8261 21.1441 17.0386C21.1129 17.0823 21.0692 17.1261 21.0317 17.1698C20.0132 18.1886 18.9947 19.2073 17.9762 20.2261C17.695 20.5073 17.4264 20.5073 17.1452 20.2261C16.6266 19.7073 16.1017 19.1823 15.5831 18.6636C15.3456 18.4261 15.3581 18.1011 15.5956 17.9011C15.7768 17.7511 16.0267 17.7448 16.2079 17.8948C16.2829 17.9573 16.3516 18.0261 16.4204 18.0948C16.8078 18.4636 17.1827 18.8386 17.5638 19.2261Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2835_21091">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "default-bin": (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7404 8L11.3942 17M6.60577 17L6.25962 8M16.2276 4.79057C16.5696 4.84221 16.9104 4.89747 17.25 4.95629M16.2276 4.79057L15.1598 18.6726C15.0696 19.8448 14.0921 20.75 12.9164 20.75H5.08357C3.90786 20.75 2.93037 19.8448 2.8402 18.6726L1.77235 4.79057M16.2276 4.79057C15.0812 4.61744 13.9215 4.48485 12.75 4.39432M0.75 4.95629C1.08957 4.89747 1.43037 4.84221 1.77235 4.79057M1.77235 4.79057C2.91878 4.61744 4.07849 4.48485 5.25 4.39432M12.75 4.39432V3.47819C12.75 2.29882 11.8393 1.31423 10.6606 1.27652C10.1092 1.25889 9.55565 1.25 9 1.25C8.44435 1.25 7.89078 1.25889 7.33942 1.27652C6.16065 1.31423 5.25 2.29882 5.25 3.47819V4.39432M12.75 4.39432C11.5126 4.2987 10.262 4.25 9 4.25C7.73803 4.25 6.48744 4.2987 5.25 4.39432"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "default-edit-form": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2835_20760)">
        <path
          d="M0 6.62598C0.140625 6.25032 0.229688 5.84179 0.426562 5.499C0.989062 4.53637 1.86094 4.01984 2.97656 4.01514C5.63437 3.99636 8.2875 4.00575 10.9453 4.01045C11.5641 4.01045 12.0094 4.44715 12 5.02943C11.9906 5.59761 11.55 6.01553 10.9406 6.01553C8.33906 6.01553 5.7375 6.01553 3.13594 6.01553C2.39531 6.01553 2.00625 6.40528 2.00625 7.13782C2.00625 11.7303 2.00625 16.3227 2.00625 20.9199C2.00625 21.6477 2.39062 22.0374 3.11719 22.0374C7.71094 22.0374 12.3047 22.0374 16.8984 22.0374C17.6156 22.0374 18.0047 21.6336 18.0047 20.9105C18.0047 18.2949 18.0047 15.6841 18.0047 13.0686C18.0047 12.336 18.6609 11.8524 19.3266 12.0778C19.7484 12.2186 20.0016 12.599 20.0062 13.0967C20.0109 13.9983 20.0062 14.8952 20.0062 15.7968C20.0062 17.4638 20.0062 19.1308 20.0062 20.7978C20.0062 22.446 19.2375 23.4837 17.6672 23.9721C17.6531 23.9768 17.6437 23.9909 17.6297 24.0003C12.5344 24.0003 7.44375 24.0003 2.34844 24.0003C2.29219 23.9768 2.24062 23.9486 2.17969 23.9298C1.3875 23.6904 0.76875 23.2161 0.384375 22.4882C0.210937 22.1548 0.126562 21.7745 0 21.4176C0 16.4871 0 11.5565 0 6.62598Z"
          fill="black"
        />
        <path
          d="M24 2.82232C23.8688 3.62529 23.3906 4.20756 22.8187 4.73349C22.5047 5.02463 22.2094 5.33924 21.9328 5.62099C20.7562 4.44235 19.5891 3.26841 18.3984 2.08039C18.4219 2.05221 18.4828 1.98647 18.5484 1.92543C18.9281 1.54507 19.3078 1.16002 19.6922 0.779664C20.4094 0.0753006 21.2672 -0.17827 22.2281 0.117562C23.1891 0.413395 23.7656 1.08958 23.9625 2.08039C23.9672 2.10856 23.9906 2.13204 24 2.16022C24 2.38561 24 2.60631 24 2.82232Z"
          fill="black"
        />
        <path
          d="M17.2687 3.22266C18.4499 4.40599 19.6171 5.57523 20.7937 6.75386C20.7562 6.79613 20.7046 6.85247 20.6484 6.90413C18.1124 9.44453 15.5812 11.9849 13.0359 14.5206C12.8906 14.6662 12.6796 14.7836 12.4781 14.8259C11.3859 15.0607 10.2937 15.272 9.19681 15.488C8.74681 15.5772 8.4515 15.2954 8.53587 14.8493C8.76087 13.7083 8.99056 12.5672 9.22962 11.4261C9.25306 11.3041 9.32337 11.1726 9.40775 11.0833C12.0187 8.46781 14.6249 5.85697 17.2359 3.24614C17.2452 3.23674 17.2593 3.22735 17.2687 3.22266Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2835_20760">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "default-file-action": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 18.0163C23.875 18.2986 23.65 18.3968 23.3438 18.3907C22.9062 18.3784 22.4688 18.3846 21.9937 18.3846C21.9937 18.4766 21.9937 18.5564 21.9937 18.6423C21.9937 19.3481 21.9937 20.0539 21.9937 20.7597C21.9875 21.7049 21.3687 22.3125 20.4062 22.3125C14.4688 22.3125 8.53125 22.3125 2.59375 22.3125C1.0625 22.3064 0 21.2507 0 19.7348C0 15.2115 0 10.6821 0 6.15884C0 4.74724 1.0875 3.66092 2.53125 3.65478C5.28125 3.64864 8.03125 3.65478 10.7812 3.64864C10.9375 3.64864 11.1062 3.59955 11.2375 3.5259C12.2063 2.96739 13.1688 2.39661 14.1313 1.82583C14.5312 1.59261 14.7688 1.64785 15 2.04064C15.2812 2.51936 15.575 2.99194 15.8438 3.47066C15.925 3.61182 16.0187 3.65478 16.175 3.64864C16.5938 3.63637 17.0187 3.64251 17.4375 3.64864C18.35 3.65478 18.9812 4.26852 18.9937 5.16458C19 5.87039 18.9937 6.57619 18.9937 7.28199C18.9937 7.36791 18.9937 7.4477 18.9937 7.55817C19.1 7.56431 19.1875 7.57045 19.2812 7.57045C19.7625 7.58272 20.25 7.55204 20.7313 7.60727C21.4375 7.68092 21.9688 8.27625 21.9875 8.96978C22.0062 9.71854 21.9937 10.4734 21.9937 11.2222C21.9937 11.3081 21.9937 11.3879 21.9937 11.5045C22.2937 11.5045 22.5688 11.5045 22.85 11.5045C23.0188 11.5045 23.1937 11.5168 23.3625 11.5045C23.6562 11.48 23.85 11.6027 23.9937 11.8421C24 13.9043 24 15.9603 24 18.0163ZM0.99375 8.06758C0.99375 8.2026 0.99375 8.27625 0.99375 8.35604C0.99375 12.1305 0.99375 15.905 0.99375 19.6734C0.99375 20.7352 1.6 21.3305 2.66875 21.3305C8.54375 21.3305 14.4125 21.3305 20.2875 21.3305C20.3563 21.3305 20.4312 21.3305 20.5 21.3305C20.7875 21.3121 20.9875 21.128 20.9937 20.8457C21 20.0478 20.9937 19.2499 20.9937 18.4521C20.9937 18.4337 20.975 18.4152 20.9625 18.3846C20.1062 18.3846 19.2438 18.3968 18.3875 18.3846C16.575 18.3539 15.0437 16.8441 15 15.0642C14.9563 13.1064 16.4875 11.5475 18.4813 11.5168C19.2313 11.5045 19.9813 11.5168 20.7313 11.5168C20.8125 11.5168 20.9 11.5168 21 11.5168C21 10.7128 21 9.93949 21 9.16617C21 8.74269 20.825 8.57084 20.3875 8.57084C19.425 8.57084 18.4688 8.57084 17.5063 8.57084C12.6688 8.57084 7.8375 8.57084 3 8.57698C2.30625 8.57084 1.625 8.53402 0.99375 8.06758ZM14.325 2.85692C11.675 4.41582 9.0375 5.97472 6.35 7.55817C9.975 7.55817 13.5312 7.55817 17.1125 7.55817C16.175 5.98086 15.2562 4.4281 14.325 2.85692ZM22.9875 17.3964C22.9875 15.7455 22.9875 14.1252 22.9875 12.4926C21.5187 12.4926 20.0625 12.4926 18.6125 12.4926C18.5062 12.4926 18.3938 12.4926 18.2875 12.4988C16.7625 12.6338 15.7187 14.07 16.0812 15.5307C16.3625 16.6538 17.3563 17.4026 18.6 17.4087C19.9875 17.4148 21.3812 17.4087 22.7687 17.4087C22.8312 17.4087 22.9 17.4026 22.9875 17.3964ZM9.28125 4.68587C9.275 4.66745 9.275 4.65518 9.26875 4.63677C9.23125 4.63677 9.19375 4.63063 9.15625 4.63063C6.95625 4.63063 4.75625 4.63063 2.55625 4.63063C2.4 4.63063 2.24375 4.64904 2.09375 4.692C1.35 4.89454 0.9375 5.55124 1.03125 6.36138C1.10625 6.99967 1.74375 7.55204 2.45 7.57045C3.04375 7.58272 3.6375 7.57659 4.23125 7.57045C4.33125 7.57045 4.44375 7.52749 4.53125 7.47839C5.31875 7.02422 6.1 6.55778 6.88125 6.09747C7.675 5.63103 8.475 5.15845 9.28125 4.68587ZM17.95 7.01808C17.9625 7.01194 17.9812 7.00581 17.9937 7.00581C17.9937 6.37979 18 5.75378 17.9937 5.12776C17.9875 4.86385 17.8187 4.66745 17.55 4.64904C17.2312 4.62449 16.9062 4.6429 16.5375 4.6429C17.025 5.45304 17.4875 6.23863 17.95 7.01808Z"
        fill="black"
      />
      <path
        d="M18.5001 16.4147C17.6626 16.4147 17.0001 15.758 17.0064 14.9356C17.0126 14.1255 17.6814 13.4749 18.5001 13.4688C19.3251 13.4688 20.0126 14.15 20.0001 14.954C19.9939 15.7641 19.3251 16.4147 18.5001 16.4147ZM18.9939 14.954C19.0001 14.684 18.7939 14.4691 18.5189 14.463C18.2376 14.4569 18.0064 14.6655 18.0001 14.9417C17.9939 15.2118 18.2314 15.4389 18.5001 15.4389C18.7751 15.4327 18.9876 15.2179 18.9939 14.954Z"
        fill="black"
      />
    </svg>
  ),
  "default-unlock": (
    <svg
      width="18"
      height="23"
      viewBox="0 0 18 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.375 9.2V5.75C3.375 4.22501 3.96763 2.76247 5.02252 1.68414C6.07742 0.605802 7.50816 0 9 0C10.4918 0 11.9226 0.605802 12.9775 1.68414C14.0324 2.76247 14.625 4.22501 14.625 5.75C14.625 6.3825 14.1187 6.9 13.5 6.9C12.8813 6.9 12.375 6.3825 12.375 5.75C12.375 4.835 12.0194 3.95748 11.3865 3.31048C10.7536 2.66348 9.89511 2.3 9 2.3C8.10489 2.3 7.24645 2.66348 6.61351 3.31048C5.98058 3.95748 5.625 4.835 5.625 5.75V9.2H15.75C16.3467 9.2 16.919 9.44232 17.341 9.87365C17.7629 10.305 18 10.89 18 11.5V20.7C18 21.31 17.7629 21.895 17.341 22.3263C16.919 22.7577 16.3467 23 15.75 23H2.25C1.65326 23 1.08097 22.7577 0.65901 22.3263C0.237053 21.895 0 21.31 0 20.7V11.5C0 10.89 0.237053 10.305 0.65901 9.87365C1.08097 9.44232 1.65326 9.2 2.25 9.2H3.375ZM2.25 11.5V20.7H15.75V11.5H2.25Z"
        fill="black"
      />
    </svg>
  ),
  "no-lock": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 0C17.37 0 18.9922 0.775923 20 2.03585C21.0061 3.29662 21.5 4.92969 21.5 6.68969L21.5 9.30769H19V6.68969C19 5.35277 18.5432 4.30354 18 3.62238C17.4559 2.94208 16.7345 2.53846 15.5 2.53846C14.2621 2.53846 13.5424 2.91923 13 3.59615C12.4585 4.27308 12 5.33923 12 6.68969V7.61538H9V6.68969C9 4.91954 9.49138 3.26785 10.5 2.00962C11.5078 0.751385 13.6334 0 15.5 0ZM14.3846 8.46154C15.7858 8.46154 16.9231 9.59877 16.9231 11V19.4615C16.9231 20.8628 15.7858 22 14.3846 22H2.53846C1.13723 22 0 20.8628 0 19.4615V11C0 9.59877 1.13723 8.46154 2.53846 8.46154H14.3846ZM8.46154 12.6923C8.01271 12.6923 7.58226 12.8706 7.2649 13.188C6.94753 13.5053 6.76923 13.9358 6.76923 14.3846C6.76923 15.0091 7.11108 15.5455 7.61538 15.8392V17.7692C7.61538 18.2355 7.99531 18.6154 8.46154 18.6154C8.92777 18.6154 9.30769 18.2355 9.30769 17.7692V15.8392C9.812 15.5455 10.1538 15.0099 10.1538 14.3846C10.1538 13.9358 9.97555 13.5053 9.65818 13.188C9.34081 12.8706 8.91037 12.6923 8.46154 12.6923Z"
        fill="#154398"
      />
    </svg>
  ),
  "primary-lock": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 8C6 6.4087 6.63214 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8H19C19.5304 8 20.0391 8.21071 20.4142 8.58579C20.7893 8.96086 21 9.46957 21 10V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V10C3 9.46957 3.21071 8.96086 3.58579 8.58579C3.96086 8.21071 4.46957 8 5 8H6ZM12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8H8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4ZM14 14C14 14.3511 13.9076 14.6959 13.732 15C13.5565 15.304 13.304 15.5565 13 15.732V17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17V15.732C10.6187 15.5119 10.3208 15.1721 10.1523 14.7653C9.98384 14.3586 9.95429 13.9076 10.0682 13.4824C10.1822 13.0571 10.4333 12.6813 10.7825 12.4133C11.1318 12.1453 11.5597 12 12 12C12.5304 12 13.0391 12.2107 13.4142 12.5858C13.7893 12.9609 14 13.4696 14 14Z"
        fill="#154398"
      />
    </svg>
  ),
  "update-icon": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2006_19930)">
        <path
          d="M0 35.3372C0.75 33.3337 1.225 31.1548 2.275 29.3266C5.275 24.1926 9.925 21.4378 15.875 21.4127C30.05 21.3125 44.2 21.3626 58.375 21.3877C61.675 21.3877 64.05 23.7168 64 26.8222C63.95 29.8525 61.6 32.0815 58.35 32.0815C44.475 32.0815 30.6 32.0815 16.725 32.0815C12.775 32.0815 10.7 34.1601 10.7 38.067C10.7 62.56 10.7 87.0531 10.7 111.571C10.7 115.453 12.75 117.532 16.625 117.532C41.125 117.532 65.625 117.532 90.125 117.532C93.95 117.532 96.025 115.378 96.025 111.521C96.025 97.5716 96.025 83.6471 96.025 69.6976C96.025 65.7907 99.525 63.2112 103.075 64.4133C105.325 65.1646 106.675 67.1932 106.7 69.8478C106.725 74.6563 106.7 79.4397 106.7 84.2482C106.7 93.1388 106.7 102.029 106.7 110.92C106.7 119.71 102.6 125.245 94.225 127.85C94.15 127.875 94.1 127.95 94.025 128C66.85 128 39.7 128 12.525 128C12.225 127.875 11.95 127.725 11.625 127.624C7.4 126.347 4.1 123.818 2.05 119.936C1.125 118.158 0.675 116.129 0 114.226C0 87.9296 0 61.6334 0 35.3372Z"
          fill="#01638d"
        />
        <path
          d="M128 15.0515C127.3 19.334 124.75 22.4394 121.7 25.2444C120.025 26.7971 118.45 28.4751 116.975 29.9777C110.7 23.6916 104.475 17.4306 98.125 11.0945C98.25 10.9442 98.575 10.5936 98.925 10.2681C100.95 8.23949 102.975 6.18588 105.025 4.15731C108.85 0.400708 113.425 -0.95167 118.55 0.626104C123.675 2.20388 126.75 5.81022 127.8 11.0945C127.825 11.2448 127.95 11.37 128 11.5203C128 12.7224 128 13.8994 128 15.0515Z"
          fill="#01638d"
        />
        <path
          d="M92.1 17.1802C98.4 23.4913 104.625 29.7272 110.9 36.0133C110.7 36.2387 110.425 36.5392 110.125 36.8147C96.6 50.3635 83.1 63.9123 69.525 77.4361C68.75 78.2125 67.625 78.8386 66.55 79.064C60.725 80.3162 54.9 81.4431 49.05 82.5952C46.65 83.071 45.075 81.5684 45.525 79.1892C46.725 73.1035 47.95 67.0178 49.225 60.9321C49.35 60.2809 49.725 59.5797 50.175 59.1039C64.1 45.1543 78 31.2299 91.925 17.3054C91.975 17.2553 92.05 17.2052 92.1 17.1802Z"
          fill="#01638d"
        />
      </g>
      <defs>
        <clipPath id="clip0_2006_19930">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "import-file-primary": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.77953 2.10624C7.74967 2.10612 7.72008 2.1119 7.69246 2.12324C7.66484 2.13459 7.63973 2.15127 7.61857 2.17235C7.59742 2.19342 7.58063 2.21846 7.56918 2.24604C7.55772 2.27361 7.55183 2.30318 7.55183 2.33304C7.55183 2.45814 7.65353 2.55894 7.77953 2.55894H11.1212C11.2472 2.55894 11.3489 2.45814 11.3489 2.33304C11.3489 2.30318 11.343 2.27361 11.3316 2.24604C11.3201 2.21846 11.3033 2.19342 11.2822 2.17235C11.261 2.15127 11.2359 2.13459 11.2083 2.12324C11.1807 2.1119 11.1511 2.10612 11.1212 2.10624H7.77953ZM11.1212 0.898438C11.7818 0.898438 12.3389 1.33944 12.5108 1.94244L14.4683 1.94334C15.0272 1.94694 15.4781 2.12784 15.7571 2.51754C15.9965 2.85234 16.0919 3.28254 16.0676 3.76584L16.0649 15.4775C16.1027 15.9743 16.0091 16.4135 15.7697 16.778C15.4889 17.2037 15.0308 17.417 14.4629 17.4224H4.62593C3.94193 17.3954 3.43523 17.2343 3.11843 16.8743C2.82413 16.5404 2.69543 16.0823 2.70083 15.5243V3.77754C2.68913 3.23754 2.83943 2.78214 3.16703 2.44554C3.50543 2.09994 4.00583 1.94694 4.64933 1.94244H6.39083C6.56183 1.33944 7.11893 0.898438 7.77953 0.898438H11.1212ZM11.1212 3.76674H7.77953C7.28813 3.76674 6.85523 3.52374 6.59423 3.15114H4.65293C4.30823 3.15294 4.11113 3.21414 4.03913 3.28794C3.95723 3.37164 3.90953 3.51474 3.91493 3.76584V15.5288C3.91223 15.8213 3.96173 15.9986 4.03193 16.0778C4.08053 16.1327 4.28933 16.1993 4.64843 16.2137H14.4584C14.6384 16.2119 14.7104 16.1777 14.7518 16.1156C14.8337 15.9914 14.8715 15.815 14.8508 15.5234L14.8517 3.73704C14.8643 3.47334 14.8274 3.30324 14.7653 3.21684C14.7419 3.18534 14.6609 3.15204 14.4629 3.15114H12.3056C12.0446 3.52374 11.6117 3.76674 11.1203 3.76674H11.1212ZM9.17633 9.99744C9.51203 9.99744 9.78383 10.2674 9.78383 10.6013C9.78383 10.9343 9.51203 11.2052 9.17633 11.2052H5.53043C5.45089 11.2056 5.37205 11.1903 5.29843 11.1602C5.22481 11.1301 5.15784 11.0857 5.10134 11.0297C5.04485 10.9737 4.99993 10.9072 4.96917 10.8338C4.9384 10.7605 4.92238 10.6818 4.92203 10.6022C4.92203 10.2683 5.19473 9.99744 5.53043 9.99744H9.17633ZM12.8231 7.58184C13.1579 7.58184 13.4306 7.85184 13.4306 8.18574C13.4306 8.51874 13.1579 8.78964 12.8231 8.78964H5.53043C5.45089 8.78999 5.37205 8.77468 5.29843 8.74457C5.22481 8.71446 5.15784 8.67014 5.10134 8.61414C5.04485 8.55815 4.99993 8.49158 4.96917 8.41822C4.9384 8.34487 4.92238 8.26618 4.92203 8.18664C4.92203 7.85274 5.19473 7.58184 5.53043 7.58184H12.8231ZM12.8231 5.16624C13.1579 5.16624 13.4306 5.43624 13.4306 5.77014C13.4304 5.84968 13.4145 5.9284 13.3838 6.00179C13.3532 6.07519 13.3084 6.14183 13.252 6.19791C13.1955 6.25398 13.1286 6.2984 13.0551 6.32862C12.9815 6.35884 12.9027 6.37427 12.8231 6.37404H5.53043C5.45089 6.37439 5.37205 6.35908 5.29843 6.32897C5.22481 6.29885 5.15784 6.25454 5.10134 6.19854C5.04485 6.14255 4.99993 6.07598 4.96917 6.00262C4.9384 5.92927 4.92238 5.85058 4.92203 5.77104C4.92203 5.43714 5.19473 5.16624 5.53043 5.16624H12.8231Z"
        fill="#154398"
        fillOpacity="0.78"
      />
    </svg>
  ),
  "sign-icon": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M92.4156 34.2046C90.3261 36.5571 88.3997 38.7464 86.2448 41.1643C78.8007 33.6164 71.4872 26.2645 63.9451 18.6186C63.9451 20.089 63.9451 21.1346 63.9451 22.2129C63.9451 27.2775 63.9451 32.3421 63.9451 37.4067C63.9451 40.7722 65.7082 42.5367 69.0711 42.5693C73.5441 42.602 77.9845 42.5693 82.4575 42.5693C83.0125 42.5693 83.6002 42.5693 84.1553 42.5693C84.2532 42.7327 84.3512 42.8961 84.4165 43.0921C82.3595 45.0853 80.1393 46.9151 78.2783 49.0716C76.4499 51.1955 74.393 52.1104 71.6178 51.751C69.6261 51.4896 67.5692 51.751 65.6102 51.3589C59.4394 50.1826 54.8685 44.5625 54.8032 38.1582C54.7379 30.1529 54.7705 22.1475 54.7705 14.1421C54.7705 13.554 54.7705 12.9659 54.7705 12.1817C54.1175 12.149 53.5298 12.0836 52.9748 12.0836C42.2004 12.0836 31.426 12.0836 20.6516 12.0836C16.8315 12.149 15.1664 13.7827 15.1664 17.6057C15.1664 48.5488 15.1664 79.4593 15.1664 110.402C15.1664 114.095 16.8642 115.794 20.5536 115.794C43.3431 115.794 66.1653 115.794 88.9548 115.794C92.7421 115.794 94.4073 114.095 94.4073 110.272C94.4073 103.639 94.3746 96.9731 94.4399 90.3401C94.4399 89.5232 94.8644 88.543 95.4194 87.9548C97.9008 85.2755 100.48 82.7268 103.386 79.7534C103.451 80.7663 103.517 81.2564 103.517 81.7792C103.517 91.353 103.549 100.959 103.517 110.533C103.484 119.159 97.7049 124.943 89.0527 124.975C66.1979 125.008 43.3431 125.008 20.4883 124.975C11.8361 124.975 6.02449 119.192 6.02449 110.533C5.99184 79.492 5.99184 48.4508 6.02449 17.4096C6.02449 8.84881 11.8035 3.03267 20.3577 3.03267C33.0911 3 45.8245 3.03267 58.5579 3C60.223 3 61.6269 3.3921 62.835 4.60107C72.4993 14.3055 82.2289 24.01 91.9259 33.7144C92.2197 33.9432 92.4483 34.2372 92.4156 34.2046Z"
        fill="#01638d"
      />
      <path
        d="M105.541 36.5243C108.218 37.8967 110.373 36.4916 112.658 34.4004C114.715 32.538 118.046 33.1915 120.07 35.2173C122.159 37.3085 122.78 40.7394 120.788 42.7652C118.568 45.0198 118.307 47.2744 118.601 50.2478C118.992 54.0054 117.36 57.3709 114.65 60.0829C104.92 69.8201 95.2235 79.5899 85.3959 89.2616C84.1226 90.5033 82.3921 91.4835 80.6944 92.0717C75.3398 93.8688 69.8873 95.4372 64.5001 97.1036C62.5411 97.7244 60.7127 97.7244 59.1782 96.1887C57.6437 94.653 57.6437 92.8232 58.2314 90.8627C59.8965 85.4714 61.431 80.0146 63.2594 74.656C63.8798 72.8588 64.9572 71.0617 66.2632 69.722C75.7643 60.0503 85.3633 50.5092 94.9623 40.9354C97.8028 38.1254 101.166 36.7204 105.541 36.5243ZM69.2996 86.0268C72.2381 85.1119 74.7195 84.4258 77.1682 83.5762C78.0497 83.2821 78.9639 82.7593 79.6169 82.1058C83.6655 78.1522 87.6488 74.1332 91.632 70.1141C97.0519 64.6901 102.472 59.2661 107.892 53.842C109.753 51.9796 110.112 50.0191 109.067 48.0912C107.434 45.1505 103.908 44.9218 101.198 47.6338C91.7953 57.0115 82.4248 66.4219 73.0543 75.8322C72.6625 76.2243 72.2381 76.6164 72.0748 77.1066C71.1606 79.9166 70.3118 82.7593 69.2996 86.0268Z"
        fill="#01638d"
      />
      <path
        d="M59.831 67.1084C58.7862 69.8204 57.7414 72.3691 56.7946 74.9504C56.5008 75.7673 56.1743 76.1921 55.2274 76.1921C48.5016 76.1594 41.7431 76.1921 35.0172 76.1594C32.34 76.1267 30.4463 74.1662 30.4463 71.6176C30.4463 69.0689 32.2747 67.0758 34.9846 67.0758C43.1144 67.0104 51.2768 67.0431 59.4066 67.0431C59.6351 67.0431 59.831 67.1084 59.831 67.1084Z"
        fill="#01638d"
      />
      <path
        d="M52.7787 97.4956C48.273 97.4956 44.1592 97.4956 40.0127 97.4956C38.119 97.4956 36.1926 97.561 34.299 97.3976C31.9808 97.1689 30.4137 95.2084 30.4463 92.8885C30.479 90.5685 32.1441 88.51 34.3969 88.4447C40.3718 88.314 46.3467 88.412 52.5502 88.412C51.6033 91.4181 51.3421 94.3262 52.7787 97.4956Z"
        fill="#01638d"
      />
    </svg>
  ),
  "receipt-icon": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 228 246"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1894_19817)">
        <path
          d="M194.732 86.631C194.732 87.3496 194.732 87.8286 194.732 88.3875C194.732 122.401 194.732 156.495 194.732 190.508C194.732 207.276 194.732 223.963 194.732 240.73C194.732 241.13 194.732 241.529 194.732 241.928C194.652 245.361 191.693 247.038 188.654 245.281C183.536 242.247 178.417 239.133 173.299 236.099C171.78 235.141 170.18 234.343 168.661 233.305C167.861 232.746 167.221 232.826 166.422 233.305C159.864 237.217 153.306 241.05 146.828 245.042C144.989 246.16 143.39 246.16 141.55 245.042C134.993 241.05 128.435 237.217 121.877 233.225C121.078 232.746 120.518 232.746 119.718 233.225C113.24 237.137 106.683 240.97 100.205 244.882C98.2855 246.08 96.5261 246.08 94.6068 244.882C88.1291 240.89 81.4914 237.057 75.0137 233.145C74.2939 232.666 73.7341 232.666 72.9344 233.145C66.3767 237.137 59.739 241.05 53.1014 244.962C51.342 246.08 49.7425 246 47.9032 244.962C41.3455 240.97 34.7878 237.137 28.2301 233.145C27.4304 232.666 26.8706 232.666 26.0709 233.145C19.4332 237.137 12.7155 241.13 6.07787 245.122C3.75868 246.559 1.11961 245.76 0.319888 243.445C0.0799719 242.806 0.0799719 242.088 0.0799719 241.449C0.0799719 237.377 0.0799719 233.385 0.0799719 229.313C0 184.36 0 139.328 0 94.2162C0 64.5141 0 34.8919 0 5.18988C0 4.55113 0 3.99222 0.0799719 3.35347C0.239916 1.75658 1.35952 0.55892 2.87899 0.159699C3.43879 1.02222e-05 4.07857 1.02147e-05 4.63837 1.02147e-05C31.6689 1.02147e-05 58.6994 1.02147e-05 85.7299 1.02147e-05C120.758 1.02147e-05 155.865 0.0798544 190.893 -0.079834C198.17 -0.079834 205.048 1.19767 211.206 5.18988C221.922 12.0565 227.68 21.9572 227.84 34.7322C228 50.5414 227.92 66.3505 227.84 82.1597C227.84 85.0341 226.321 86.5511 223.442 86.5511C214.405 86.5511 205.368 86.5511 196.331 86.5511C195.931 86.631 195.451 86.631 194.732 86.631ZM7.75728 235.381C8.15714 235.141 8.39705 235.061 8.557 234.981C13.9151 231.788 19.2732 228.674 24.5514 225.4C26.3907 224.282 28.0702 224.282 29.9095 225.4C36.4672 229.392 43.0249 233.225 49.5826 237.217C50.3023 237.616 50.7822 237.696 51.5019 237.217C58.1396 233.225 64.7773 229.313 71.4149 225.32C73.1743 224.282 74.6938 224.282 76.4532 225.32C83.0109 229.313 89.6485 233.225 96.2862 237.137C97.006 237.616 97.5658 237.616 98.3655 237.137C104.923 233.225 111.561 229.313 118.039 225.32C119.878 224.203 121.557 224.203 123.397 225.32C129.794 229.153 136.192 232.906 142.59 236.818C143.79 237.537 144.589 237.457 145.709 236.818C152.107 232.906 158.584 229.153 164.982 225.241C166.742 224.203 168.261 224.203 170.02 225.241C175.298 228.434 180.577 231.548 185.855 234.662C186.175 234.902 186.575 235.061 186.974 235.301C186.974 159.369 186.974 83.517 186.974 7.66505C127.155 7.66505 67.4963 7.66505 7.67731 7.66505C7.75728 83.5969 7.75728 159.369 7.75728 235.381ZM194.812 7.82474C194.812 31.6183 194.812 55.2522 194.812 78.9659C203.289 78.9659 211.686 78.9659 220.163 78.9659C220.163 78.5667 220.243 78.2473 220.243 77.9279C220.243 63.556 220.323 49.2639 220.243 34.8919C220.163 26.668 216.964 19.8014 210.806 14.372C206.248 10.4596 200.969 8.22396 194.812 7.82474Z"
          fill="#01638d"
        />
        <path
          d="M97.3259 219.492C76.4532 219.412 60.2989 202.724 59.5791 183.083C58.8594 162.164 75.4936 143.959 97.4858 143.959C118.359 143.959 135.233 160.966 135.153 181.965C135.073 202.645 118.039 219.572 97.3259 219.492ZM97.3259 211.827C113.96 211.827 127.475 198.333 127.475 181.725C127.475 165.118 114.04 151.624 97.4059 151.624C80.6917 151.624 67.1765 165.038 67.1765 181.725C67.1765 198.333 80.6917 211.827 97.3259 211.827Z"
          fill="#01638d"
        />
        <path
          d="M97.4057 102.36C74.3738 102.36 51.3419 102.36 28.31 102.36C25.9108 102.36 24.6312 101.482 24.1514 99.5657C23.5116 97.0906 25.0311 94.9348 27.5902 94.7751C27.9901 94.7751 28.4699 94.7751 28.9497 94.7751C65.177 94.7751 101.404 94.7751 137.632 94.7751C147.308 94.7751 156.985 94.7751 166.661 94.7751C169.54 94.7751 171.14 96.4518 170.9 99.0867C170.74 100.923 169.38 102.28 167.541 102.36C167.061 102.36 166.501 102.36 165.942 102.36C142.99 102.36 120.198 102.36 97.4057 102.36Z"
          fill="#01638d"
        />
        <path
          d="M97.3259 125.116C120.358 125.116 143.47 125.116 166.502 125.116C169.381 125.116 170.98 126.713 170.74 129.348C170.58 131.104 169.381 132.382 167.621 132.621C167.141 132.701 166.662 132.701 166.182 132.701C120.278 132.701 74.3739 132.701 28.55 132.701C25.9109 132.701 24.6314 131.903 24.1516 129.907C23.5118 127.352 25.1112 125.116 27.7503 125.116C30.8692 125.036 33.9081 125.116 37.027 125.116C57.1 125.116 77.2529 125.116 97.3259 125.116Z"
          fill="#01638d"
        />
        <path
          d="M84.6104 64.8335C84.6104 61.8793 85.49 60.3622 87.0895 59.8033C89.7286 58.925 92.0477 60.6816 92.2077 63.7157C92.4476 66.6699 94.4469 68.5862 97.4858 68.5063C100.365 68.4265 102.364 66.4304 102.444 63.6358C102.524 60.8413 100.525 58.6057 97.7257 58.3661C96.6861 58.2863 95.5665 58.2064 94.5269 57.9669C89.1687 56.7692 85.1702 52.2181 84.6903 46.7089C84.1305 41.2795 87.2494 36.0896 92.3676 33.9338C93.2473 33.5346 93.6472 33.1354 93.5672 32.1772C93.4872 31.4586 93.5672 30.74 93.5672 30.0214C93.7271 27.9455 95.2466 26.5881 97.3259 26.5881C99.4052 26.5881 101.245 27.9455 101.085 29.9416C100.925 32.4966 101.884 33.6943 104.123 34.8919C107.482 36.6485 109.402 39.8423 110.041 43.6748C110.201 44.5531 110.121 45.5112 109.961 46.3895C109.562 48.3058 108.202 49.4236 106.283 49.3437C104.443 49.3437 102.924 47.9864 102.524 46.2298C102.444 45.9903 102.444 45.6709 102.444 45.4314C102.204 42.3973 100.205 40.481 97.1659 40.5609C94.287 40.6407 92.2877 42.7167 92.2877 45.5112C92.2877 48.3856 94.4469 50.5414 97.4059 50.6212C103.724 50.8608 108.762 54.9328 109.881 60.8413C111.081 66.9893 108.042 72.5784 102.044 75.2133C101.724 75.3729 101.324 75.9319 101.324 76.3311C101.165 77.4489 101.165 78.5667 100.925 79.6845C100.525 81.6008 99.2452 82.4791 97.4059 82.4791C95.5665 82.4791 94.287 81.6008 93.8071 79.7644C93.5672 78.8063 93.4872 77.8481 93.4872 76.89C93.4872 75.9319 93.2473 75.4528 92.2877 75.0536C87.6493 72.8978 85.0902 69.2249 84.6104 64.8335Z"
          fill="#01638d"
        />
        <path
          d="M150.747 43.036C145.389 43.036 140.111 43.036 134.753 43.036C131.874 43.036 130.194 40.6407 131.074 37.926C131.554 36.3291 132.913 35.371 134.833 35.371C137.952 35.371 140.991 35.371 144.109 35.371C151.627 35.371 159.064 35.371 166.582 35.371C169.541 35.371 171.3 37.5268 170.58 40.2415C170.1 41.998 168.821 42.9562 166.742 42.9562C161.463 43.036 156.105 43.036 150.747 43.036Z"
          fill="#01638d"
        />
        <path
          d="M43.8247 43.036C38.4665 43.036 33.1884 43.036 27.8303 43.036C24.9513 43.036 23.2719 40.481 24.2315 37.7663C24.8713 36.1694 26.1509 35.4508 27.8303 35.4508C29.3497 35.4508 30.7892 35.4508 32.3087 35.4508C41.1856 35.4508 50.1425 35.4508 59.0193 35.4508C59.4992 35.4508 59.979 35.4508 60.4588 35.5306C62.6181 35.6903 63.9776 37.2074 63.9776 39.3632C63.9776 41.519 62.4581 43.1158 60.2189 43.1158C54.7009 43.036 49.2628 43.036 43.8247 43.036Z"
          fill="#01638d"
        />
        <path
          d="M150.747 66.111C156.105 66.111 161.463 66.111 166.821 66.111C169.061 66.111 170.58 67.6281 170.66 69.8637C170.74 72.0993 169.301 73.6962 166.981 73.7761C156.185 73.7761 145.309 73.7761 134.513 73.7761C132.274 73.7761 130.754 72.1792 130.754 69.9435C130.754 67.7079 132.274 66.1909 134.593 66.1909C140.031 66.111 145.389 66.111 150.747 66.111Z"
          fill="#01638d"
        />
        <path
          d="M43.9045 66.111C49.2626 66.111 54.5408 66.111 59.8989 66.111C62.7779 66.111 64.4573 68.5063 63.6576 71.1412C63.0978 72.8179 61.8182 73.6962 59.7389 73.6962C53.6611 73.6962 47.6632 73.6962 41.5853 73.6962C36.9469 73.6962 32.3885 73.6962 27.7502 73.6962C26.2307 73.6962 25.0311 73.1373 24.3114 71.7001C23.5916 70.183 23.6716 68.7458 24.7912 67.3885C25.5909 66.3505 26.7105 66.0311 27.9901 66.0311C33.3482 66.111 38.6264 66.111 43.9045 66.111Z"
          fill="#01638d"
        />
        <path
          d="M90.8482 188.512C91.0881 188.113 91.248 187.634 91.6479 187.235C98.2856 180.608 104.923 173.981 111.561 167.353C112.76 166.156 114.04 165.597 115.719 166.156C118.518 167.194 119.238 170.308 117.239 172.463C117.079 172.623 116.919 172.783 116.759 172.943C109.162 180.528 101.644 188.033 94.0471 195.618C91.6479 198.014 89.6486 198.014 87.2494 195.618C84.1305 192.504 80.9317 189.311 77.8128 186.197C76.5332 184.919 76.2933 183.482 77.013 182.045C77.7328 180.528 79.2523 179.49 80.7717 179.729C81.7314 179.889 82.691 180.368 83.3308 181.007C85.4901 183.003 87.5693 185.159 89.6486 187.235C89.9685 187.554 90.2084 187.953 90.4483 188.273C90.4483 188.432 90.6882 188.512 90.8482 188.512Z"
          fill="#01638d"
        />
      </g>
      <defs>
        <clipPath id="clip0_1894_19817">
          <rect width="228" height="246" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "import-receipt": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 228 215"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1894_19774)">
        <path
          d="M0 7.91707C0.62069 7.57285 0.551724 6.88441 0.758621 6.33365C2.34483 2.89145 4.96552 0.688441 8.82759 0.206532C9.93103 0.0688441 11.1034 0 12.2069 0C80.069 0 148 0 215.862 0C217.448 0 218.966 0.0688441 220.483 0.413064C224.69 1.51457 227.862 5.36984 227.931 9.8447C228 23.2004 228.069 36.4874 227.931 49.8431C227.862 55.0753 223.931 59.2747 218.69 59.4124C209.517 59.6878 200.276 59.619 191.103 59.5501C188.828 59.5501 188.345 60.1009 188.345 62.3727C188.345 110.977 188.276 159.581 188.138 208.184C188.138 209.286 188.069 210.387 187.862 211.489C187.448 213.417 185.655 214.793 183.724 214.793C181.724 214.793 179.793 213.279 179.517 211.282C179.379 210.319 179.379 209.355 179.379 208.391C179.448 155.656 179.517 102.922 179.517 50.1873C179.517 44.6798 179.31 39.2411 182.69 34.0778C181.862 34.0778 181.31 34.0778 180.828 34.0778C136.966 34.0778 93.1034 34.0778 49.2414 34.0778C43.7931 34.0778 39.7931 36.9004 38.4828 41.5818C38 43.2341 38 44.9552 38 46.6763C38 100.443 38 154.211 38 208.047C38 209.079 38 210.112 37.8621 211.145C37.5172 213.348 35.7241 214.862 33.5172 214.793C31.3793 214.725 29.5862 213.21 29.3103 211.007C29.1724 210.043 29.1724 209.079 29.1724 208.116C29.1724 159.512 29.1724 110.908 29.2414 62.3039C29.2414 60.032 28.7586 59.4124 26.4828 59.4813C22.2759 59.6878 18 59.2747 13.7931 59.619C7.37931 60.1009 2.48276 58.2421 0 51.9084C0 37.2446 0 22.5809 0 7.91707ZM114.138 8.81204C80.069 8.81204 46 8.81204 11.931 8.81204C9.03448 8.81204 8.82759 8.94973 8.82759 11.7723C8.82759 23.82 8.82759 35.9366 8.82759 47.9843C8.82759 50.6004 9.10345 50.8758 11.7931 50.8758C16.8966 50.8758 22 50.8069 27.1724 50.9446C28.8966 51.0135 29.5172 50.5315 29.3793 48.7416C29.1034 44.0602 29.3103 39.3788 31.7931 35.1793C32.4138 34.1467 31.7241 34.0778 30.9655 34.0778C28.6207 34.0778 26.2069 34.1467 23.8621 34.009C20.2759 33.8024 18.2069 30.5668 19.7931 27.6065C20.8966 25.4723 22.8966 25.1281 25.1034 25.1281C84 25.1281 142.966 25.1281 201.862 25.1281C202.207 25.1281 202.621 25.1281 202.965 25.1281C205.793 25.3346 207.586 27.0557 207.586 29.5341C207.586 32.0125 205.793 33.8024 202.965 33.9401C201.517 34.009 200 33.9401 198.483 34.009C193.586 34.2155 189.724 37.4512 188.69 42.2014C188.207 44.4044 188.552 46.6074 188.345 48.8104C188.207 50.3939 188.759 50.8069 190.345 50.8069C198.897 50.7381 207.379 50.8069 215.931 50.7381C218.965 50.7381 219.103 50.6004 219.103 47.4336C219.103 35.6612 219.103 23.8889 219.103 12.1166C219.103 8.67435 219.103 8.67435 215.586 8.67435C181.793 8.81204 147.931 8.81204 114.138 8.81204Z"
          fill="#244061"
        />
        <path
          d="M86.8275 74.4204C94.7585 74.4204 102.69 74.3516 110.621 74.4204C114.345 74.4204 116.414 77.0365 115.379 80.1345C114.827 81.7179 113.793 82.7505 112.069 83.0259C111.172 83.1636 110.276 83.2324 109.448 83.2324C94.1378 83.2324 78.8965 83.2324 63.5861 83.2324C62.8275 83.2324 62.0689 83.2324 61.3792 83.0948C58.8275 82.7505 57.3102 81.0294 57.3792 78.6199C57.4482 76.2792 59.1033 74.4892 61.724 74.4204C67.0344 74.2827 72.4137 74.3516 77.724 74.3516C80.7585 74.4204 83.793 74.4204 86.8275 74.4204Z"
          fill="#244061"
        />
        <path
          d="M86.4827 108.911C78.4827 108.911 70.4827 108.911 62.4137 108.911C59.3792 108.911 57.5861 107.466 57.3792 104.987C57.1723 102.646 58.4827 100.788 60.8275 100.306C61.5861 100.168 62.4137 100.099 63.2413 100.099C78.6896 100.099 94.0689 100.099 109.517 100.099C109.724 100.099 109.931 100.099 110.207 100.099C113.655 100.168 115.724 101.958 115.655 104.643C115.586 107.259 113.586 108.911 110.207 108.911C102.345 108.911 94.4137 108.911 86.4827 108.911Z"
          fill="#244061"
        />
        <path
          d="M86.4828 134.59C78.4139 134.59 70.3449 134.59 62.207 134.59C60.207 134.59 58.5518 133.833 57.7242 131.974C56.9656 130.253 57.3104 128.601 58.5518 127.224C59.5863 126.122 60.9656 125.778 62.4139 125.778C78.4828 125.778 94.6208 125.709 110.69 125.778C113.793 125.778 115.793 127.775 115.724 130.253C115.655 132.8 113.655 134.521 110.552 134.521C102.483 134.659 94.4828 134.59 86.4828 134.59Z"
          fill="#244061"
        />
        <path
          d="M142.552 83.2325C138.69 83.2325 134.828 83.3013 130.965 83.2325C127.379 83.1636 125.31 80.5475 126.207 77.6561C126.828 75.7973 128.069 74.5581 130.069 74.5581C138.414 74.4893 146.828 74.4893 155.172 74.5581C157.655 74.5581 159.379 76.5546 159.379 78.8953C159.379 81.0983 157.793 83.0259 155.379 83.1636C151.103 83.3701 146.828 83.2325 142.483 83.2325C142.552 83.1636 142.552 83.2325 142.552 83.2325Z"
          fill="#244061"
        />
        <path
          d="M142.621 108.911C138.758 108.911 134.896 108.911 131.034 108.911C128 108.911 126.138 107.259 126 104.712C125.862 102.165 127.862 100.168 130.896 100.099C138.758 100.03 146.621 100.03 154.483 100.099C157.586 100.099 159.517 102.096 159.379 104.643C159.31 107.259 157.379 108.842 154.138 108.842C150.345 108.911 146.483 108.911 142.621 108.911Z"
          fill="#244061"
        />
        <path
          d="M142.621 134.59C138.759 134.59 134.897 134.59 131.034 134.59C128.069 134.59 126.138 132.869 126.069 130.322C126 127.843 127.931 125.847 130.759 125.778C138.759 125.709 146.759 125.709 154.759 125.778C157.655 125.847 159.517 127.912 159.379 130.391C159.241 132.938 157.379 134.521 154.345 134.59C150.414 134.659 146.552 134.59 142.621 134.59Z"
          fill="#244061"
        />
        <path
          d="M53.1725 206.119C54.9656 206.119 56.7587 206.05 58.4828 206.119C61.1035 206.188 62.9656 207.909 63.1035 210.25C63.2414 212.453 61.5863 214.518 59.1035 214.725C55.1035 215.069 51.1035 215.069 47.1035 214.725C44.5518 214.449 43.0346 212.522 43.1725 210.25C43.3104 207.909 45.0346 206.326 47.5863 206.119C47.7242 206.119 47.8621 206.119 48.0001 206.119C49.7242 206.119 51.4483 206.119 53.1725 206.119Z"
          fill="#244061"
        />
        <path
          d="M80.8275 206.119C82.6896 206.119 84.5517 206.05 86.4137 206.119C88.8965 206.257 90.6896 207.978 90.8275 210.25C90.9655 212.384 89.3793 214.38 86.9655 214.656C82.8275 215.069 78.6896 215.138 74.5517 214.656C72.2068 214.38 70.6896 212.384 70.8275 210.181C70.9655 207.978 72.6206 206.257 75.0344 206.119C76.9655 206.05 78.8965 206.119 80.8275 206.119Z"
          fill="#244061"
        />
        <path
          d="M108.414 206.119C110.276 206.119 112.138 206.05 114 206.119C116.483 206.257 118.276 208.047 118.414 210.319C118.552 212.453 116.965 214.449 114.552 214.725C110.414 215.138 106.276 215.207 102.138 214.725C99.793 214.449 98.2758 212.453 98.4137 210.25C98.5516 208.047 100.276 206.326 102.621 206.188C104.552 206.05 106.483 206.119 108.414 206.119Z"
          fill="#244061"
        />
        <path
          d="M163.724 206.119C165.586 206.119 167.448 206.05 169.31 206.119C171.862 206.257 173.586 207.909 173.724 210.25C173.862 212.59 172.345 214.518 169.793 214.725C165.793 215.069 161.793 215.069 157.793 214.725C155.31 214.518 153.655 212.453 153.793 210.25C153.931 207.909 155.793 206.188 158.414 206.119C160.138 206.05 161.931 206.119 163.724 206.119Z"
          fill="#244061"
        />
        <path
          d="M136.069 206.119C137.931 206.119 139.793 206.05 141.655 206.119C144.138 206.257 145.931 208.047 146 210.319C146.069 212.453 144.552 214.449 142.138 214.725C138 215.138 133.862 215.207 129.724 214.725C127.379 214.449 125.862 212.384 126 210.25C126.207 208.047 127.862 206.326 130.276 206.188C132.276 206.05 134.207 206.119 136.069 206.119Z"
          fill="#244061"
        />
        <path
          d="M114.138 8.81201C148 8.81201 181.793 8.81201 215.655 8.81201C219.172 8.81201 219.172 8.81201 219.172 12.2542C219.172 24.0265 219.172 35.7989 219.172 47.5712C219.172 50.738 219.034 50.8757 216 50.8757C207.448 50.8757 198.965 50.8069 190.414 50.9446C188.828 50.9446 188.345 50.5315 188.414 48.9481C188.621 46.7451 188.276 44.5421 188.759 42.3391C189.862 37.5888 193.655 34.3532 198.552 34.1466C200 34.0778 201.517 34.1466 203.034 34.0778C205.862 33.9401 207.655 32.1501 207.655 29.6718C207.655 27.1245 205.862 25.4034 203.034 25.2657C202.69 25.2657 202.276 25.2657 201.931 25.2657C143.034 25.2657 84.0689 25.2657 25.1723 25.2657C22.9654 25.2657 20.9654 25.61 19.862 27.7441C18.3448 30.6356 20.3448 33.8713 23.931 34.1466C26.2758 34.2843 28.6896 34.2155 31.0344 34.2155C31.793 34.2155 32.4827 34.2843 31.862 35.317C29.3792 39.5165 29.1723 44.1979 29.4482 48.8793C29.5172 50.6692 28.9654 51.1511 27.2413 51.0823C22.1379 50.9446 17.0344 51.0823 11.862 51.0134C9.17235 51.0134 8.89648 50.738 8.89648 48.122C8.89648 36.0743 8.89648 23.9577 8.89648 11.91C8.89648 9.08739 9.03442 8.9497 11.9999 8.9497C45.9999 8.81201 80.0689 8.81201 114.138 8.81201Z"
          fill="#B8C4F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1894_19774">
          <rect width="228" height="215" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "up-receipt": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 229 229"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1984_19774)">
        <path
          d="M24.1949 156.738C24.1949 155.261 24.1949 154.125 24.1949 152.989C24.1949 108.734 24.1949 64.5359 24.1949 20.2811C24.1949 7.66931 31.7488 0 44.3006 0C99.1652 0 154.03 0 208.838 0C221.219 0 228.943 7.72612 228.943 20.0538C228.943 77.2612 228.943 134.469 228.943 191.733C228.943 210.707 217.641 224.796 199.807 228.318C197.138 228.83 194.411 229 191.685 229C140.228 229.057 88.7716 229.057 37.2579 229C18.4018 229 4.20288 217.638 0.738347 199.8C0.227187 197.3 0.113595 194.744 0.0567999 192.244C-0.0567914 186.961 4.2133e-06 181.678 4.2133e-06 176.451C0.0567999 154.182 -2.10143 156.908 19.5377 156.795C20.9576 156.738 22.3775 156.738 24.1949 156.738ZM36.1788 156.738C37.8259 156.738 39.0186 156.738 40.2113 156.738C80.593 156.738 120.918 156.738 161.3 156.738C166.922 156.738 168.74 158.556 168.74 164.18C168.74 173.951 168.626 183.779 168.797 193.551C169.081 208.719 183.507 219.626 198.274 216.275C207.02 214.286 217.016 205.765 216.959 191.278C216.789 134.185 216.903 77.034 216.903 19.9402C216.903 18.9744 216.903 18.0655 216.789 17.0997C216.448 14.3161 214.631 12.4981 211.791 12.2141C210.769 12.1005 209.746 12.1005 208.667 12.1005C153.916 12.1005 99.1652 12.1005 44.4142 12.1005C43.3919 12.1005 42.3127 12.1005 41.2904 12.2141C38.6778 12.4981 36.974 13.9752 36.4628 16.5884C36.2356 17.6678 36.1788 18.804 36.1788 19.9402C36.1788 64.4222 36.1788 108.961 36.1788 153.443C36.1788 154.409 36.1788 155.318 36.1788 156.738ZM156.699 168.895C108.309 168.895 60.3738 168.895 12.1543 168.895C12.1543 176.565 12.1543 184.064 12.1543 191.562C12.2111 206.731 22.2639 216.9 37.4283 216.9C79.2867 216.956 121.145 216.9 162.947 216.9C163.799 216.9 164.707 216.786 165.559 216.729C163.685 213.832 161.811 211.275 160.277 208.492C157.494 203.208 156.586 197.527 156.642 191.562C156.756 184.064 156.699 176.565 156.699 168.895Z"
          fill="#01638d"
        />
        <path
          d="M119.328 68.6261C115.011 72.9437 111.319 76.6931 107.628 80.3858C103.766 84.2488 100.471 84.7601 97.6317 81.9764C94.7919 79.1359 95.3031 75.841 99.1084 72.0347C106.037 65.1039 112.966 58.1732 119.839 51.2992C120.236 50.9015 120.634 50.447 121.031 50.1062C125.348 46.4704 128.585 46.6408 132.504 50.7311C139.547 58.1732 146.59 65.6152 153.689 73.0005C155.45 74.8184 156.415 76.8067 155.677 79.3632C154.484 83.5103 147.612 84.8737 144.147 81.522C140.058 77.5453 136.082 73.3982 131.311 69.4215C131.311 70.3872 131.311 71.2962 131.311 72.262C131.311 86.0099 131.311 99.7011 131.311 113.449C131.311 117.71 129.664 119.869 126.257 120.437C122.622 121.005 119.725 118.846 119.384 115.153C119.271 114.131 119.271 113.108 119.271 112.029C119.271 98.8489 119.271 85.6691 119.271 72.546C119.328 71.5234 119.328 70.5577 119.328 68.6261Z"
          fill="#01638d"
        />
      </g>
      <defs>
        <clipPath id="clip0_1984_19774">
          <rect width="229" height="229" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "view-receipt": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 221 221"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1985_19808)">
        <path
          d="M171.39 221C167.822 220.137 164.196 219.561 160.801 218.353C148.887 214.209 140.197 206.267 134.787 194.929C133.233 191.648 129.953 190.9 127.363 189.001C127.075 188.828 126.212 189.289 125.694 189.634C121.205 192.454 116.716 195.274 112.284 198.267C109.982 199.763 107.968 199.763 105.723 198.267C101.464 195.447 97.0904 192.799 92.8891 189.922C91.5078 189.001 90.587 188.886 89.0906 189.864C84.8318 192.799 80.4003 195.447 76.0839 198.324C73.8969 199.763 71.9401 199.821 69.6956 198.324C65.2641 195.389 60.7175 192.569 56.2859 189.634C55.1349 188.886 54.3292 188.943 53.2357 189.692C48.8042 192.627 44.2576 195.447 39.826 198.324C38.157 199.418 36.4305 199.936 34.5888 198.9C32.8047 197.922 32.4018 196.253 32.4018 194.296C32.4018 174.44 32.4018 154.585 32.4018 134.729C32.4018 131.391 34.0708 129.435 36.7758 129.492C39.4232 129.55 41.0346 131.507 41.0346 134.845C41.0346 151.362 41.0346 167.937 41.0346 184.454C41.0346 185.26 41.0346 186.008 41.0346 187.217C44.4302 185.03 47.6531 183.188 50.6458 181.001C53.5234 178.929 55.9406 178.872 58.8758 180.944C62.962 183.879 67.3359 186.411 71.5372 189.174C72.5156 189.807 73.2063 189.864 74.1846 189.174C78.6737 186.181 83.2779 183.361 87.7669 180.368C89.9539 178.872 91.9682 178.929 94.1552 180.368C98.4141 183.188 102.788 185.836 106.989 188.713C108.428 189.692 109.464 189.807 110.96 188.771C114.816 186.123 118.788 183.706 122.701 181.174C126.499 178.757 126.499 178.699 130.528 180.253C129.55 166.728 133.291 154.758 142.557 144.801C151.765 134.902 163.333 130.298 176.973 130.24C176.973 129.492 176.973 128.859 176.973 128.226C176.973 96.4573 176.973 64.631 176.973 32.8622C176.973 21.2943 170.009 11.9708 159.477 9.32344C157.635 8.86302 155.621 8.63281 153.722 8.63281C115.622 8.63281 77.4651 8.63281 39.3656 8.63281C38.7901 8.63281 38.2721 8.63281 37.3513 8.63281C37.9268 9.6112 38.5023 10.3018 38.675 11.1076C39.5383 14.2154 40.862 17.3232 40.9195 20.431C41.0922 45.0057 41.0346 69.638 41.0346 94.2128C41.0346 97.3206 39.2505 99.2773 36.6607 99.2773C34.1284 99.2198 32.4594 97.3206 32.4018 94.3279C32.4018 93.8099 32.4018 93.3495 32.4018 92.8315C32.4018 82.4146 32.4018 71.9977 32.4018 61.5232C32.4018 60.7174 32.4018 59.9693 32.4018 58.9333C31.4234 58.9333 30.5602 58.9333 29.6969 58.9333C21.6396 58.9333 13.5823 58.8758 5.525 58.9333C2.93516 58.9333 1.03594 58.1276 0 55.7104C0 43.049 0 30.3875 0 17.726C0.172656 17.2656 0.345313 16.8052 0.460417 16.3448C2.24453 8.92057 6.67604 3.79844 13.8125 1.15104C15.0786 0.690625 16.4023 0.345313 17.6685 0C64.4583 0 111.248 0 157.98 0C159.419 0.345313 160.858 0.690625 162.297 1.09349C176.109 4.94948 185.548 17.6109 185.605 32.5169C185.663 64.5734 185.605 96.6875 185.605 128.744C185.605 129.665 185.605 130.586 185.605 131.391C186.469 131.622 186.987 131.794 187.562 131.967C207.475 137.549 221.058 155.333 221 175.822C220.942 196.253 207.245 214.094 187.332 219.504C184.915 220.137 182.44 220.54 179.965 221.058C177.145 221 174.268 221 171.39 221ZM175.707 138.988C155.506 138.988 139.046 155.448 138.988 175.591C138.988 195.792 155.391 212.31 175.534 212.367C195.85 212.425 212.367 195.907 212.31 175.649C212.367 155.448 195.85 138.988 175.707 138.988ZM32.3443 50.1854C32.3443 49.3221 32.3443 48.6891 32.3443 48.056C32.3443 39.0779 32.3443 30.0997 32.3443 21.1216C32.3443 13.9852 27.2797 8.69036 20.5461 8.63281C13.7549 8.57526 8.63281 13.9276 8.63281 21.1792C8.63281 30.1573 8.63281 39.1354 8.63281 48.1135C8.63281 48.8042 8.69036 49.4948 8.74792 50.1854C16.6901 50.1854 24.3445 50.1854 32.3443 50.1854Z"
          fill="black"
        />
        <path
          d="M170.236 182.574C170.476 182.175 170.636 181.696 171.036 181.297C177.673 174.67 184.311 168.042 190.949 161.415C192.148 160.218 193.428 159.659 195.107 160.218C197.906 161.256 198.626 164.37 196.627 166.525C196.467 166.685 196.307 166.845 196.147 167.005C188.549 174.59 181.032 182.095 173.435 189.68C171.036 192.076 169.036 192.076 166.637 189.68C163.518 186.566 160.319 183.373 157.2 180.259C155.921 178.981 155.681 177.544 156.401 176.107C157.12 174.59 158.64 173.552 160.159 173.791C161.119 173.951 162.079 174.43 162.719 175.069C164.878 177.065 166.957 179.221 169.036 181.297C169.356 181.616 169.596 182.015 169.836 182.335C169.836 182.494 170.076 182.574 170.236 182.574Z"
          fill="black"
        />
        <path
          d="M109.004 23.769C125.118 23.769 141.233 23.769 157.29 23.769C161.549 23.769 162.93 25.2078 162.93 29.4667C162.93 37.8693 162.93 46.2719 162.93 54.6745C162.93 59.0484 161.491 60.4297 157.06 60.4297C125.003 60.4297 92.9466 60.4297 60.8901 60.4297C56.3435 60.4297 55.0198 59.0484 55.0198 54.5018C55.0198 46.2143 55.0198 37.9844 55.0198 29.6969C55.0198 25.0927 56.3435 23.769 60.8901 23.769C76.8896 23.7115 92.9466 23.769 109.004 23.769ZM63.7677 51.6242C93.9825 51.6242 124.082 51.6242 154.124 51.6242C154.124 45.1208 154.124 38.8477 154.124 32.4594C123.91 32.4594 93.925 32.4594 63.7677 32.4594C63.7677 38.9052 63.7677 45.2935 63.7677 51.6242Z"
          fill="black"
        />
        <path
          d="M62.962 112.802C62.962 109.349 65.6094 107.335 68.3719 108.14C69.2927 108.371 70.0985 108.889 71.0193 109.119C72.4581 109.464 73.6667 109.004 74.2422 107.622C74.8753 106.184 74.4149 104.86 73.0336 104.112C71.8826 103.479 70.674 103.133 69.4654 102.615C65.3792 100.889 62.7894 97.8961 62.2138 93.4646C61.6383 88.8604 63.3649 85.2346 67.1633 82.4721C67.7388 82.0693 68.1992 81.1484 68.2568 80.4578C68.5446 77.5227 69.9834 75.681 72.4006 75.5659C74.8753 75.3932 76.4292 77.0622 77.0047 80.1701C77.0623 80.688 77.5802 81.2635 78.0407 81.5513C78.7313 82.0117 79.6521 82.1844 80.3427 82.6448C82.242 83.7958 82.875 86.1555 81.9542 88.1122C81.0909 89.9539 78.9615 90.9323 76.8896 90.3568C76.0263 90.069 75.1631 89.6086 74.2422 89.3784C72.8034 89.0331 71.5948 89.4935 71.0193 90.8747C70.4438 92.3135 70.8466 93.6372 72.2854 94.3279C73.6091 95.0185 75.0479 95.4789 76.4292 96.112C84.6016 99.9104 85.6375 110.615 78.2709 115.795C77.2349 116.543 76.9472 117.234 76.9472 118.442C76.8896 121.032 75.2782 122.816 72.9761 122.931C70.6164 123.104 68.5446 121.435 68.4295 118.787C68.3719 117.349 67.6237 116.946 66.5878 116.601C64.4008 115.91 62.962 114.644 62.962 112.802Z"
          fill="black"
        />
        <path
          d="M126.672 82.0117C118.385 82.0117 110.155 82.0693 101.867 82.0117C98.2414 82.0117 95.8817 78.501 97.8385 75.681C98.5867 74.5875 100.371 73.494 101.694 73.494C118.327 73.3214 134.902 73.3789 151.535 73.4365C154.182 73.4365 155.966 75.2781 155.966 77.7529C155.966 80.2852 154.182 82.0693 151.362 82.0693C143.074 82.0117 134.844 82.0117 126.672 82.0117Z"
          fill="black"
        />
        <path
          d="M126.672 103.594C118.385 103.594 110.155 103.651 101.867 103.594C98.1838 103.594 95.8817 100.083 97.781 97.3206C98.5291 96.2271 100.313 95.1336 101.579 95.076C118.212 94.9034 134.787 94.9609 151.42 95.0185C154.067 95.0185 155.851 96.8026 155.851 99.2773C155.851 101.81 154.067 103.594 151.247 103.594C143.074 103.594 134.845 103.594 126.672 103.594Z"
          fill="black"
        />
        <path
          d="M126.672 125.176C118.385 125.176 110.155 125.233 101.867 125.176C98.2991 125.176 96.1121 122.01 97.6084 119.018C98.4142 117.406 99.7954 116.543 101.58 116.543C118.212 116.543 134.787 116.543 151.42 116.543C154.125 116.543 155.851 118.327 155.851 120.802C155.851 123.334 154.067 125.118 151.247 125.118C143.075 125.176 134.902 125.176 126.672 125.176Z"
          fill="black"
        />
        <path
          d="M36.7183 110.097C39.0204 110.097 40.9772 111.996 40.9772 114.298C41.0347 116.658 39.0204 118.672 36.6608 118.672C34.2436 118.672 32.3444 116.601 32.4019 114.241C32.4595 111.939 34.4162 110.04 36.7183 110.097Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1985_19808">
          <rect width="221" height="221" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "refund-icon": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 226 262"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1985_19819)">
        <path
          d="M47.6689 130.963C47.6689 94.8736 76.7463 65.6302 112.814 65.5558C149.254 65.4814 178.554 94.7992 178.48 131.26C178.405 167.275 149.031 196.519 113.112 196.37C76.7463 196.37 47.6689 167.201 47.6689 130.963ZM113.037 77.4615C83.1418 77.6103 59.4189 101.571 59.4932 131.558C59.5676 160.727 83.8111 184.613 113.26 184.613C142.486 184.538 166.655 160.355 166.581 131.037C166.507 101.422 142.486 77.3127 113.037 77.4615Z"
          fill="#01638d"
        />
        <path
          d="M112.591 231.343C109.839 228.664 106.939 226.06 104.262 223.306C103.295 222.339 102.403 221.149 101.956 219.884C101.064 217.428 102.18 214.675 104.262 213.261C106.344 211.847 109.244 211.996 111.252 213.633C112.442 214.675 113.558 215.791 114.673 216.907C119.879 222.116 125.01 227.325 130.141 232.533C133.042 235.51 133.116 238.784 130.29 241.611C124.266 247.713 118.243 253.74 112.07 259.693C109.244 262.446 105.824 262.521 103.369 260.065C100.841 257.61 100.99 254.038 103.816 251.136C105.972 248.904 108.278 246.671 110.955 244.067C106.79 243.695 103.146 243.397 99.5024 243.025C53.172 237.965 13.6833 203.513 3.34639 157.751C-6.6931 113.179 5.87485 75.378 39.8604 44.7952C40.3809 44.2744 40.9759 43.8279 41.5708 43.3814C44.9173 40.7771 48.4125 40.8515 50.7179 43.6791C52.9489 46.4323 52.2796 49.7063 49.2306 52.5339C44.7686 56.7009 40.1578 60.7935 36.142 65.407C-0.892509 107.821 5.35428 174.642 49.4537 209.689C66.9298 223.604 86.7857 231.12 109.17 232.087C110.137 232.161 111.104 232.087 112.07 232.087C112.293 231.864 112.442 231.566 112.591 231.343Z"
          fill="#01638d"
        />
        <path
          d="M113.409 30.7316C116.458 33.6336 119.656 36.4612 122.631 39.4377C124.638 41.5212 124.936 44.3488 123.597 46.6555C122.184 49.0366 120.028 50.004 117.425 49.4831C116.161 49.1855 114.822 48.4413 113.855 47.474C107.757 41.4467 101.734 35.4195 95.7843 29.3178C92.8096 26.267 92.884 23.0673 95.8586 20.0165C101.734 14.0636 107.683 8.18517 113.632 2.30673C116.607 -0.595288 119.953 -0.744109 122.556 1.78585C125.01 4.24141 124.862 7.81312 122.11 10.7151C119.953 12.9475 117.648 15.1798 115.045 17.7841C119.135 18.1562 122.705 18.3794 126.2 18.8259C176.249 25.002 216.332 62.505 224.215 111.988C230.983 154.551 217.374 190.194 184.727 218.395C184.504 218.544 184.28 218.767 184.057 218.916C180.934 221.372 177.364 221.149 175.133 218.321C172.977 215.642 173.646 212.368 176.398 209.689C181.38 204.853 186.735 200.314 191.122 194.882C240.13 134.758 206.442 44.6464 130.142 31.3269C124.787 30.434 119.358 30.2107 114.004 29.6154C113.781 29.9875 113.632 30.3596 113.409 30.7316Z"
          fill="#01638d"
        />
        <path
          d="M118.987 161.248C118.987 162.885 119.061 164.745 118.987 166.606C118.763 170.252 116.235 172.633 112.888 172.558C109.691 172.484 106.865 170.103 107.162 166.68C107.534 162.29 106.047 160.206 101.808 159.239C99.5769 158.718 97.4946 157.155 95.4867 155.816C92.1402 153.584 91.3222 150.012 93.2557 147.184C95.1893 144.282 98.7588 143.761 102.031 145.994C105.749 148.524 109.765 150.235 114.301 149.342C116.309 148.97 118.392 148.077 120.028 146.887C122.705 144.952 122.482 142.348 119.805 140.487C118.54 139.594 117.053 138.925 115.64 138.329C111.252 136.395 106.642 134.758 102.328 132.674C95.8586 129.475 91.694 124.489 92.289 116.825C92.8095 109.384 97.4202 104.77 103.965 102.24C106.642 101.199 107.385 99.8591 107.014 97.4036C106.939 96.9571 107.014 96.5107 107.014 95.9898C107.162 92.1204 109.468 89.5905 112.888 89.516C116.384 89.4416 118.838 92.046 118.987 96.0642C119.061 97.5524 118.987 99.0406 118.987 100.008C123.077 102.091 127.018 103.803 130.588 105.961C134.009 108.044 134.678 111.69 132.744 114.592C130.736 117.494 127.39 118.015 123.895 115.709C119.656 112.881 115.194 111.17 109.988 112.583C109.468 112.732 108.798 112.807 108.427 113.104C106.939 114.592 104.559 116.081 104.336 117.792C104.188 119.131 106.419 121.289 108.129 122.257C111.327 124.043 114.971 125.159 118.317 126.647C120.846 127.763 123.449 128.805 125.828 130.293C135.942 136.692 136.537 149.342 127.018 156.709C124.787 158.42 121.961 159.536 118.987 161.248Z"
          fill="#01638d"
        />
      </g>
      <defs>
        <clipPath id="clip0_1985_19819">
          <rect width="226" height="262" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "refund-confirm": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 117.217C14 81.7394 14 46.2618 14 10.7613C14.0228 10.6693 14.0455 10.5543 14.0683 10.4623C14.5916 7.42732 16.321 5.38098 19.2108 4.3693C19.6887 4.20835 20.1893 4.13938 20.6899 4.02441C47.5633 4.02441 74.4367 4.02441 101.31 4.02441C101.401 4.04741 101.492 4.0704 101.583 4.09339C104.632 4.53025 107.09 6.80652 107.795 9.84155C107.863 10.1634 107.932 10.5083 108 10.8532C108 46.3078 108 81.7395 108 117.194C107.977 117.286 107.954 117.401 107.932 117.493C107.477 120.321 105.952 122.344 103.335 123.448C102.698 123.724 101.993 123.816 101.31 124C74.4367 124 47.5633 124 20.6899 124C20.5989 123.977 20.5079 123.954 20.4168 123.931C17.436 123.425 15.4336 121.747 14.3868 118.873C14.2048 118.344 14.1365 117.769 14 117.217ZM18.9605 63.9892C18.9605 81.4176 18.9605 98.846 18.9605 116.274C18.9605 117.93 19.9845 118.965 21.6229 118.965C47.8591 118.965 74.1181 118.965 100.354 118.965C101.993 118.965 103.039 117.93 103.039 116.251C103.039 81.3946 103.039 46.5608 103.039 11.7039C103.039 10.0715 101.993 9.01381 100.377 9.01381C74.1181 9.01381 47.8591 9.01381 21.6229 9.01381C20.0073 9.01381 18.9605 10.0715 18.9605 11.681C18.9605 29.1324 18.9605 46.5607 18.9605 63.9892Z"
        fill="#01638d"
      />
      <path
        d="M36.4572 44.8121C35.6608 45.6168 34.9326 46.3756 34.2045 47.1114C33.9542 47.3643 33.7266 47.5942 33.4763 47.8471C32.4751 48.8128 30.9505 48.8128 29.9948 47.8701C29.0164 46.9044 28.9936 45.3179 29.9721 44.3293C32.3158 41.938 34.6596 39.5698 37.0033 37.2245C38.0045 36.2129 39.5063 36.2818 40.5531 37.3165C41.8956 38.6731 43.2381 40.0296 44.5806 41.3862C45.5591 42.3749 46.5148 43.3406 47.4933 44.3293C48.722 45.5938 48.3352 47.6632 46.7424 48.376C45.7866 48.8128 44.7172 48.5829 43.9208 47.8011C43.2381 47.1343 42.5782 46.4446 41.9183 45.7778C41.8501 45.7088 41.7818 45.6398 41.6453 45.5249C41.6453 45.6628 41.6453 45.7318 41.668 45.8008C42.874 51.0201 45.6274 55.1588 50.019 58.1478C53.8191 60.746 58.0515 61.8496 62.6252 61.4358C68.8828 60.8609 73.775 57.8949 77.3475 52.6986C77.5523 52.3997 77.7571 52.0778 77.9392 51.7559C78.6901 50.5373 80.1919 50.1464 81.3524 50.8592C82.5584 51.5949 82.9225 53.1124 82.1716 54.377C80.3057 57.481 77.8937 60.0792 74.9355 62.1255C71.9091 64.2179 68.6097 65.6204 64.9917 66.1952C57.1185 67.3908 50.1783 65.3215 44.2621 59.9412C40.189 56.2164 37.6859 51.5719 36.6392 46.1227C36.5937 45.6858 36.5255 45.2949 36.4572 44.8121Z"
        fill="#01638d"
      />
      <path
        d="M85.5177 38.1675C85.6315 38.0525 85.6998 37.9835 85.7908 37.9145C86.6782 37.0178 87.5429 36.1211 88.4303 35.2474C89.7274 33.9598 91.7753 34.3047 92.5034 35.9372C92.9358 36.9029 92.731 37.9835 91.9573 38.7653C89.7729 40.9726 87.6112 43.1799 85.4267 45.3642C85.3129 45.4791 85.1992 45.5941 85.1081 45.709C84.0159 46.8357 82.5141 46.8357 81.3991 45.709C79.3739 43.6627 77.3715 41.6394 75.3463 39.593C75.0733 39.3171 74.7775 39.0182 74.5044 38.7423C73.5487 37.7306 73.5487 36.1901 74.5044 35.2244C75.4374 34.2587 76.9619 34.2127 77.9631 35.1554C78.6913 35.8452 79.3739 36.558 80.0566 37.2708C80.1476 37.3627 80.1704 37.4777 80.2386 37.5927C80.2841 37.5467 80.3296 37.5237 80.3979 37.4777C80.2159 36.7879 80.0566 36.0751 79.829 35.4084C77.235 28.0507 72.1834 23.4062 64.5833 21.9117C57.9844 20.6241 52.182 22.5325 47.2669 27.177C46.1064 28.2806 45.1507 29.5222 44.2861 30.8788C43.7172 31.7755 42.6932 32.1894 41.692 31.9595C40.6908 31.7295 39.9399 30.9248 39.7806 29.8671C39.6896 29.2463 39.8261 28.6485 40.1447 28.1427C43.4441 23.0383 47.9268 19.4745 53.6838 17.6581C58.0982 16.2555 62.5809 16.1635 67.0636 17.2902C71.569 18.4398 75.4601 20.7161 78.714 24.096C81.877 27.3839 83.9932 31.2697 85.0626 35.7302C85.1536 36.1211 85.2447 36.512 85.3129 36.9259C85.3812 37.3167 85.4267 37.7076 85.5177 38.1675Z"
        fill="#01638d"
      />
      <path
        d="M60.99 79.002C70.8656 79.002 80.7412 79.002 90.594 79.002C91.8682 79.002 92.8695 79.8297 93.097 81.0253C93.3701 82.5198 92.3233 83.8764 90.8215 83.9913C90.7078 83.9913 90.594 83.9913 90.4802 83.9913C70.8201 83.9913 51.16 83.9913 31.4998 83.9913C30.5214 83.9913 29.7477 83.6465 29.2243 82.8187C28.7237 82.037 28.701 81.1863 29.1106 80.3585C29.5429 79.5078 30.2483 79.0709 31.1813 79.002C31.295 79.002 31.4088 79.002 31.5226 79.002C41.3526 79.002 51.16 79.002 60.99 79.002Z"
        fill="#01638d"
      />
      <path
        d="M61.0121 91.4873C70.8422 91.4873 80.695 91.4873 90.525 91.4873C91.8448 91.4873 92.846 92.292 93.0736 93.5336C93.3466 95.0052 92.2772 96.4077 90.7981 96.4997C90.6843 96.4997 90.5933 96.4997 90.4795 96.4997C70.7966 96.4997 51.1138 96.4997 31.4536 96.4997C30.1111 96.4997 29.1099 95.695 28.8596 94.4534C28.5865 92.9818 29.656 91.5793 31.1351 91.4873C31.2716 91.4873 31.4081 91.4873 31.5446 91.4873C41.3747 91.4873 51.2048 91.4873 61.0121 91.4873Z"
        fill="#01638d"
      />
      <path
        d="M58.5086 54.7452C58.5086 54.3773 58.6224 53.9404 58.4631 53.6645C58.3266 53.4116 57.8942 53.3426 57.5757 53.1817C56.0056 52.3539 54.8451 51.1123 54.1625 49.4569C53.7301 48.4452 53.9122 47.5025 54.6631 46.7207C55.414 45.939 56.3242 45.755 57.3254 46.1459C57.9853 46.3758 58.4176 46.8587 58.7134 47.5025C59.214 48.6061 60.2607 49.158 61.3757 48.974C62.6272 48.7671 63.5374 47.6174 63.4464 46.3758C63.3554 45.0653 62.3087 44.0536 61.0116 44.0306C58.5996 43.9846 56.6427 43.0419 55.1409 41.1335C52.6379 37.9605 53.1612 33.1781 56.3469 30.6949C56.9385 30.235 57.6212 29.9131 58.2811 29.5453C58.4631 29.4533 58.5086 29.3613 58.5086 29.1774C58.5086 28.6255 58.5086 28.0967 58.5086 27.5449C58.5086 26.1653 59.5781 25.0847 60.9206 25.0387C62.2632 25.0157 63.4009 26.0734 63.4464 27.4529C63.4692 28.0047 63.4692 28.5796 63.4464 29.1314C63.4464 29.3613 63.5147 29.4533 63.7195 29.5453C65.0847 30.0971 66.1997 30.9708 67.0417 32.1894C67.8836 33.385 67.6333 34.9485 66.4728 35.7763C65.3578 36.558 63.8332 36.2591 63.0141 35.0865C62.3087 34.0978 61.0799 33.7299 60.0104 34.2128C58.941 34.6726 58.3493 35.8222 58.5769 36.9719C58.8044 38.1445 59.7829 38.9492 60.9889 38.9952C64.6069 39.0872 67.5195 41.4784 68.2477 44.9733C68.9986 48.5142 67.0644 52.124 63.7422 53.4576C63.5374 53.5495 63.4464 53.6415 63.4464 53.8944C63.4692 54.4233 63.4692 54.9291 63.4464 55.4579C63.4237 56.8835 62.3314 57.9871 60.9661 57.9871C59.5781 57.9871 58.5086 56.8605 58.5086 55.4349C58.5086 55.205 58.5086 54.9751 58.5086 54.7452Z"
        fill="#01638d"
      />
      <path
        d="M52.2977 108.984C45.312 108.984 38.3263 108.984 31.3406 108.984C29.4974 108.984 28.2914 107.099 29.0651 105.42C29.4747 104.547 30.1801 104.087 31.113 103.995C31.2268 103.972 31.3633 103.995 31.4771 103.995C45.3803 103.995 59.2834 103.995 73.1639 103.995C74.6884 103.995 75.8034 105.053 75.8034 106.501C75.8034 107.881 74.7112 108.984 73.3459 109.007C70.9111 109.007 68.4536 109.007 66.0189 109.007C61.4679 108.984 56.8942 108.984 52.2977 108.984Z"
        fill="#01638d"
      />
    </svg>
  ),
  "payment-icon": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.0366 5.94531H3.96512C2.50551 5.94531 1.32227 7.12856 1.32227 8.58817V28.4096C1.32227 29.8692 2.50551 31.0525 3.96512 31.0525H33.0366C34.4962 31.0525 35.6794 29.8692 35.6794 28.4096V8.58817C35.6794 7.12856 34.4962 5.94531 33.0366 5.94531Z"
        stroke="#CEBA00"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.32227 15.1953H35.6794M25.108 24.4453H29.0723"
        stroke="#CEBA00"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "cancel-payment": (
    <svg
      width="183"
      height="141"
      viewBox="0 0 183 141"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1127_19307)">
        <path
          d="M0 45.9C1.9 47.4 3.7 49 5.6 50.5C6.8 51.5 7.9 52.7 9.3 53.2C11.8 54.3 12.2 56 12.2 58.5C12.1 74.7 12.1 90.9 12.1 107.1C12.1 110.1 12.4 110.6 15.3 111.7C16 112 16.8 112.3 17.5 112.6C23 114.5 26.9 118 29.4 123.3C30.8 126.2 31.3 126.2 34.5 125.9C43.6 124.9 52.7 123.8 61.9 123.3C71.3 122.8 80.5 124.7 89.8 125.9C98.9 127.1 108.1 128.3 117.3 128.9C127 129.5 136.7 127.9 146.3 126.6C153.5 125.7 152.2 126.4 154.2 120.2C156.4 113.8 161.1 110.7 167 108.8C170.5 107.6 170.6 107.4 170.6 103.7C170.6 86.1 170.6 68.6 170.6 51C170.6 48 170.3 47.6 167.6 46.5C166.9 46.2 166.1 45.9 165.4 45.6C159.8 43.7 155.7 40.2 153.2 34.7C151.9 31.9 151.2 31.8 148.3 32.2C138.2 33.5 128.2 35.4 118 34.8C108.9 34.3 99.9 33 90.9 31.8C80.7 30.4 70.4 28.9 60.1 29.1C59.8 29.1 59.5 29.1 59.4 29C59 25.1 58.7 21.3 58.3 17.1C63.3 17.3 68.5 17.3 73.6 17.9C84.5 19.2 95.4 20.7 106.3 22.2C115.2 23.4 124.1 23.5 133 22.6C148.2 21 163.4 19.1 178.5 17.4C181.1 17.1 182.5 18.2 182.5 20.9C182.5 57.6 182.5 94.3 182.5 131C182.5 133 181.7 134.2 179.9 134.4C160.9 137.3 141.9 140 122.7 140.6C112.5 140.9 102.5 139.4 92.4 137.9C81.3 136.2 70.3 134.2 59 134.8C49.5 135.3 40 136.2 30.5 137.1C21.7 138 12.9 139.3 4.1 140.5C1.8 140.8 0.4 139.6 0.4 137.2C0.4 132.6 0.4 127.9 0.4 123.3C0.4 97.9 0.4 72.5 0.4 47.2C0.4 46.6 0.4 45.9 0.4 45.3C0.3 45.5 0.1 45.7 0 45.9Z"
          fill="#ED1117"
        />
        <path
          d="M94.3 111.5C93.1 111.5 91.9 111.5 90.6 111.5C90.4 111.5 90.3 111.4 90.1 111.4C86.3 111.1 82.6 110.2 79.1 108.5C69.5 103.8 63.6 96.0999 61.6 85.5999C61.4 84.3999 61.3 83.1999 61.1 81.9999C61.1 80.7999 61.1 79.5999 61.1 78.2999C61.1 78.0999 61.2 77.8999 61.2 77.7999C61.5 73.3999 62.6 69.2999 64.8 65.4999C70.6 55.1999 79.4 49.5999 91.1 48.8999C97.3 48.4999 103.1 49.9999 108.4 53.2999C117.9 59.1999 123 67.6999 123.7 78.8999C124 84.5999 122.8 89.8999 120.1 94.8999C115.2 103.7 107.8 109.1 97.9 111C96.8 111.3 95.5 111.4 94.3 111.5ZM94.4 94.2999C95.6 93.8999 96.7 93.5999 97.8 93.0999C102.7 90.6999 103.4 85.4999 101.7 81.9999C100.9 80.4999 99.6 79.3999 98.1 78.6999C96.4 77.8999 94.5 77.1999 92.8 76.3999C92 75.9999 91.2 75.5999 90.5 75.0999C88.9 73.8999 89.3 71.9999 91.1 71.1999C92.4 70.6999 93.8 70.7999 95.1 70.8999C96 70.9999 97 71.2999 97.9 71.4999C99.2 71.7999 100.1 71.2999 100.5 70.0999C100.6 69.6999 100.7 69.1999 100.8 68.7999C101 67.6999 100.5 66.7999 99.4 66.4999C98.9 66.2999 98.4 66.1999 97.9 66.0999C96.8 65.8999 95.7 65.7999 94.6 65.5999C94.6 64.5999 94.6 63.6999 94.6 62.6999C94.6 61.9999 94.2 61.5999 93.5 61.5999C92.8 61.5999 92.1 61.5999 91.4 61.5999C90.5 61.5999 90.2 61.9999 90.2 62.8999C90.2 63.7999 90.2 64.5999 90.2 65.4999C90.2 65.8999 90.1 65.9999 89.7 66.0999C88.8 66.3999 87.9 66.5999 87.1 66.9999C84.4 68.2999 82.7 70.4999 82.5 73.5999C82.3 76.7999 83.8 79.0999 86.6 80.5999C88 81.3999 89.6 81.8999 91.1 82.5999C92.1 83.0999 93.2 83.4999 94.2 84.0999C95.2 84.6999 95.7 85.6999 95.5 86.8999C95.3 88.0999 94.4 88.5999 93.4 88.9999C92.1 89.3999 90.8 89.3999 89.5 89.1999C88.2 88.9999 86.9 88.5999 85.7 88.2999C84.5 87.9999 83.5 88.4999 83.1 89.6999C83 90.1999 82.8 90.5999 82.7 91.0999C82.5 92.1999 82.9 93.0999 83.9 93.4999C85 93.8999 86.1 94.0999 87.3 94.3999C88.2 94.5999 89.1 94.6999 90 94.7999C90 95.7999 90 96.7999 90 97.7999C90 98.5999 90.4 98.9999 91.2 98.9999C91.8 98.9999 92.4 98.9999 93 98.9999C94.1 98.9999 94.4 98.6999 94.4 97.5999C94.4 96.2999 94.4 95.2999 94.4 94.2999Z"
          fill="#ED1117"
        />
        <path
          d="M28.5 52.6999C27.4 52.6999 26.3 52.6999 25.2 52.6999C24.6 52.5999 23.9 52.5999 23.3 52.4999C18.1 51.6999 13.4 49.5999 9.5 46.0999C4.9 41.9999 2 36.9999 0.9 30.8999C0.7 29.8999 0.6 28.8999 0.5 27.9999C0.5 26.8999 0.5 25.7999 0.5 24.6999C0.6 24.0999 0.6 23.3999 0.7 22.7999C1.6 16.9999 4 12.0999 8 7.89994C13 2.89994 19.1 0.199944 26.2 -5.5803e-05C31.2 -0.200056 35.9 0.999944 40.1 3.59994C48.4 8.69994 52.8 16.0999 53.1 25.8999C53.3 30.8999 52 35.5999 49.4 39.8999C45.2 46.6999 39.2 50.8999 31.3 52.2999C30.4 52.4999 29.5 52.5999 28.5 52.6999ZM23.7 26.2999C23.5 26.4999 23.4 26.5999 23.3 26.6999C21.3 28.6999 19.2 30.6999 17.2 32.7999C16.3 33.6999 16.2 34.8999 17 35.7999C17.8 36.7999 19.3 36.8999 20.3 35.8999C22.3 33.8999 24.4 31.7999 26.4 29.7999C26.5 29.6999 26.7 29.5999 26.8 29.3999C27.9 30.4999 29 31.5999 30.1 32.6999C31.2 33.7999 32.3 34.8999 33.4 35.9999C34.1 36.6999 34.9 36.7999 35.8 36.4999C36.6 36.1999 37.1 35.4999 37.1 34.5999C37.1 33.8999 36.8 33.2999 36.3 32.7999C34.3 30.7999 32.3 28.7999 30.3 26.7999C30.2 26.6999 30.1 26.4999 29.9 26.2999C30.1 26.0999 30.2 25.9999 30.4 25.8999C32.4 23.9999 34.3 21.9999 36.3 19.9999C36.5 19.7999 36.7 19.5999 36.8 19.3999C37.7 18.1999 37.1 16.4999 35.7 15.9999C34.8 15.6999 34 15.9999 33.4 16.5999C31.4 18.5999 29.4 20.6999 27.3 22.6999C27.2 22.7999 27 22.9999 26.8 23.1999C26.7 22.9999 26.6 22.7999 26.4 22.6999C24.4 20.6999 22.3 18.5999 20.3 16.5999C19.5 15.8999 18.5 15.6999 17.7 16.1999C16.8 16.6999 16.4 17.5999 16.6 18.5999C16.7 19.0999 17 19.4999 17.4 19.7999C19.4 22.0999 21.6 24.1999 23.7 26.2999Z"
          fill="#ED1117"
        />
      </g>
      <defs>
        <clipPath id="clip0_1127_19307">
          <rect width="182.4" height="140.7" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "confirm-payment": (
    <svg
      width="183"
      height="141"
      viewBox="0 0 183 141"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1127_19303)">
        <path
          d="M0 46.1C1.9 47.6 3.7 49.2001 5.6 50.7001C6.8 51.7001 7.9 52.9001 9.3 53.4001C11.8 54.5 12.2 56.2001 12.2 58.7001C12.1 74.9001 12.1 91.1001 12.1 107.3C12.1 110.3 12.4 110.8 15.3 111.9C16 112.2 16.8 112.5 17.5 112.8C23 114.7 26.9 118.2 29.4 123.5C30.8 126.4 31.3 126.4 34.5 126.1C43.6 125.1 52.7 124 61.9 123.5C71.3 123 80.5 124.9 89.8 126.1C98.9 127.3 108.1 128.5 117.3 129.1C127 129.7 136.7 128.1 146.3 126.8C153.5 125.9 152.2 126.6 154.2 120.4C156.4 114 161.1 110.9 167 109C170.5 107.8 170.6 107.6 170.6 103.9C170.6 86.3001 170.6 68.8 170.6 51.2001C170.6 48.2001 170.3 47.8001 167.6 46.7001C166.9 46.4001 166.1 46.1 165.4 45.8C159.8 43.9 155.7 40.4001 153.2 34.9001C151.9 32.1001 151.2 32.0001 148.3 32.4001C138.2 33.7001 128.2 35.6 118 35C108.9 34.5 99.9 33.2 90.9 32C80.7 30.6 70.4 29.1 60.1 29.3C59.8 29.3 59.5 29.3001 59.4 29.2001C59 25.3001 58.7 21.5 58.3 17.3C63.3 17.5 68.5 17.5 73.6 18.1C84.5 19.4 95.4 20.9 106.3 22.4C115.2 23.6 124.1 23.7 133 22.8C148.2 21.2 163.4 19.3001 178.5 17.6C181.1 17.3 182.5 18.4 182.5 21.1C182.5 57.8 182.5 94.5 182.5 131.2C182.5 133.2 181.7 134.4 179.9 134.6C160.9 137.5 141.9 140.2 122.7 140.8C112.5 141.1 102.5 139.6 92.4 138.1C81.3 136.4 70.3 134.4 59 135C49.5 135.5 40 136.4 30.5 137.3C21.7 138.2 12.9 139.5 4.1 140.7C1.8 141 0.4 139.8 0.4 137.4C0.4 132.8 0.4 128.1 0.4 123.5C0.4 98.1 0.4 72.7001 0.4 47.4001C0.4 46.8001 0.4 46.1 0.4 45.5C0.3 45.7001 0.1 45.9 0 46.1Z"
          fill="#389e0d"
        />
        <path
          d="M26.8 0C41.4 0 53.3 11.9 53.2 26.5C53.2 41 41.3 52.8 26.8 52.8C12.2 52.8 0.299979 40.9 0.399979 26.3C0.399979 11.8 12.3 0 26.8 0ZM23.5 28.3C22.2 27.1 20.9 26 19.6 24.9C18.1 23.7 16.5 23.7 15.3 25C14.2 26.2 14.3 28 15.7 29.3C17.5 31 19.4 32.7 21.3 34.3C22.6 35.5 24.1 35.5 25.4 34.4C27 33.1 28.5 31.9 30.1 30.6C32.7 28.5 35.3 26.3 37.9 24.2C39 23.3 39.5 22 38.8 20.8C38.3 20 37.2 19.2 36.3 19C35.5 18.9 34.4 19.5 33.7 20C30.3 22.6 26.9 25.5 23.5 28.3Z"
          fill="#389e0d"
        />
        <path
          d="M61.2 82.2C61.2 81 61.2 79.8 61.2 78.5C61.2 78.3 61.3 78.1 61.3 78C61.6 73.6 62.8 69.5 64.9 65.7C69.8 56.9 77.2 51.5 87.1 49.6C88.3 49.4 89.5 49.3 90.7 49.1C91.9 49.1 93.1 49.1 94.4 49.1C94.6 49.1 94.7 49.2 94.9 49.2C99.3 49.5 103.4 50.6 107.2 52.8C117.5 58.6 123.1 67.4 123.8 79.2C124.1 84.3 123.2 89.2 120.9 93.7C115.3 104.9 106.3 110.9 93.9 111.7C88.3 112.1 82.9 110.8 77.9 108.1C69.1 103.2 63.7 95.8 61.8 85.9C61.4 84.6 61.3 83.4 61.2 82.2ZM94.4 94.4C95.6 94 96.7 93.7 97.8 93.2C102.7 90.8 103.5 85.7 101.7 82.1C100.9 80.6 99.6 79.5 98.1 78.8C96.4 77.9 94.5 77.3 92.7 76.5C91.9 76 91 75.6 90.3 75C89 74 89.2 72.2 90.7 71.5C91.3 71.2 91.9 71 92.6 71C94.4 70.8 96.2 71.1 97.9 71.6C99.3 72 100.3 71.5 100.6 70.1C100.7 69.7 100.8 69.4 100.9 69C101.1 67.9 100.6 67 99.5 66.6C98.7 66.4 98 66.2 97.2 66.1C96.4 66 95.6 65.9 94.7 65.8C94.7 64.8 94.7 63.9 94.7 62.9C94.7 62.1 94.3 61.8 93.6 61.8C92.9 61.8 92.3 61.8 91.6 61.8C90.7 61.8 90.3 62.2 90.3 63.1C90.3 63.9 90.3 64.7 90.3 65.5C90.3 65.9 90.2 66.1 89.7 66.3C88.8 66.5 87.9 66.8 87.1 67.2C84.4 68.6 82.7 70.7 82.5 73.8C82.3 77 83.8 79.2 86.5 80.7C88.1 81.6 89.9 82.1 91.5 82.9C92.6 83.4 93.7 83.9 94.6 84.6C96.1 85.8 95.7 87.9 94 88.8C93 89.3 92 89.4 90.9 89.4C89.1 89.4 87.3 89 85.6 88.4C84.4 88 83.4 88.5 83 89.7C82.8 90.2 82.7 90.7 82.6 91.2C82.4 92.3 82.9 93.2 83.9 93.5C85 93.8 86.1 94.1 87.3 94.4C88.2 94.6 89.1 94.7 90 94.8C90 95.8 90 96.8 90 97.8C90 98.6 90.4 99 91.2 99C91.9 99 92.5 99 93.2 99C94.2 99 94.5 98.7 94.5 97.6C94.4 96.5 94.4 95.4 94.4 94.4Z"
          fill="#389e0d"
        />
      </g>
      <defs>
        <clipPath id="clip0_1127_19303">
          <rect width="182.4" height="140.9" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "payment-success": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M116.216 81.1932C115.635 81.1932 115.163 81.1932 114.655 81.1932C107.94 81.1932 101.224 81.2291 94.5091 81.1932C84.6359 81.1573 76.868 73.2597 77.0495 63.4952C77.2309 54.5206 84.89 46.8742 94.001 46.7665C100.789 46.6947 107.613 46.7306 114.401 46.7306C114.945 46.7306 115.49 46.7306 116.143 46.7306C116.179 46.3716 116.252 46.0126 116.252 45.6895C116.252 43.2843 116.288 40.8432 116.252 38.438C116.216 35.602 114.437 33.843 111.533 33.843C102.204 33.843 92.8394 33.843 83.5106 33.843C63.1107 33.843 42.6746 33.843 22.2747 33.843C21.7302 33.843 21.1857 33.843 20.4235 33.843C20.4235 34.3456 20.4235 34.8482 20.4235 35.3148C20.4235 42.674 20.4235 50.0333 20.4235 57.3925C20.4235 59.3669 19.3345 60.9464 17.5922 61.5567C15.8498 62.2029 14.1801 61.8798 13.0185 60.4798C12.3651 59.69 11.7844 58.5053 11.7844 57.4643C11.7118 45.187 11.6755 32.8737 11.7481 20.5964C11.7844 13.668 17.6285 8.06781 24.743 8.03191C33.6725 7.96011 42.602 8.03191 51.5678 8.03191C67.031 8.03191 82.4943 8.03191 97.9938 8.03191C101.587 8.03191 103.221 9.64735 103.221 13.2013C103.221 16.7553 103.221 20.2733 103.221 23.8273C103.221 24.2581 103.221 24.6889 103.221 25.2632C105.943 25.2632 108.484 25.2632 111.061 25.2632C119.446 25.2632 125 30.7198 125 38.9765C125 55.7052 125 72.434 125 89.1627C125 97.2399 119.41 102.768 111.243 102.768C97.0863 102.768 82.9298 102.768 68.7733 102.768C66.9221 102.768 65.5065 102.122 64.5627 100.543C63.7278 99.1066 63.7641 97.5989 64.6716 96.1989C65.6154 94.6911 67.0673 94.1526 68.8459 94.1526C81.2601 94.1885 93.7106 94.1526 106.125 94.1526C107.976 94.1526 109.827 94.1885 111.715 94.1526C114.401 94.1167 116.216 92.3218 116.252 89.6653C116.288 87.1165 116.252 84.5677 116.252 81.983C116.252 81.8035 116.216 81.624 116.216 81.1932ZM94.4365 16.5758C93.8921 16.5758 93.4928 16.5758 93.0935 16.5758C70.5157 16.5758 47.9379 16.5758 25.3601 16.5758C25.106 16.5758 24.8156 16.5758 24.5615 16.5758C22.5651 16.7194 20.7501 18.1912 20.5324 20.1656C20.3509 21.7811 20.4961 23.4324 20.4961 25.1196C45.2155 25.1196 69.7897 25.1196 94.4365 25.1196C94.4365 22.2837 94.4365 19.5195 94.4365 16.5758ZM116.216 55.3822C108.629 55.3822 101.224 55.3822 93.7832 55.3822C93.1298 55.3822 92.4401 55.5616 91.7867 55.777C87.7939 57.0694 85.2167 61.09 85.8337 65.0748C86.4871 69.3108 90.0081 72.5058 94.3276 72.5417C101.406 72.5776 108.484 72.5417 115.526 72.5417C115.744 72.5417 115.962 72.4699 116.179 72.4699C116.216 66.7979 116.216 61.1618 116.216 55.3822Z"
        fill="#389e0d"
      />
      <path
        d="M59.626 91.9274C59.6623 107.4 47.0666 119.964 31.4219 120C15.7046 120.036 3 107.507 3 91.9633C3 76.491 15.632 63.9983 31.2767 63.9624C46.9577 63.9624 59.5897 76.4551 59.626 91.9274ZM31.4219 72.5781C20.496 72.5422 11.7117 81.1219 11.7117 91.8556C11.6754 102.589 20.3145 111.277 31.1315 111.313C42.0574 111.384 50.878 102.841 50.9143 92.071C50.9869 81.3373 42.3115 72.6499 31.4219 72.5781Z"
        fill="#389e0d"
      />
      <path
        d="M101.043 68.2693C98.9015 68.2693 96.7962 68.3052 94.6545 68.2693C92.041 68.2334 90.0809 66.3667 90.1172 63.9256C90.1535 61.5562 92.0773 59.6895 94.6182 59.6895C98.8652 59.6536 103.148 59.6536 107.395 59.6895C109.936 59.6895 111.86 61.5921 111.86 63.9615C111.86 66.3308 109.936 68.2334 107.432 68.2693C105.326 68.3052 103.185 68.2693 101.043 68.2693Z"
        fill="#389e0d"
      />
      <path
        d="M26.8485 92.5367C30.3695 89.0545 33.6001 85.7877 36.9033 82.5928C39.4442 80.1516 43.2918 81.1568 44.2356 84.4595C44.6712 85.9672 44.2356 87.3314 43.1466 88.4083C38.7545 92.8239 34.3261 97.2035 29.8613 101.547C28.119 103.234 25.7596 103.163 23.9809 101.475C22.0934 99.6805 20.2059 97.8497 18.3909 95.947C16.6849 94.1521 16.7212 91.7469 18.4272 90.0238C20.1696 88.3006 22.6379 88.2288 24.5254 89.9879C25.324 90.7417 25.9773 91.6033 26.8485 92.5367Z"
        fill="#389e0d"
      />
    </svg>
  ),
  "payment-error": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2011_19962)">
        <path
          d="M121.879 48.035C83.206 48.035 44.7944 48.035 6.20873 48.035C6.17971 48.499 6.12169 48.905 6.12169 49.34C6.12169 60.0707 6.09268 70.8013 6.12169 81.532C6.1507 88.6954 10.9957 94.5538 18.5677 96.6129C20.0764 97.0189 21.701 97.1639 23.2677 97.2219C26.517 97.3089 29.7373 97.2509 32.9866 97.2509C35.1335 97.2509 36.497 98.324 36.526 99.9481C36.5551 101.63 35.1625 102.732 32.9286 102.732C29.7373 102.732 26.546 102.761 23.3547 102.732C12.3592 102.587 3.22051 96.1489 0.609451 86.5493C0.145262 84.8382 -0.0288086 83.0111 -0.0288086 81.271C0.000203192 63.3189 0.000203192 45.3668 0.029215 27.4147C0.029215 17.9891 5.91861 10.3327 15.7826 7.2295C18.2486 6.44645 20.9757 6.06943 23.5868 6.06943C50.5677 5.98242 77.5487 5.98242 104.53 6.04042C115.554 6.06943 124.867 12.7108 127.333 22.2814C127.768 23.9055 127.913 25.6456 127.942 27.3277C127.971 45.2798 127.971 63.2029 127.971 81.155C127.971 83.0691 127.072 84.2001 125.447 84.4612C123.416 84.7802 121.908 83.4461 121.879 81.3C121.879 70.8303 121.879 60.3607 121.879 49.8911C121.879 49.282 121.879 48.731 121.879 48.035ZM121.792 29.8509C83.177 29.8509 44.7074 29.8509 6.23774 29.8509C6.23774 34.1141 6.23774 38.2614 6.23774 42.4086C44.8234 42.4086 83.264 42.4086 121.792 42.4086C121.792 38.2034 121.792 34.0851 121.792 29.8509ZM6.52785 24.1375C44.9685 24.1375 83.177 24.1375 121.473 24.1375C121.386 23.6155 121.357 23.2385 121.24 22.8614C119.094 16.104 112.479 11.5218 104.588 11.5218C77.5197 11.4928 50.4517 11.4928 23.3837 11.5218C18.5968 11.4928 14.5061 13.0588 11.1407 16.104C8.73275 18.2792 7.07908 20.8893 6.52785 24.1375Z"
          fill="#ED1117"
        />
        <path
          d="M85.1783 120.974C75.6044 120.974 66.0306 120.974 56.4567 120.974C50.1321 120.974 45.4032 117.958 43.4014 112.622C42.0668 109.084 42.8792 105.806 44.91 102.645C51.8728 91.8276 58.8066 81.01 65.7694 70.1923C68.3805 66.1321 70.9626 62.0718 73.6026 58.0406C79.1439 49.5141 91.4159 49.3981 96.9571 57.9246C106.531 72.6865 115.96 87.5354 125.505 102.297C127.913 106.038 128.725 109.838 126.694 113.84C124.373 118.451 120.254 120.916 114.596 120.974C104.79 121.032 94.9843 120.974 85.1783 120.974ZM85.2074 115.493C94.7812 115.493 104.355 115.493 113.929 115.493C120.399 115.493 123.648 110.476 120.428 105.4C110.883 90.4645 101.309 75.5576 91.706 60.6797C88.6017 55.8655 82.0451 55.8365 78.9408 60.6507C69.2509 75.6446 59.619 90.6675 49.987 105.719C49.1167 107.112 48.6235 108.591 49.0297 110.215C49.871 113.579 52.4821 115.493 56.3696 115.493C65.9725 115.493 75.6045 115.493 85.2074 115.493Z"
          fill="#ED1117"
        />
        <path
          d="M32.0871 79.009C36.4389 79.009 40.7906 79.009 45.1134 79.009C47.3473 79.009 48.7399 80.0821 48.7399 81.7352C48.7399 83.3883 47.3473 84.4613 45.1134 84.4613C36.3808 84.4613 27.6193 84.4613 18.8867 84.4613C16.6238 84.4613 15.2603 83.4173 15.2603 81.7061C15.2603 80.024 16.6238 78.98 18.8867 78.98C23.2965 79.009 27.6773 79.009 32.0871 79.009Z"
          fill="#ED1117"
        />
        <path
          d="M82.0129 82.6339C82.0129 79.7338 82.0129 76.8046 82.0129 73.9044C82.0129 71.9903 83.2314 70.7722 85.0591 70.7722C86.8869 70.7722 88.1054 71.9903 88.1054 73.9044C88.1054 79.7338 88.1344 85.5341 88.1054 91.3635C88.1054 93.2486 86.8579 94.4957 85.0591 94.4957C83.2314 94.4957 82.0419 93.2776 82.0129 91.3635C81.9839 88.4633 82.0129 85.5631 82.0129 82.6339Z"
          fill="#ED1117"
        />
        <circle cx="85" cy="102" r="3" fill="#ED1117" />
      </g>
      <defs>
        <clipPath id="clip0_2011_19962">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  userprofile: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.83981 11.5908C10.9198 11.5908 12.6098 9.90078 12.6098 7.82078C12.6098 5.74078 10.9198 4.05078 8.83981 4.05078C6.75981 4.05078 5.06982 5.74078 5.06982 7.82078C5.06982 9.90078 6.75981 11.5908 8.83981 11.5908Z"
        fill="#695EE5"
      />
      <path
        d="M16.16 17.4813V19.2013C16.16 19.6113 15.83 19.9513 15.41 19.9513H2.75C2.34 19.9513 2 19.6113 2 19.2013V17.4813C2 15.0713 3.96 13.1113 6.37 13.1113H11.79C12.28 13.1113 12.75 13.1913 13.19 13.3513C13.19 13.3513 13.19 13.3413 13.2 13.3513C14.92 13.9313 16.16 15.5613 16.16 17.4813Z"
        fill="#262626"
      />
      <path
        d="M16.16 17.4813V19.2013C16.16 19.6113 15.83 19.9513 15.41 19.9513H2.75C2.34 19.9513 2 19.6113 2 19.2013V17.4813C2 15.0713 3.96 13.1113 6.37 13.1113H11.79C12.28 13.1113 12.75 13.1913 13.19 13.3513C13.19 13.3513 13.19 13.3413 13.2 13.3513C14.92 13.9313 16.16 15.5613 16.16 17.4813Z"
        fill="#695EE5"
      />
      <path
        d="M22 16.6214V18.0314C22 18.3614 21.73 18.6314 21.4 18.6314H17.66V17.4814C17.66 16.4714 17.4 15.5114 16.95 14.6814C16.76 14.3414 16.55 14.0214 16.31 13.7314C16.14 13.5414 15.97 13.3514 15.79 13.1914H18.5701C18.6801 13.1914 18.7801 13.1914 18.8801 13.2114C19.0101 13.2214 19.14 13.2414 19.2701 13.2714C20.0301 13.4314 20.69 13.8514 21.18 14.4114C21.26 14.5014 21.34 14.6014 21.41 14.7114C21.42 14.7114 21.42 14.7114 21.41 14.7214C21.6 15.0014 21.7501 15.3014 21.8501 15.6314C21.8801 15.7414 21.91 15.8514 21.93 15.9614C21.98 16.1714 22 16.3914 22 16.6214Z"
        fill="#695EE5"
      />
      <path
        d="M16.3801 11.4507C18.0315 11.4507 19.3701 10.112 19.3701 8.4607C19.3701 6.80937 18.0315 5.4707 16.3801 5.4707C14.7288 5.4707 13.3901 6.80937 13.3901 8.4607C13.3901 10.112 14.7288 11.4507 16.3801 11.4507Z"
        fill="#695EE5"
      />
    </svg>
  ),
  "plus-circle-white": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM16.5 12.5625C16.5 12.6656 16.4156 12.75 16.3125 12.75H12.75V16.3125C12.75 16.4156 12.6656 16.5 12.5625 16.5H11.4375C11.3344 16.5 11.25 16.4156 11.25 16.3125V12.75H7.6875C7.58437 12.75 7.5 12.6656 7.5 12.5625V11.4375C7.5 11.3344 7.58437 11.25 7.6875 11.25H11.25V7.6875C11.25 7.58437 11.3344 7.5 11.4375 7.5H12.5625C12.6656 7.5 12.75 7.58437 12.75 7.6875V11.25H16.3125C16.4156 11.25 16.5 11.3344 16.5 11.4375V12.5625Z"
        fill="#fff"
      />
    </svg>
  ),
  "plus-circle-green": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM16.5 12.5625C16.5 12.6656 16.4156 12.75 16.3125 12.75H12.75V16.3125C12.75 16.4156 12.6656 16.5 12.5625 16.5H11.4375C11.3344 16.5 11.25 16.4156 11.25 16.3125V12.75H7.6875C7.58437 12.75 7.5 12.6656 7.5 12.5625V11.4375C7.5 11.3344 7.58437 11.25 7.6875 11.25H11.25V7.6875C11.25 7.58437 11.3344 7.5 11.4375 7.5H12.5625C12.6656 7.5 12.75 7.58437 12.75 7.6875V11.25H16.3125C16.4156 11.25 16.5 11.3344 16.5 11.4375V12.5625Z"
        fill="#389e0d"
      />
    </svg>
  ),
  "plus-circle-black": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM16.5 12.5625C16.5 12.6656 16.4156 12.75 16.3125 12.75H12.75V16.3125C12.75 16.4156 12.6656 16.5 12.5625 16.5H11.4375C11.3344 16.5 11.25 16.4156 11.25 16.3125V12.75H7.6875C7.58437 12.75 7.5 12.6656 7.5 12.5625V11.4375C7.5 11.3344 7.58437 11.25 7.6875 11.25H11.25V7.6875C11.25 7.58437 11.3344 7.5 11.4375 7.5H12.5625C12.6656 7.5 12.75 7.58437 12.75 7.6875V11.25H16.3125C16.4156 11.25 16.5 11.3344 16.5 11.4375V12.5625Z"
        fill="#333"
      />
    </svg>
  ),
  "single-numbering-blue": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1 3C11.1 2.44772 10.6523 2 10.1 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V10.9C19 10.3477 18.5523 9.9 18 9.9H14C12.3984 9.9 11.1 8.60163 11.1 7V3ZM9.5 13.1C9.00294 13.1 8.6 13.5029 8.6 14C8.6 14.4971 9.00294 14.9 9.5 14.9H12C12.4971 14.9 12.9 14.4971 12.9 14C12.9 13.5029 12.4971 13.1 12 13.1H9.5ZM9.5 16.6C9.00294 16.6 8.6 17.0029 8.6 17.5C8.6 17.9971 9.00294 18.4 9.5 18.4H14.5C14.9971 18.4 15.4 17.9971 15.4 17.5C15.4 17.0029 14.9971 16.6 14.5 16.6H9.5Z"
        fill="#154398"
      />
      <path
        d="M16.8929 8.1C17.3383 8.1 17.5614 7.56143 17.2464 7.24645L13.7536 3.75355C13.4386 3.43857 12.9 3.66165 12.9 4.10711V7C12.9 7.60751 13.3925 8.1 14 8.1H16.8929Z"
        fill="#154398"
      />
    </svg>
  ),
  "print-receipt-blue": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.875 1.5C6.83947 1.5 6 2.33947 6 3.375V6.36564C5.5736 6.41799 5.1489 6.47583 4.72596 6.53912C3.27191 6.75668 2.25 8.02163 2.25 9.45569V15.75C2.25 17.4069 3.59315 18.75 5.25 18.75H5.51963L5.36461 20.4552C5.26479 21.5533 6.12935 22.5 7.23191 22.5H16.7681C17.8706 22.5 18.7352 21.5533 18.6354 20.4552L18.4804 18.75H18.75C20.4069 18.75 21.75 17.4069 21.75 15.75V9.45569C21.75 8.02163 20.7281 6.75668 19.274 6.53912C18.8511 6.47583 18.4264 6.41799 18 6.36564V3.375C18 2.33947 17.1605 1.5 16.125 1.5H7.875ZM16.5 6.20498V3.375C16.5 3.16789 16.3321 3 16.125 3H7.875C7.66789 3 7.5 3.16789 7.5 3.375V6.20498C8.98198 6.06931 10.483 6 12 6C13.517 6 15.018 6.06931 16.5 6.20498ZM16.2834 14.4696C16.4607 14.4879 16.5996 14.6298 16.6158 14.8073L17.1415 20.591C17.1615 20.8107 16.9886 21 16.7681 21H7.23191C7.0114 21 6.83849 20.8107 6.85845 20.591L7.38425 14.8073C7.40039 14.6298 7.53926 14.4879 7.71659 14.4696C9.12438 14.3244 10.5534 14.25 12 14.25C13.4466 14.25 14.8756 14.3244 16.2834 14.4696ZM17.25 10.5C17.25 10.0858 17.5858 9.75 18 9.75H18.0075C18.4217 9.75 18.7575 10.0858 18.7575 10.5V10.5075C18.7575 10.9217 18.4217 11.2575 18.0075 11.2575H18C17.5858 11.2575 17.25 10.9217 17.25 10.5075V10.5ZM15 9.75C14.5858 9.75 14.25 10.0858 14.25 10.5V10.5075C14.25 10.9217 14.5858 11.2575 15 11.2575H15.0075C15.4217 11.2575 15.7575 10.9217 15.7575 10.5075V10.5C15.7575 10.0858 15.4217 9.75 15.0075 9.75H15Z"
        fill="#154398"
      />
    </svg>
  ),
  "print-bar-blue": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.875 1.5C6.83947 1.5 6 2.33947 6 3.375V6.36564C5.5736 6.41799 5.1489 6.47583 4.72596 6.53912C3.27191 6.75668 2.25 8.02163 2.25 9.45569V15.75C2.25 17.4069 3.59315 18.75 5.25 18.75H5.51963L5.36461 20.4552C5.26479 21.5533 6.12935 22.5 7.23191 22.5H16.7681C17.8706 22.5 18.7352 21.5533 18.6354 20.4552L18.4804 18.75H18.75C20.4069 18.75 21.75 17.4069 21.75 15.75V9.45569C21.75 8.02163 20.7281 6.75668 19.274 6.53912C18.8511 6.47583 18.4264 6.41799 18 6.36564V3.375C18 2.33947 17.1605 1.5 16.125 1.5H7.875ZM16.5 6.20498V3.375C16.5 3.16789 16.3321 3 16.125 3H7.875C7.66789 3 7.5 3.16789 7.5 3.375V6.20498C8.98198 6.06931 10.483 6 12 6C13.517 6 15.018 6.06931 16.5 6.20498ZM16.2834 14.4696C16.4607 14.4879 16.5996 14.6298 16.6158 14.8073L17.1415 20.591C17.1615 20.8107 16.9886 21 16.7681 21H7.23191C7.0114 21 6.83849 20.8107 6.85845 20.591L7.38425 14.8073C7.40039 14.6298 7.53926 14.4879 7.71659 14.4696C9.12438 14.3244 10.5534 14.25 12 14.25C13.4466 14.25 14.8756 14.3244 16.2834 14.4696ZM17.25 10.5C17.25 10.0858 17.5858 9.75 18 9.75H18.0075C18.4217 9.75 18.7575 10.0858 18.7575 10.5V10.5075C18.7575 10.9217 18.4217 11.2575 18.0075 11.2575H18C17.5858 11.2575 17.25 10.9217 17.25 10.5075V10.5ZM15 9.75C14.5858 9.75 14.25 10.0858 14.25 10.5V10.5075C14.25 10.9217 14.5858 11.2575 15 11.2575H15.0075C15.4217 11.2575 15.7575 10.9217 15.7575 10.5075V10.5C15.7575 10.0858 15.4217 9.75 15.0075 9.75H15Z"
        fill="#154398"
      />
    </svg>
  ),
  "export-blue": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1 3C11.1 2.44772 10.6523 2 10.1 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V10.9C19 10.3477 18.5523 9.9 18 9.9H14C12.3984 9.9 11.1 8.60163 11.1 7V3ZM9.5 13.1C9.00294 13.1 8.6 13.5029 8.6 14C8.6 14.4971 9.00294 14.9 9.5 14.9H12C12.4971 14.9 12.9 14.4971 12.9 14C12.9 13.5029 12.4971 13.1 12 13.1H9.5ZM9.5 16.6C9.00294 16.6 8.6 17.0029 8.6 17.5C8.6 17.9971 9.00294 18.4 9.5 18.4H14.5C14.9971 18.4 15.4 17.9971 15.4 17.5C15.4 17.0029 14.9971 16.6 14.5 16.6H9.5Z"
        fill="#154398"
      />
      <path
        d="M16.8929 8.1C17.3383 8.1 17.5614 7.56143 17.2464 7.24645L13.7536 3.75355C13.4386 3.43857 12.9 3.66165 12.9 4.10711V7C12.9 7.60751 13.3925 8.1 14 8.1H16.8929Z"
        fill="#154398"
      />
    </svg>
  ),
  "add-file-blue": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5495 13.73H14.2624C14.6683 13.73 15.005 13.4 15.005 12.99C15.005 12.57 14.6683 12.24 14.2624 12.24H12.5495V10.51C12.5495 10.1 12.2228 9.77 11.8168 9.77C11.4109 9.77 11.0743 10.1 11.0743 10.51V12.24H9.37129C8.96535 12.24 8.62871 12.57 8.62871 12.99C8.62871 13.4 8.96535 13.73 9.37129 13.73H11.0743V15.46C11.0743 15.87 11.4109 16.2 11.8168 16.2C12.2228 16.2 12.5495 15.87 12.5495 15.46V13.73ZM19.3381 9.02561C19.5708 9.02292 19.8242 9.02 20.0545 9.02C20.302 9.02 20.5 9.22 20.5 9.47V17.51C20.5 19.99 18.5099 22 16.0446 22H8.17327C5.59901 22 3.5 19.89 3.5 17.29V6.51C3.5 4.03 5.5 2 7.96535 2H13.2525C13.5099 2 13.7079 2.21 13.7079 2.46V5.68C13.7079 7.51 15.203 9.01 17.0149 9.02C17.4381 9.02 17.8112 9.02316 18.1377 9.02593C18.3917 9.02809 18.6175 9.03 18.8168 9.03C18.9578 9.03 19.1405 9.02789 19.3381 9.02561ZM19.61 7.5662C18.7961 7.5692 17.8367 7.5662 17.1466 7.5592C16.0516 7.5592 15.1496 6.6482 15.1496 5.5422V2.9062C15.1496 2.4752 15.6674 2.2612 15.9635 2.5722C16.4995 3.1351 17.2361 3.90891 17.9693 4.67913C18.7002 5.44689 19.4277 6.21108 19.9496 6.7592C20.2387 7.0622 20.0268 7.5652 19.61 7.5662Z"
        fill="#154398"
      />
    </svg>
  ),
  "add-file-green": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5495 13.73H14.2624C14.6683 13.73 15.005 13.4 15.005 12.99C15.005 12.57 14.6683 12.24 14.2624 12.24H12.5495V10.51C12.5495 10.1 12.2228 9.77 11.8168 9.77C11.4109 9.77 11.0743 10.1 11.0743 10.51V12.24H9.37129C8.96535 12.24 8.62871 12.57 8.62871 12.99C8.62871 13.4 8.96535 13.73 9.37129 13.73H11.0743V15.46C11.0743 15.87 11.4109 16.2 11.8168 16.2C12.2228 16.2 12.5495 15.87 12.5495 15.46V13.73ZM19.3381 9.02561C19.5708 9.02292 19.8242 9.02 20.0545 9.02C20.302 9.02 20.5 9.22 20.5 9.47V17.51C20.5 19.99 18.5099 22 16.0446 22H8.17327C5.59901 22 3.5 19.89 3.5 17.29V6.51C3.5 4.03 5.5 2 7.96535 2H13.2525C13.5099 2 13.7079 2.21 13.7079 2.46V5.68C13.7079 7.51 15.203 9.01 17.0149 9.02C17.4381 9.02 17.8112 9.02316 18.1377 9.02593C18.3917 9.02809 18.6175 9.03 18.8168 9.03C18.9578 9.03 19.1405 9.02789 19.3381 9.02561ZM19.61 7.5662C18.7961 7.5692 17.8367 7.5662 17.1466 7.5592C16.0516 7.5592 15.1496 6.6482 15.1496 5.5422V2.9062C15.1496 2.4752 15.6674 2.2612 15.9635 2.5722C16.4995 3.1351 17.2361 3.90891 17.9693 4.67913C18.7002 5.44689 19.4277 6.21108 19.9496 6.7592C20.2387 7.0622 20.0268 7.5652 19.61 7.5662Z"
        fill="#389e0d"
      />
    </svg>
  ),
  "add-blue": (
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="#01638D" />
    </svg>
  ),
  camera: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12.5"
        cy="12.5"
        r="12"
        fill="#757779"
        fillOpacity="0.75"
        stroke="white"
      />
      <path
        d="M12.0833 15.7105C12.908 15.7105 13.609 15.422 14.1865 14.8449C14.7635 14.2675 15.0521 13.5664 15.0521 12.7418C15.0521 11.9171 14.7635 11.216 14.1865 10.6386C13.609 10.0615 12.908 9.773 12.0833 9.773C11.2587 9.773 10.5576 10.0615 9.98011 10.6386C9.40307 11.216 9.11456 11.9171 9.11456 12.7418C9.11456 13.5664 9.40307 14.2675 9.98011 14.8449C10.5576 15.422 11.2587 15.7105 12.0833 15.7105ZM6.80553 18.0195C6.44268 18.0195 6.13217 17.8904 5.874 17.6323C5.61539 17.3737 5.48608 17.0629 5.48608 16.7001V8.78342C5.48608 8.42057 5.61539 8.11006 5.874 7.85189C6.13217 7.59328 6.44268 7.46398 6.80553 7.46398H8.88365L10.1041 6.14453H14.0625L15.283 7.46398H17.3611C17.7239 7.46398 18.0347 7.59328 18.2933 7.85189C18.5514 8.11006 18.6805 8.42057 18.6805 8.78342V16.7001C18.6805 17.0629 18.5514 17.3737 18.2933 17.6323C18.0347 17.8904 17.7239 18.0195 17.3611 18.0195H6.80553Z"
        fill="white"
      />
    </svg>
  ),
  backup: (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0885 16.6303C13.8014 17.8126 12.1979 18.5946 10.4738 18.8808C8.74966 19.167 6.9795 18.945 5.37944 18.242C3.77938 17.5389 2.41865 16.3851 1.46337 14.9216C0.508092 13.458 -0.000391364 11.748 2.26006e-07 10.0003H1.5C1.49989 11.5109 1.95597 12.9864 2.80851 14.2335C3.66106 15.4806 4.87032 16.4412 6.27796 16.9894C7.6856 17.5377 9.226 17.6481 10.6975 17.3062C12.1689 16.9643 13.5028 16.186 14.5245 15.0733H12.345C12.1461 15.0733 11.9553 14.9943 11.8147 14.8536C11.674 14.713 11.595 14.5222 11.595 14.3233C11.595 14.1244 11.674 13.9336 11.8147 13.793C11.9553 13.6523 12.1461 13.5733 12.345 13.5733H15.8385C16.0374 13.5733 16.2282 13.6523 16.3688 13.793C16.5095 13.9336 16.5885 14.1244 16.5885 14.3233V17.8138C16.5885 18.0127 16.5095 18.2035 16.3688 18.3441C16.2282 18.4848 16.0374 18.5638 15.8385 18.5638C15.6396 18.5638 15.4488 18.4848 15.3082 18.3441C15.1675 18.2035 15.0885 18.0127 15.0885 17.8138V16.6288V16.6303ZM3.4755 4.9288H5.655C5.85391 4.9288 6.04468 5.00782 6.18533 5.14847C6.32598 5.28912 6.405 5.47989 6.405 5.6788C6.405 5.87771 6.32598 6.06848 6.18533 6.20913C6.04468 6.34978 5.85391 6.4288 5.655 6.4288H2.16C1.96109 6.4288 1.77032 6.34978 1.62967 6.20913C1.48902 6.06848 1.41 5.87771 1.41 5.6788V2.1853C1.41 1.98639 1.48902 1.79562 1.62967 1.65497C1.77032 1.51432 1.96109 1.4353 2.16 1.4353C2.35891 1.4353 2.54968 1.51432 2.69033 1.65497C2.83098 1.79562 2.91 1.98639 2.91 2.1853V3.3703C4.19693 2.1865 5.80084 1.40324 7.52571 1.11622C9.25059 0.829198 11.0217 1.05086 12.6227 1.75411C14.2236 2.45737 15.585 3.61175 16.5405 5.0762C17.496 6.54064 18.0042 8.25171 18.003 10.0003H16.503C16.5031 8.48945 16.047 7.01379 15.1942 5.76659C14.3415 4.51939 13.132 3.5588 11.7241 3.01065C10.3162 2.46251 8.77553 2.35235 7.30396 2.69461C5.83239 3.03688 4.4985 3.81561 3.477 4.9288H3.4755Z"
        fill="#01638D"
      />
    </svg>
  ),
  cloud: (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.35 6.04C19.0141 4.33772 18.0976 2.80486 16.7571 1.70325C15.4165 0.601633 13.7351 -0.000392242 12 1.91737e-07C9.11 1.91737e-07 6.6 1.64 5.35 4.04C3.88023 4.19883 2.52101 4.89521 1.53349 5.99532C0.545971 7.09543 -0.000171702 8.52168 4.04928e-08 10C4.04928e-08 13.31 2.69 16 6 16H19C21.76 16 24 13.76 24 11C24 8.36 21.95 6.22 19.35 6.04ZM19 14H6C3.79 14 2 12.21 2 10C2 7.79 3.79 6 6 6H6.71C7.37 3.69 9.48 2 12 2C15.04 2 17.5 4.46 17.5 7.5V8H19C20.66 8 22 9.34 22 11C22 12.66 20.66 14 19 14Z"
        fill="#01638D"
      />
    </svg>
  ),
  "block-tree": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.66667 8H4.4C4.29391 8 4.19217 8.04214 4.11716 8.11716C4.04214 8.19217 4 8.29391 4 8.4V12.9333C4 13.0394 4.04214 13.1412 4.11716 13.2162C4.19217 13.2912 4.29391 13.3333 4.4 13.3333H11.6C11.7061 13.3333 11.8078 13.2912 11.8828 13.2162C11.9579 13.1412 12 13.0394 12 12.9333V12.3333M6.754 2.92333C7.09133 2.76333 7.502 2.66667 8 2.66667C10.1333 2.66667 10.6667 4.44467 10.6667 5.33333V8H11.6C11.7061 8 11.8078 8.04214 11.8828 8.11716C11.9579 8.19217 12 8.29391 12 8.4V8.66667M5.33333 5.33333V8M2 2L14 14"
        stroke="#1574F6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "user-header": (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9997 0.333008C7.79467 0.333008 0.333008 7.79467 0.333008 16.9997C0.333008 26.2047 7.79467 33.6663 16.9997 33.6663C26.2047 33.6663 33.6663 26.2047 33.6663 16.9997C33.6663 7.79467 26.2047 0.333008 16.9997 0.333008ZM11.1663 12.833C11.1663 12.067 11.3172 11.3084 11.6104 10.6007C11.9035 9.89296 12.3332 9.24989 12.8749 8.70822C13.4166 8.16654 14.0596 7.73686 14.7674 7.44371C15.4751 7.15056 16.2336 6.99967 16.9997 6.99967C17.7657 6.99967 18.5243 7.15056 19.232 7.44371C19.9397 7.73686 20.5828 8.16654 21.1245 8.70822C21.6661 9.24989 22.0958 9.89296 22.389 10.6007C22.6821 11.3084 22.833 12.067 22.833 12.833C22.833 14.3801 22.2184 15.8638 21.1245 16.9578C20.0305 18.0518 18.5468 18.6663 16.9997 18.6663C15.4526 18.6663 13.9688 18.0518 12.8749 16.9578C11.7809 15.8638 11.1663 14.3801 11.1663 12.833ZM27.4297 25.3063C26.1821 26.8757 24.596 28.1429 22.79 29.0133C20.9839 29.8838 19.0045 30.3349 16.9997 30.333C14.9948 30.3349 13.0154 29.8838 11.2094 29.0133C9.40334 28.1429 7.81728 26.8757 6.56967 25.3063C9.27134 23.368 12.958 21.9997 16.9997 21.9997C21.0413 21.9997 24.728 23.368 27.4297 25.3063Z"
        fill="#fff"
      />
    </svg>
  ),
  "icon-pdf": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0751 1.55469L22.2481 5.90469V22.4467H6.6593V22.5007H22.3013V5.95944L18.0751 1.55469Z"
        fill="#909090"
      />
      <path
        d="M18.0232 1.5H6.60596V22.446H22.248V5.90475L18.0232 1.5Z"
        fill="#F4F4F4"
      />
      <path
        d="M6.49123 2.625H1.69873V7.74525H16.7737V2.625H6.49123Z"
        fill="#7A7B7C"
      />
      <path
        d="M16.854 7.65916H1.79626V2.53516H16.854V7.65916Z"
        fill="#DD2025"
      />
      <path
        d="M6.78897 3.40003H5.80872V7.00003H6.57972V5.78578L6.74997 5.79553C6.91539 5.79268 7.07927 5.76305 7.23522 5.70778C7.37194 5.66075 7.49772 5.58651 7.60497 5.48953C7.71409 5.39714 7.80013 5.28055 7.85622 5.14903C7.93144 4.9304 7.95831 4.69805 7.93497 4.46803C7.93028 4.30371 7.90147 4.14097 7.84947 3.98503C7.80212 3.87246 7.73186 3.77098 7.64315 3.68705C7.55444 3.60312 7.44923 3.53857 7.33422 3.49753C7.23477 3.46153 7.13203 3.4354 7.02747 3.41953C6.94829 3.40731 6.86833 3.40079 6.78822 3.40003M6.64647 5.12053H6.57972V4.01053H6.72447C6.78835 4.00592 6.85245 4.01573 6.91204 4.03922C6.97163 4.06272 7.02517 4.09931 7.06872 4.14628C7.15895 4.26704 7.20716 4.41403 7.20597 4.56478C7.20597 4.74928 7.20597 4.91653 7.03947 5.03428C6.91952 5.10025 6.78298 5.1307 6.64647 5.12053ZM9.39972 3.39028C9.31647 3.39028 9.23547 3.39628 9.17847 3.39853L8.99997 3.40303H8.41497V7.00303H9.10347C9.36658 7.01024 9.62855 6.96564 9.87447 6.87178C10.0724 6.79327 10.2477 6.66671 10.3845 6.50353C10.5175 6.33887 10.613 6.14716 10.6642 5.94178C10.7231 5.70918 10.7519 5.46996 10.7497 5.23003C10.7643 4.94665 10.7423 4.66257 10.6845 4.38478C10.6296 4.1803 10.5267 3.99185 10.3845 3.83503C10.2729 3.7084 10.1362 3.60626 9.98322 3.53503C9.8518 3.47422 9.71356 3.42939 9.57147 3.40153C9.51496 3.39219 9.45773 3.38793 9.40047 3.38878M9.26397 6.34153H9.18897V4.04353H9.19872C9.35334 4.02574 9.50978 4.05364 9.64872 4.12378C9.75046 4.20502 9.83337 4.30738 9.89172 4.42378C9.95468 4.54628 9.99098 4.68073 9.99822 4.81828C10.005 4.98328 9.99822 5.11828 9.99822 5.23003C10.0013 5.35876 9.99299 5.4875 9.97347 5.61478C9.95035 5.74545 9.90762 5.87188 9.84672 5.98978C9.77778 6.09939 9.68465 6.19176 9.57447 6.25978C9.48193 6.31963 9.37236 6.34755 9.26247 6.33928M13.0725 3.40303H11.25V7.00303H12.021V5.57503H12.996V4.90603H12.021V4.07203H13.071V3.40303"
        fill="#464648"
      />
      <path
        d="M16.3358 15.1921C16.3358 15.1921 18.7268 14.7586 18.7268 15.5754C18.7268 16.3921 17.2455 16.0599 16.3358 15.1921ZM14.568 15.2544C14.1881 15.3383 13.8179 15.4612 13.4633 15.6211L13.7633 14.9461C14.0633 14.2711 14.3745 13.3509 14.3745 13.3509C14.7325 13.9534 15.149 14.5191 15.618 15.0399C15.2643 15.0926 14.9138 15.1647 14.568 15.2559V15.2544ZM13.6215 10.3794C13.6215 9.66761 13.8518 9.47336 14.031 9.47336C14.2103 9.47336 14.412 9.55961 14.4188 10.1776C14.3604 10.799 14.2302 11.4116 14.031 12.0031C13.7581 11.5065 13.6169 10.9483 13.6208 10.3816L13.6215 10.3794ZM10.1348 18.2664C9.40126 17.8276 11.673 16.4769 12.0848 16.4334C12.0825 16.4341 10.9028 18.7254 10.1348 18.2664ZM19.425 15.6721C19.4175 15.5971 19.35 14.7669 17.8725 14.8021C17.2567 14.7922 16.6411 14.8356 16.0328 14.9319C15.4435 14.3382 14.936 13.6685 14.5238 12.9406C14.7835 12.1902 14.9406 11.4081 14.991 10.6156C14.9693 9.71561 14.754 9.19961 14.064 9.20711C13.374 9.21461 13.2735 9.81836 13.3643 10.7169C13.4532 11.3206 13.6208 11.9102 13.863 12.4704C13.863 12.4704 13.5443 13.4626 13.1228 14.4496C12.7013 15.4366 12.4133 15.9541 12.4133 15.9541C11.6803 16.1927 10.9903 16.5472 10.3695 17.0041C9.75151 17.5794 9.50026 18.0211 9.82576 18.4629C10.1063 18.8439 11.088 18.9301 11.9655 17.7804C12.4318 17.1865 12.8577 16.5621 13.2405 15.9114C13.2405 15.9114 14.5785 15.5446 14.9948 15.4441C15.411 15.3436 15.9143 15.2641 15.9143 15.2641C15.9143 15.2641 17.136 16.4934 18.3143 16.4499C19.4925 16.4064 19.4355 15.7456 19.428 15.6736"
        fill="#DD2025"
      />
      <path
        d="M17.9655 1.55859V5.96334H22.1902L17.9655 1.55859Z"
        fill="#909090"
      />
      <path d="M18.0232 1.5V5.90475H22.2479L18.0232 1.5Z" fill="#F4F4F4" />
      <path
        d="M6.73123 3.34339H5.75098V6.94339H6.52498V5.72989L6.69598 5.73964C6.8614 5.73679 7.02528 5.70716 7.18123 5.65189C7.31794 5.60484 7.44372 5.5306 7.55098 5.43364C7.65928 5.341 7.74453 5.22443 7.79998 5.09314C7.8752 4.87451 7.90207 4.64216 7.87873 4.41214C7.87404 4.24782 7.84523 4.08508 7.79323 3.92914C7.74588 3.81657 7.67562 3.71509 7.58691 3.63116C7.4982 3.54723 7.39299 3.48268 7.27798 3.44164C7.17808 3.40529 7.07482 3.37891 6.96973 3.36289C6.89055 3.35067 6.81059 3.34415 6.73048 3.34339M6.58873 5.06389H6.52198V3.95389H6.66748C6.73136 3.94928 6.79547 3.95909 6.85505 3.98258C6.91464 4.00608 6.96818 4.04267 7.01173 4.08964C7.10197 4.2104 7.15017 4.35739 7.14898 4.50814C7.14898 4.69264 7.14898 4.85989 6.98248 4.97764C6.86253 5.04361 6.72599 5.07331 6.58948 5.06314M9.34198 3.33364C9.25873 3.33364 9.17773 3.33964 9.12073 3.34189L8.94448 3.34639H8.35948V6.94639H9.04798C9.3111 6.9536 9.57306 6.909 9.81898 6.81514C10.0169 6.73663 10.1922 6.61007 10.329 6.44689C10.462 6.28223 10.5575 6.09052 10.6087 5.88514C10.6676 5.65254 10.6964 5.41332 10.6942 5.17339C10.7088 4.89001 10.6868 4.60593 10.629 4.32814C10.5741 4.12366 10.4712 3.93521 10.329 3.77839C10.2174 3.65176 10.0808 3.54961 9.92773 3.47839C9.79631 3.41758 9.65807 3.37275 9.51598 3.34489C9.45947 3.33555 9.40224 3.33129 9.34498 3.33214M9.20848 6.28489H9.13348V3.98689H9.14323C9.29785 3.9691 9.45429 3.997 9.59323 4.06714C9.69497 4.14838 9.77788 4.25074 9.83623 4.36714C9.89919 4.48964 9.93549 4.62409 9.94273 4.76164C9.94948 4.92664 9.94273 5.06164 9.94273 5.17339C9.94578 5.30212 9.9375 5.43086 9.91798 5.55814C9.89486 5.68881 9.85213 5.81524 9.79123 5.93314C9.72229 6.04275 9.62916 6.13512 9.51898 6.20314C9.42644 6.26299 9.31687 6.29091 9.20698 6.28264M13.0147 3.34639H11.1922V6.94639H11.9632V5.51839H12.9382V4.84939H11.9632V4.01539H13.0132V3.34639"
        fill="white"
      />
    </svg>
  ),
  "icon-word": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6045 2.25H7.27878C7.16138 2.2499 7.04511 2.27293 6.93661 2.31777C6.8281 2.3626 6.72949 2.42837 6.64641 2.51132C6.56332 2.59426 6.49739 2.69276 6.45237 2.80119C6.40735 2.90962 6.38413 3.02585 6.38403 3.14325V7.125L14.6858 9.5625L22.5 7.125V3.14325C22.4999 3.02579 22.4767 2.90949 22.4316 2.80102C22.3866 2.69254 22.3206 2.59401 22.2374 2.51105C22.1542 2.4281 22.0555 2.36234 21.9469 2.31755C21.8384 2.27276 21.722 2.2498 21.6045 2.25Z"
        fill="#41A5EE"
      />
      <path
        d="M22.5 7.125H6.38403V12L14.6858 13.4625L22.5 12V7.125Z"
        fill="#2B7CD3"
      />
      <path
        d="M6.38403 12V16.875L14.1975 17.85L22.5 16.875V12H6.38403Z"
        fill="#185ABD"
      />
      <path
        d="M7.27878 21.75H21.6038C21.7213 21.7503 21.8377 21.7274 21.9464 21.6827C22.0551 21.6379 22.1539 21.5722 22.2371 21.4892C22.3204 21.4062 22.3864 21.3077 22.4316 21.1992C22.4767 21.0906 22.4999 20.9743 22.5 20.8568V16.875H6.38403V20.8568C6.38413 20.9742 6.40735 21.0904 6.45237 21.1988C6.49739 21.3072 6.56332 21.4057 6.64641 21.4887C6.72949 21.5716 6.8281 21.6374 6.93661 21.6822C7.04511 21.7271 7.16138 21.7501 7.27878 21.75Z"
        fill="#103F91"
      />
      <path
        opacity="0.1"
        d="M12.3255 6.15039H6.38403V18.3379H12.3255C12.5623 18.3367 12.789 18.2423 12.9567 18.0751C13.1243 17.9079 13.2193 17.6814 13.221 17.4446V7.04364C13.2193 6.80689 13.1243 6.58038 12.9567 6.41318C12.789 6.24598 12.5623 6.15157 12.3255 6.15039Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.8373 6.63672H6.38403V18.8242H11.8373C12.074 18.823 12.3008 18.7286 12.4684 18.5614C12.636 18.3942 12.731 18.1677 12.7328 17.931V7.52997C12.731 7.29322 12.636 7.06671 12.4684 6.89951C12.3008 6.73231 12.074 6.6379 11.8373 6.63672Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.8373 6.63672H6.38403V17.8492H11.8373C12.074 17.848 12.3008 17.7536 12.4684 17.5864C12.636 17.4192 12.731 17.1927 12.7328 16.956V7.52997C12.731 7.29322 12.636 7.06671 12.4684 6.89951C12.3008 6.73231 12.074 6.6379 11.8373 6.63672Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.349 6.63672H6.38403V17.8492H11.349C11.5858 17.848 11.8125 17.7536 11.9802 17.5864C12.1478 17.4192 12.2428 17.1927 12.2445 16.956V7.52997C12.2428 7.29322 12.1478 7.06671 11.9802 6.89951C11.8125 6.73231 11.5858 6.6379 11.349 6.63672Z"
        fill="black"
      />
      <path
        d="M2.3955 6.63672H11.349C11.5862 6.63652 11.8137 6.73049 11.9816 6.89799C12.1496 7.06549 12.2441 7.2928 12.2445 7.52997V16.4685C12.2441 16.7056 12.1496 16.933 11.9816 17.1004C11.8137 17.2679 11.5862 17.3619 11.349 17.3617H2.3955C2.27804 17.3619 2.16168 17.339 2.05309 17.2942C1.9445 17.2494 1.84581 17.1836 1.76264 17.1007C1.67948 17.0177 1.61348 16.9192 1.56841 16.8107C1.52334 16.7022 1.5001 16.5859 1.5 16.4685V7.52997C1.5001 7.41251 1.52334 7.29621 1.56841 7.18773C1.61348 7.07926 1.67948 6.98073 1.76264 6.89777C1.84581 6.81481 1.9445 6.74906 2.05309 6.70427C2.16168 6.65948 2.27804 6.63652 2.3955 6.63672Z"
        fill="url(#paint0_linear_1862_36458)"
      />
      <path
        d="M5.17496 13.4908C5.19221 13.6288 5.20421 13.7488 5.20946 13.8516H5.23046C5.23796 13.7541 5.25446 13.6363 5.27921 13.4991C5.30396 13.3618 5.32571 13.2456 5.34596 13.1503L6.28721 9.09509H7.50521L8.48021 13.0896C8.537 13.3367 8.57758 13.5872 8.60171 13.8396H8.61821C8.63612 13.5939 8.66994 13.3497 8.71946 13.1083L9.49871 9.08984H10.6065L9.23846 14.9008H7.94321L7.01546 11.0563C6.98846 10.9453 6.95796 10.8008 6.92396 10.6228C6.88996 10.4448 6.86896 10.3148 6.86096 10.2328H6.84521C6.83471 10.3273 6.81371 10.4676 6.78221 10.6536C6.75071 10.8403 6.72596 10.9776 6.70721 11.0676L5.83496 14.9031H4.51796L3.14246 9.09509H4.26746L5.11571 13.1586C5.14102 13.2683 5.1608 13.3792 5.17496 13.4908Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1862_36458"
          x1="3.3705"
          y1="5.93472"
          x2="10.374"
          y2="18.0637"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2368C4" />
          <stop offset="0.5" stopColor="#1A5DBE" />
          <stop offset="1" stopColor="#1146AC" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "icon-excel": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5858 3.30392H13.9882V1.51367L1.5 3.44117V20.3364L13.9882 22.4874V19.8339H21.5858C21.8158 19.8456 22.0412 19.7656 22.2125 19.6116C22.3839 19.4576 22.4872 19.242 22.5 19.0119V4.12517C22.487 3.89527 22.3836 3.67985 22.2123 3.52597C22.041 3.37209 21.8157 3.29226 21.5858 3.30392ZM21.7057 19.1484H13.9628L13.95 17.7317H15.8153V16.0817H13.9357L13.9268 15.1067H15.8153V13.4567H13.9125L13.9035 12.4817H15.8153V10.8317H13.8975V9.85667H15.8153V8.20667H13.8975V7.23167H15.8153V5.58167H13.8975V4.08167H21.7057V19.1484Z"
        fill="#20744A"
      />
      <path
        d="M16.8652 5.58008H20.1075V7.23008H16.8652V5.58008ZM16.8652 8.20583H20.1075V9.85583H16.8652V8.20583ZM16.8652 10.8316H20.1075V12.4816H16.8652V10.8316ZM16.8652 13.4573H20.1075V15.1073H16.8652V13.4573ZM16.8652 16.0831H20.1075V17.7331H16.8652V16.0831Z"
        fill="#20744A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.76019 8.00433L6.36969 7.91208L7.38144 10.6938L8.57694 7.79733L10.1864 7.70508L8.23194 11.6546L10.1864 15.6138L8.48469 15.4991L7.33569 12.4811L6.18594 15.3843L4.62219 15.2463L6.43869 11.7491L4.76019 8.00433Z"
        fill="white"
      />
    </svg>
  ),
  "arrow-right-circle": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 11C0.5 13.0767 1.11581 15.1068 2.26957 16.8335C3.42332 18.5602 5.0632 19.906 6.98182 20.7007C8.90045 21.4955 11.0116 21.7034 13.0484 21.2982C15.0852 20.8931 16.9562 19.8931 18.4246 18.4246C19.8931 16.9562 20.8931 15.0852 21.2982 13.0484C21.7034 11.0116 21.4955 8.90045 20.7007 6.98182C19.906 5.0632 18.5602 3.42332 16.8335 2.26957C15.1068 1.11581 13.0767 0.5 11 0.5C8.21523 0.5 5.54451 1.60625 3.57538 3.57538C1.60625 5.54451 0.5 8.21523 0.5 11ZM5 10.25H14.1125L9.9275 6.04475L11 5L17 11L11 17L9.9275 15.9298L14.1125 11.75H5V10.25Z"
        fill="#01638D"
      />
    </svg>
  ),
  "arrow-left-circle": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 11C21.5 8.9233 20.8842 6.89323 19.7304 5.16651C18.5767 3.4398 16.9368 2.09398 15.0182 1.29926C13.0996 0.504545 10.9884 0.29661 8.95155 0.701756C6.91475 1.1069 5.04383 2.10693 3.57538 3.57538C2.10693 5.04383 1.1069 6.91475 0.701756 8.95155C0.29661 10.9884 0.504545 13.0996 1.29926 15.0182C2.09398 16.9368 3.4398 18.5767 5.16651 19.7304C6.89323 20.8842 8.9233 21.5 11 21.5C13.7848 21.5 16.4555 20.3938 18.4246 18.4246C20.3938 16.4555 21.5 13.7848 21.5 11ZM17 11.75L7.8875 11.75L12.0725 15.9553L11 17L5 11L11 5L12.0725 6.07025L7.8875 10.25L17 10.25V11.75Z"
        fill="#01638D"
      />
    </svg>
  ),
  "reload-yellow": (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.05273V10.0527H7"
        stroke="#FFA800"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 20.0527V14.0527H17"
        stroke="#FFA800"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.49 9.05232C19.9828 7.61911 19.1209 6.33772 17.9845 5.32774C16.8482 4.31776 15.4745 3.61209 13.9917 3.27658C12.5089 2.94107 10.9652 2.98666 9.50481 3.4091C8.04437 3.83153 6.71475 4.61704 5.64 5.69232L1 10.0523M23 14.0523L18.36 18.4123C17.2853 19.4876 15.9556 20.2731 14.4952 20.6955C13.0348 21.118 11.4911 21.1636 10.0083 20.8281C8.52547 20.4926 7.1518 19.7869 6.01547 18.7769C4.87913 17.7669 4.01717 16.4855 3.51 15.0523"
        stroke="#FFA800"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "filter-close": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_236_25401)">
        <path
          d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z"
          fill="#01638D"
        />
      </g>
      <defs>
        <clipPath id="clip0_236_25401">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  png: (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8696 7.28832H15.412V5.08039C15.4117 5.06659 15.4103 5.05283 15.4079 5.03922C15.4087 4.95042 15.3773 4.86435 15.3195 4.79689L11.6455 0.600418L11.6428 0.597718C11.6208 0.573954 11.5958 0.553086 11.5686 0.535618L11.5443 0.520768C11.5209 0.507793 11.4962 0.497382 11.4707 0.489718L11.4504 0.482968C11.4224 0.475976 11.3936 0.47235 11.3647 0.472168H2.33522C1.9228 0.472168 1.588 0.807643 1.588 1.21939V7.28764H1.13035C0.5404 7.28764 0.0625 7.76554 0.0625 8.35549V13.9094C0.0625 14.4987 0.5404 14.9772 1.13035 14.9772H1.588V18.7788C1.588 19.1906 1.9228 19.5261 2.33522 19.5261H14.6648C15.0765 19.5261 15.412 19.1906 15.412 18.7788V14.9772H15.8696C16.4596 14.9772 16.9375 14.4993 16.9375 13.9094V8.35549C16.9375 7.76622 16.4589 7.28832 15.8696 7.28832ZM2.33522 1.22007H10.9908V5.04327C10.9908 5.24982 11.1581 5.41722 11.3647 5.41722H14.6655V7.28899H2.33522V1.22007ZM6.9124 12.3832V14.0268H5.77975V8.57014H7.22087L7.8412 9.66567L8.35353 10.5702C8.67685 11.1453 8.99275 11.8243 9.24385 12.4406H9.25938C9.18715 11.7204 9.16218 10.9833 9.16218 10.1577V8.57082H10.2955V14.0275H9.00085L8.51148 13.1439L7.84053 11.933L7.83512 11.9229C7.5118 11.3316 7.14663 10.6356 6.8881 9.99574H6.8557C6.8962 10.7234 6.9124 11.4929 6.9124 12.3832ZM2.29608 12.0673V14.0262H1.07365V8.64304C1.45368 8.57824 1.9876 8.52964 2.7409 8.52964C3.5023 8.52964 4.045 8.67544 4.40883 8.97514C4.76523 9.24177 4.99203 9.69537 4.99203 10.2293C4.99203 10.772 4.82193 11.2256 4.48983 11.5246C4.0693 11.9134 3.4456 12.0997 2.71727 12.0997C2.57614 12.1033 2.435 12.0925 2.29608 12.0673ZM14.6648 18.5777H2.33522V14.9779H14.6648V18.5777ZM15.9264 13.7757C15.5457 13.9053 14.8254 14.0835 14.1052 14.0835C13.1089 14.0835 12.3887 13.8324 11.8872 13.3552C11.3931 12.8773 11.1177 12.1645 11.1177 11.3633C11.1258 9.54957 12.4454 8.51344 14.2341 8.51344C14.9388 8.51344 15.4809 8.65114 15.7482 8.77264L15.489 9.76894C15.1893 9.63124 14.8254 9.53404 14.226 9.53404C13.198 9.53404 12.4123 10.1166 12.4123 11.2985C12.4123 12.4325 13.1251 13.0872 14.1369 13.0872C14.4116 13.0872 14.6385 13.0548 14.7363 13.015V11.8655H13.8939V10.9016H15.9264V13.7757Z"
        fill="#DD2025"
      />
    </svg>
  ),
  pdf: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 190 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1856_19844)">
        <path
          d="M172.569 76.255C173.44 77.0636 174.25 77.9344 175.121 78.7429C179.915 83.5322 184.708 88.3215 189.44 93.0485C189.813 93.4217 189.938 93.7327 189.938 94.2303C189.938 120.105 189.938 145.979 189.938 171.854C189.938 172.538 189.751 172.662 189.128 172.662C183.961 172.662 178.732 172.662 173.565 172.662C173.191 172.662 172.88 172.662 172.507 172.724C169.145 172.662 165.783 172.662 162.421 172.724C162.048 172.724 161.674 172.662 161.301 172.662C117.038 172.662 72.7752 172.662 28.4502 172.662C28.0767 172.662 27.7654 172.662 27.3919 172.724C24.0301 172.724 20.6684 172.724 17.3067 172.724C16.9954 172.724 16.6841 172.662 16.3729 172.662C11.2058 172.662 6.03866 172.662 0.933812 172.662C0.186761 172.662 -0.0622559 172.476 -0.0622559 171.729C-0.0622559 156.491 -0.0622559 141.252 -0.0622559 125.951C-0.0622559 115.44 -0.0622559 104.866 -0.0622559 94.3547C-0.0622559 93.7327 0.124507 93.3595 0.560287 92.9241C5.97641 87.5751 11.3303 82.1638 16.6841 76.8148C16.8709 76.6282 17.1199 76.4416 17.3067 76.255C17.3067 77.499 17.3689 78.6807 17.3689 79.9247C17.3689 84.2164 17.3689 88.5081 17.3689 92.7375C17.3689 93.1729 17.3067 93.6083 17.9915 93.5461C21.1664 93.4839 24.2792 93.4839 27.4541 93.4839C27.7654 93.4839 28.0767 93.4839 28.3879 93.4839C72.713 93.4839 117.038 93.4839 161.363 93.4839C161.737 93.4839 162.048 93.4839 162.421 93.4839C165.472 93.4839 168.46 93.4839 171.51 93.5461C172.32 93.5461 172.444 93.2973 172.444 92.5509C172.444 87.4507 172.444 82.2882 172.444 77.188C172.507 76.9392 172.569 76.6282 172.569 76.255ZM77.0085 136.525C77.0085 144.238 77.0085 151.95 77.0085 159.663C77.0085 160.409 77.1953 160.534 77.9423 160.534C82.3624 160.471 86.7824 160.534 91.2025 160.534C95.5603 160.534 99.9803 160.347 104.276 159.476C111.871 157.921 117.474 153.754 120.524 146.539C122.516 141.812 122.765 136.898 122.018 131.86C120.898 124.272 116.851 118.799 110.003 115.378C105.894 113.325 101.412 112.89 96.9299 112.641C90.6422 112.268 84.2923 112.517 77.9423 112.454C77.1953 112.454 77.0085 112.641 77.0085 113.325C77.0085 121.1 77.0085 128.813 77.0085 136.525ZM28.7615 136.525C28.7615 144.238 28.7615 151.95 28.7615 159.663C28.7615 160.347 28.886 160.596 29.633 160.596C33.1815 160.534 36.73 160.534 40.2785 160.596C41.0256 160.596 41.2123 160.471 41.2123 159.725C41.1501 154.687 41.2123 149.649 41.1501 144.611C41.1501 143.927 41.3368 143.802 41.9594 143.802C44.5118 143.864 47.002 143.802 49.5544 143.802C51.7955 143.802 54.0367 143.616 56.2156 143.056C60.5734 142.061 64.1841 140.008 66.4253 135.965C67.9816 133.166 68.3552 130.056 68.2307 126.947C67.9194 120.602 64.4954 116 58.519 113.885C55.7798 112.952 52.9784 112.517 50.1147 112.517C43.2667 112.454 36.3565 112.517 29.5085 112.454C28.886 112.454 28.7615 112.641 28.7615 113.263C28.7615 121.038 28.7615 128.75 28.7615 136.525ZM131.73 136.525C131.73 144.238 131.73 152.012 131.73 159.725C131.73 160.347 131.855 160.534 132.539 160.534C136.15 160.471 139.699 160.471 143.309 160.534C144.056 160.534 144.181 160.347 144.181 159.601C144.181 153.381 144.181 147.223 144.119 141.003C144.119 140.195 144.368 140.008 145.115 140.008C151.091 140.008 157.067 140.008 163.044 140.008C163.666 140.008 163.915 139.884 163.915 139.2C163.853 136.587 163.853 134.037 163.915 131.425C163.915 130.741 163.729 130.554 163.044 130.554C157.005 130.554 150.967 130.554 144.928 130.616C144.243 130.616 144.056 130.43 144.056 129.745C144.119 127.382 144.119 125.018 144.056 122.655C144.056 121.909 144.305 121.846 144.928 121.846C151.34 121.846 157.815 121.846 164.227 121.846C164.849 121.846 165.098 121.722 165.036 121.038C164.974 118.425 164.974 115.875 165.036 113.263C165.036 112.517 164.849 112.33 164.164 112.33C153.644 112.33 143.06 112.33 132.539 112.33C131.792 112.33 131.668 112.517 131.668 113.201C131.792 121.1 131.73 128.813 131.73 136.525Z"
          fill="#EC1C24"
        />
        <path
          d="M27.5163 93.6083C24.3414 93.6083 21.2287 93.6083 18.0537 93.6705C17.3689 93.6705 17.4312 93.2973 17.4312 92.862C17.4312 88.5703 17.4312 84.2786 17.4312 80.0491C17.4312 78.8052 17.3689 77.6234 17.3689 76.3794C17.3689 61.3275 17.3689 46.2133 17.3689 31.1613C17.3689 21.1474 17.3689 11.0713 17.3689 1.05736C17.3689 0.248786 17.5557 0.12439 18.3027 0.12439C52.0445 0.12439 85.7863 0.12439 119.528 0.12439C120.213 0.12439 120.649 0.310984 121.147 0.80857C136.586 16.2337 152.025 31.6589 167.464 47.0841C168.958 48.5768 170.452 50.0696 172.008 51.5623C172.444 51.9977 172.631 52.4331 172.631 52.9929C172.631 60.7677 172.631 68.6047 172.631 76.3794C172.631 76.7526 172.569 77.0636 172.569 77.4368C172.569 82.537 172.569 87.6995 172.569 92.7998C172.569 93.5461 172.444 93.7949 171.635 93.7949C168.585 93.7327 165.596 93.7327 162.546 93.7327C162.546 82.2261 162.546 70.6572 162.546 59.1505C162.546 58.3419 162.359 58.1553 161.55 58.1553C146.235 58.1553 130.921 58.1553 115.544 58.2175C114.672 58.2175 114.486 58.0309 114.486 57.1602C114.486 41.8594 114.486 26.5586 114.548 11.1957C114.548 10.3871 114.299 10.2005 113.552 10.2005C85.226 10.2005 56.8381 10.2005 28.5124 10.2005C27.6408 10.2005 27.5163 10.4493 27.5163 11.2579C27.5163 38.6251 27.5163 66.1167 27.5163 93.6083Z"
          fill="#EC1C24"
        />
        <path
          d="M162.484 172.787C165.845 172.725 169.207 172.725 172.569 172.787C172.569 187.901 172.569 202.953 172.569 218.067C172.569 218.876 172.32 219.062 171.573 219.062C120.524 219.062 69.4757 219.062 18.365 219.062C17.6179 219.062 17.3689 218.938 17.3689 218.067C17.3689 202.953 17.3689 187.901 17.3689 172.787C20.7306 172.787 24.0924 172.787 27.4541 172.787C27.4541 184.542 27.4541 196.235 27.4541 207.991C27.4541 208.737 27.5786 208.924 28.3879 208.924C72.7752 208.924 117.162 208.924 161.55 208.924C162.359 208.924 162.484 208.737 162.484 207.991C162.484 196.235 162.484 184.542 162.484 172.787Z"
          fill="#EC1C24"
        />
        <path
          d="M89.4595 136.525C89.4595 131.922 89.4595 127.32 89.4595 122.717C89.4595 122.095 89.584 121.909 90.2065 121.971C93.3815 122.033 96.5565 121.846 99.6692 122.655C105.397 124.148 108.821 128.128 109.443 133.975C109.692 136.463 109.63 138.951 109.007 141.439C107.762 146.228 104.65 149.151 99.9804 150.458C96.681 151.39 93.257 151.142 89.8953 151.204C89.2727 151.204 89.5217 150.769 89.5217 150.458C89.4595 145.793 89.4595 141.128 89.4595 136.525Z"
          fill="#EC1C24"
        />
        <path
          d="M41.15 128.191C41.15 126.138 41.15 124.148 41.15 122.095C41.15 121.784 41.0877 121.473 41.5857 121.473C44.3249 121.598 47.1264 121.287 49.8655 121.66C53.414 122.157 55.4684 124.521 55.4684 128.191C55.4684 131.86 53.4763 134.286 49.8655 134.784C47.1264 135.157 44.3249 134.846 41.5857 134.97C41.0877 134.97 41.15 134.659 41.15 134.348C41.15 132.233 41.15 130.181 41.15 128.191Z"
          fill="#EC1C24"
        />
      </g>
      <defs>
        <clipPath id="clip0_1856_19844">
          <rect width="190" height="219" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  jpg: (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.36799 9.55185C8.18129 9.54672 7.99471 9.56542 7.8128 9.6075V11.4219C7.92785 11.4503 8.06823 11.4587 8.26244 11.4587C8.9749 11.4587 9.41609 11.0849 9.41609 10.4559C9.41609 9.8889 9.03612 9.55185 8.36799 9.55185ZM17.8632 7.5117H17.3207L17.3492 5.5272C17.3458 5.41122 17.3009 5.30027 17.2225 5.2143L12.5615 0.1407C12.524 0.0981358 12.4782 0.0636821 12.4268 0.0394781C12.3754 0.0152741 12.3196 0.00183667 12.2628 0L2.50998 0C2.29131 0.00349236 2.08254 0.0912463 1.9276 0.244789C1.77266 0.398332 1.68365 0.605685 1.67931 0.8232V7.5117H1.13573C0.83491 7.5117 0.544649 7.6356 0.333549 7.8561C0.118164 8.0802 -0.00140664 8.3787 1.24892e-05 8.68875V14.8103C1.24892e-05 15.4592 0.508762 15.9862 1.13573 15.9862H1.67931V20.1758C1.6834 20.3938 1.77258 20.6017 1.928 20.7556C2.08341 20.9094 2.29288 20.997 2.51209 21H16.527C16.965 21 17.3503 20.6304 17.3503 20.1768V15.9873H17.8643C18.4912 15.9873 19 15.4592 19 14.8092V8.6877C19 8.3769 18.8807 8.0766 18.6675 7.8561C18.5641 7.74781 18.4397 7.66147 18.3018 7.60228C18.164 7.5431 18.0155 7.51228 17.8653 7.5117H17.8632ZM3.11373 1.4469H10.4558V6.25275C10.4554 6.36096 10.4969 6.46515 10.5719 6.5436C10.6082 6.58161 10.6519 6.61191 10.7004 6.63266C10.7488 6.65342 10.8009 6.66419 10.8537 6.66435H15.8768V7.5117H3.11373V1.4469ZM10.745 10.4192C10.745 11.0208 10.5508 11.5322 10.1993 11.8787C9.74119 12.326 9.06356 12.5265 8.27088 12.5265C8.09461 12.5265 7.93629 12.5171 7.8128 12.4992V14.6979H6.57787V8.631C6.99268 8.5575 7.47926 8.5029 8.29832 8.5029C9.12478 8.5029 9.7148 8.66775 10.1106 8.9964C10.4895 9.30615 10.7439 9.81645 10.7439 10.4192H10.745ZM2.52054 13.5303C2.70525 13.5933 2.94274 13.6395 3.20661 13.6395C3.77025 13.6395 4.12173 13.3749 4.12173 12.4173V8.5491H5.46009V12.4341C5.46009 14.1876 4.64947 14.7977 3.34699 14.7977C3.01608 14.7973 2.68706 14.7481 2.37066 14.6517L2.52054 13.5303ZM3.11373 19.5531V15.9862H15.8768V19.5531H3.11373ZM16.5544 14.4144C15.9165 14.6331 15.2479 14.7501 14.5732 14.7609C13.4914 14.7609 12.7082 14.4785 12.1625 13.9314C11.6168 13.4022 11.317 12.6 11.3255 11.696C11.335 9.65265 12.7694 8.48505 14.7147 8.48505C15.481 8.48505 16.071 8.6394 16.3613 8.78535L16.0794 9.89835C15.7533 9.7524 15.348 9.63375 14.6967 9.63375C13.579 9.63375 12.7335 10.291 12.7335 11.6235C12.7335 12.8909 13.4998 13.6395 14.6007 13.6395C14.9089 13.6395 15.1548 13.6028 15.2604 13.5482V12.2619H14.3453V11.1762H16.5544V14.4144ZM11.9176 1.596L12.324 2.0517L15.0472 5.04735L15.1981 5.229H12.4148C12.2037 5.229 12.0717 5.19435 12.0158 5.124C11.9598 5.05575 11.9271 4.9455 11.9176 4.79535V1.596Z"
        fill="#DD2025"
      />
    </svg>
  ),
  "import-cloud": (
    <svg
      width="36"
      height="29"
      viewBox="0 0 36 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.1982 11.84C29.4098 11.1296 29.6214 10.4192 29.6214 9.472C29.6214 4.2624 25.8129 0 21.1581 0C17.9844 0 15.0223 2.1312 13.7528 5.2096C13.118 4.9728 12.2717 4.736 11.637 4.736C8.67483 4.736 6.34743 7.3408 6.34743 10.656C6.34743 11.1296 6.34743 11.6032 6.55901 11.84C2.75055 12.5504 0 15.8656 0 20.128C0 24.6272 3.3853 28.416 7.40534 28.416H14.8107V21.312H8.46324L17.9844 10.656L27.5055 21.312H21.1581V28.416H28.5634C32.5835 28.416 35.9688 24.6272 35.9688 20.128C35.9688 15.8656 33.0067 12.3136 29.1982 11.84Z"
        fill="#01638D"
      />
    </svg>
  ),
  export: (
    <svg
      width="71"
      height="69"
      viewBox="0 0 71 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8335 10.0625L59.1668 10.0625C62.421 10.0625 65.0835 12.65 65.0835 15.8125V50.3125C65.0835 53.475 62.421 56.0625 59.1668 56.0625H11.8335C8.57933 56.0625 5.91682 53.475 5.91682 50.3125V15.8125C5.91682 12.65 8.57933 10.0625 11.8335 10.0625Z"
        fill="#C5DDFD"
      />
      <path d="M36.5 65.3813L23.1875 50H49.8125L36.5 65.3813Z" fill="#3689FC" />
      <path
        d="M40.9375 24.125V57.1875H32.0625V24.125H40.9375Z"
        fill="#3689FC"
      />
    </svg>
  ),
  "warning-denied": (
    <svg
      width="84"
      height="84"
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.9999 0.333496C18.9583 0.333496 0.333252 18.9585 0.333252 42.0002C0.333252 65.0418 18.9583 83.6668 41.9999 83.6668C65.0416 83.6668 83.6666 65.0418 83.6666 42.0002C83.6666 18.9585 65.0416 0.333496 41.9999 0.333496ZM41.9999 75.3335C23.6249 75.3335 8.66658 60.3752 8.66658 42.0002C8.66658 23.6252 23.6249 8.66683 41.9999 8.66683C60.3749 8.66683 75.3332 23.6252 75.3332 42.0002C75.3332 60.3752 60.3749 75.3335 41.9999 75.3335ZM56.9583 21.1668L41.9999 36.1252L27.0416 21.1668L21.1666 27.0418L36.1249 42.0002L21.1666 56.9585L27.0416 62.8335L41.9999 47.8752L56.9583 62.8335L62.8332 56.9585L47.8749 42.0002L62.8332 27.0418L56.9583 21.1668Z"
        fill="#FF6569"
      />
    </svg>
  ),
  "solid-warning": (
    <svg
      width="92"
      height="80"
      viewBox="0 0 92 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.166626 79.5002H91.8333L46 0.333496L0.166626 79.5002ZM50.1666 67.0002H41.8333V58.6668H50.1666V67.0002ZM50.1666 50.3335H41.8333V33.6668H50.1666V50.3335Z"
        fill="#FFA800"
      />
    </svg>
  ),
  "solid-folder": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6H11L9 4H4C2.9 4 2 4.9 2 6V10H22V8C22 6.9 21.1 6 20 6Z"
        fill="#FFA000"
      />
      <path
        d="M20 6H4C2.9 6 2 6.9 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6Z"
        fill="#FFCA28"
      />
    </svg>
  ),
  "thumb-up": (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 20H17C17.83 20 18.54 19.5 18.84 18.78L21.86 11.73C21.95 11.5 22 11.26 22 11V9C22 7.9 21.1 7 20 7H13.69L14.64 2.43L14.67 2.11C14.67 1.7 14.5 1.32 14.23 1.05L13.17 0L6.58 6.59C6.22 6.95 6 7.45 6 8V18C6 19.1 6.9 20 8 20ZM8 8L12.34 3.66L11 9H20V11L17 18H8V8ZM0 8H4V20H0V8Z"
        fill="#01638D"
      />
    </svg>
  ),
  "red-x": (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
        fill="#CE3135"
      />
    </svg>
  ),
  upload: (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0H2C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM2 18V2H9V7H14V18H2Z"
        fill="white"
      />
    </svg>
  ),
  "close-blue-outline": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_389_44468)">
        <mask
          id="mask0_389_44468"
          style={{ maskType: "luminance" }}
          maskUnits={"userSpaceOnUse"}
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <path
            d="M7.99998 14.6668C11.682 14.6668 14.6666 11.6822 14.6666 8.00016C14.6666 4.31816 11.682 1.3335 7.99998 1.3335C4.31798 1.3335 1.33331 4.31816 1.33331 8.00016C1.33331 11.6822 4.31798 14.6668 7.99998 14.6668Z"
            fill="white"
            stroke="white"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M9.88565 6.11426L6.11432 9.88559M6.11432 6.11426L9.88565 9.88559"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </mask>
        <g mask="url(#mask0_389_44468)">
          <path d="M0 0H16V16H0V0Z" fill="#3699FF" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_389_44468">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "close-blue-circle": (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1.375C5.6375 1.375 1.375 5.6375 1.375 11C1.375 16.3625 5.6375 20.625 11 20.625C16.3625 20.625 20.625 16.3625 20.625 11C20.625 5.6375 16.3625 1.375 11 1.375ZM11 19.25C6.4625 19.25 2.75 15.5375 2.75 11C2.75 6.4625 6.4625 2.75 11 2.75C15.5375 2.75 19.25 6.4625 19.25 11C19.25 15.5375 15.5375 19.25 11 19.25Z"
        fill="#01638D"
      />
      <path
        d="M14.7125 15.8125L11 12.1L7.2875 15.8125L6.1875 14.7125L9.9 11L6.1875 7.2875L7.2875 6.1875L11 9.9L14.7125 6.1875L15.8125 7.2875L12.1 11L15.8125 14.7125L14.7125 15.8125Z"
        fill="#01638D"
      />
    </svg>
  ),
  "check-blue-circle": (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7031 10.4844C17.0469 13.7656 14.5728 16.8552 11.1013 17.5456C9.40813 17.8828 7.65177 17.6772 6.08227 16.9581C4.51278 16.2391 3.21015 15.0431 2.35988 13.5406C1.50961 12.0382 1.15504 10.3057 1.34665 8.59001C1.53827 6.87429 2.2663 5.26276 3.42708 3.98487C5.80796 1.3625 9.82814 0.640624 13.1094 1.95312"
        stroke="#1574F6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.54688 9.17188L9.82812 12.4531L17.7031 3.92188"
        stroke="#1574F6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "view-blue": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_236_23755)">
        <path
          d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.8 17.5 12 17.5C8.2 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z"
          fill="#1574F6"
        />
      </g>
      <defs>
        <clipPath id="clip0_236_23755">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "like-blue": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_241_24170)">
        <path
          d="M9 21H18C18.83 21 19.54 20.5 19.84 19.78L22.86 12.73C22.95 12.5 23 12.26 23 12V10C23 8.9 22.1 8 21 8H14.69L15.64 3.43L15.67 3.11C15.67 2.7 15.5 2.32 15.23 2.05L14.17 1L7.58 7.59C7.22 7.95 7 8.45 7 9V19C7 20.1 7.9 21 9 21ZM9 9L13.34 4.66L12 10H21V12L18 19H9V9ZM1 9H5V21H1V9Z"
          fill="#01638D"
        />
      </g>
      <defs>
        <clipPath id="clip0_241_24170">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "delete-profile": (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_368_44812)">
        <path d="M0 0H100V100H0V0Z" fill="white" />
        <path
          d="M66.6666 37.5V79.1667H33.3333V37.5H66.6666ZM60.4166 12.5H39.5833L35.4166 16.6667H20.8333V25H79.1666V16.6667H64.5833L60.4166 12.5ZM74.9999 29.1667H24.9999V79.1667C24.9999 83.75 28.7499 87.5 33.3333 87.5H66.6666C71.2499 87.5 74.9999 83.75 74.9999 79.1667V29.1667Z"
          fill="#FF6569"
        />
      </g>
      <defs>
        <clipPath id="clip0_368_44812">
          <rect width="100" height="100" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "company-blue": (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.49705 12.602C3.59199 12.5969 3.68697 12.6113 3.77619 12.6441C3.86542 12.6769 3.94702 12.7276 4.01602 12.793C4.08502 12.8584 4.13998 12.9372 4.17753 13.0245C4.21509 13.1119 4.23445 13.2059 4.23445 13.301C4.23445 13.3961 4.21509 13.4902 4.17753 13.5775C4.13998 13.6649 4.08502 13.7436 4.01602 13.8091C3.94702 13.8745 3.86542 13.9251 3.77619 13.958C3.68697 13.9908 3.59199 14.0051 3.49705 14H0.70005C0.60511 14.0051 0.510131 13.9908 0.420906 13.958C0.33168 13.9251 0.250078 13.8745 0.181077 13.8091C0.112076 13.7436 0.0571228 13.6649 0.0195686 13.5775C-0.0179857 13.4902 -0.0373535 13.3961 -0.0373535 13.301C-0.0373535 13.2059 -0.0179857 13.1119 0.0195686 13.0245C0.0571228 12.9372 0.112076 12.8584 0.181077 12.793C0.250078 12.7276 0.33168 12.6769 0.420906 12.6441C0.510131 12.6113 0.60511 12.5969 0.70005 12.602H3.49705ZM19.3 12.602C19.395 12.5969 19.49 12.6113 19.5792 12.6441C19.6684 12.6769 19.75 12.7276 19.819 12.793C19.888 12.8584 19.943 12.9372 19.9805 13.0245C20.0181 13.1119 20.0375 13.2059 20.0375 13.301C20.0375 13.3961 20.0181 13.4902 19.9805 13.5775C19.943 13.6649 19.888 13.7436 19.819 13.8091C19.75 13.8745 19.6684 13.9251 19.5792 13.958C19.49 13.9908 19.395 14.0051 19.3 14H5.52905C5.43411 14.0051 5.33913 13.9908 5.24991 13.958C5.16068 13.9251 5.07908 13.8745 5.01008 13.8091C4.94108 13.7436 4.88612 13.6649 4.84857 13.5775C4.81101 13.4902 4.79165 13.3961 4.79165 13.301C4.79165 13.2059 4.81101 13.1119 4.84857 13.0245C4.88612 12.9372 4.94108 12.8584 5.01008 12.793C5.07908 12.7276 5.16068 12.6769 5.24991 12.6441C5.33913 12.6113 5.43411 12.5969 5.52905 12.602H19.3ZM3.49705 6.33402C3.59113 6.33047 3.68497 6.34592 3.77294 6.37947C3.86091 6.41302 3.94121 6.46398 4.00903 6.52928C4.07686 6.59459 4.13081 6.6729 4.16766 6.75955C4.20451 6.84619 4.2235 6.93937 4.2235 7.03352C4.2235 7.12768 4.20451 7.22086 4.16766 7.3075C4.13081 7.39414 4.07686 7.47246 4.00903 7.53776C3.94121 7.60307 3.86091 7.65402 3.77294 7.68757C3.68497 7.72112 3.59113 7.73658 3.49705 7.73302H0.70005C0.605965 7.73658 0.512129 7.72112 0.424157 7.68757C0.336186 7.65402 0.255887 7.60307 0.188065 7.53776C0.120243 7.47246 0.0662923 7.39414 0.0294414 7.3075C-0.0074094 7.22086 -0.0264031 7.12768 -0.0264031 7.03352C-0.0264031 6.93937 -0.0074094 6.84619 0.0294414 6.75955C0.0662923 6.6729 0.120243 6.59459 0.188065 6.52928C0.255887 6.46398 0.336186 6.41302 0.424157 6.37947C0.512129 6.34592 0.605965 6.33047 0.70005 6.33402H3.49705ZM19.3 6.33402C19.3941 6.33047 19.488 6.34592 19.5759 6.37947C19.6639 6.41302 19.7442 6.46398 19.812 6.52928C19.8799 6.59459 19.9338 6.6729 19.9707 6.75955C20.0075 6.84619 20.0265 6.93937 20.0265 7.03352C20.0265 7.12768 20.0075 7.22086 19.9707 7.3075C19.9338 7.39414 19.8799 7.47246 19.812 7.53776C19.7442 7.60307 19.6639 7.65402 19.5759 7.68757C19.488 7.72112 19.3941 7.73658 19.3 7.73302H5.52805C5.43396 7.73658 5.34013 7.72112 5.25216 7.68757C5.16419 7.65402 5.08389 7.60307 5.01606 7.53776C4.94824 7.47246 4.89429 7.39414 4.85744 7.3075C4.82059 7.22086 4.8016 7.12768 4.8016 7.03352C4.8016 6.93937 4.82059 6.84619 4.85744 6.75955C4.89429 6.6729 4.94824 6.59459 5.01606 6.52928C5.08389 6.46398 5.16419 6.41302 5.25216 6.37947C5.34013 6.34592 5.43396 6.33047 5.52805 6.33402H19.3ZM3.49705 2.34838e-05C3.59199 -0.00505668 3.68697 0.00925649 3.77619 0.0420901C3.86542 0.0749236 3.94702 0.125589 4.01602 0.190997C4.08502 0.256404 4.13998 0.335182 4.17753 0.422526C4.21509 0.50987 4.23445 0.603948 4.23445 0.699023C4.23445 0.794098 4.21509 0.888177 4.17753 0.975521C4.13998 1.06286 4.08502 1.14164 4.01602 1.20705C3.94702 1.27246 3.86542 1.32312 3.77619 1.35596C3.68697 1.38879 3.59199 1.4031 3.49705 1.39802H0.70005C0.60511 1.4031 0.510131 1.38879 0.420906 1.35596C0.33168 1.32312 0.250078 1.27246 0.181077 1.20705C0.112076 1.14164 0.0571228 1.06286 0.0195686 0.975521C-0.0179857 0.888177 -0.0373535 0.794098 -0.0373535 0.699023C-0.0373535 0.603948 -0.0179857 0.50987 0.0195686 0.422526C0.0571228 0.335182 0.112076 0.256404 0.181077 0.190997C0.250078 0.125589 0.33168 0.0749236 0.420906 0.0420901C0.510131 0.00925649 0.60511 -0.00505668 0.70005 2.34838e-05H3.49705ZM19.3 2.34838e-05C19.395 -0.00505668 19.49 0.00925649 19.5792 0.0420901C19.6684 0.0749236 19.75 0.125589 19.819 0.190997C19.888 0.256404 19.943 0.335182 19.9805 0.422526C20.0181 0.50987 20.0375 0.603948 20.0375 0.699023C20.0375 0.794098 20.0181 0.888177 19.9805 0.975521C19.943 1.06286 19.888 1.14164 19.819 1.20705C19.75 1.27246 19.6684 1.32312 19.5792 1.35596C19.49 1.38879 19.395 1.4031 19.3 1.39802H5.52805C5.43311 1.4031 5.33813 1.38879 5.24891 1.35596C5.15968 1.32312 5.07808 1.27246 5.00908 1.20705C4.94008 1.14164 4.88512 1.06286 4.84757 0.975521C4.81001 0.888177 4.79065 0.794098 4.79065 0.699023C4.79065 0.603948 4.81001 0.50987 4.84757 0.422526C4.88512 0.335182 4.94008 0.256404 5.00908 0.190997C5.07808 0.125589 5.15968 0.0749236 5.24891 0.0420901C5.33813 0.00925649 5.43311 -0.00505668 5.52805 2.34838e-05H19.3Z"
        fill="#01638D"
      />
    </svg>
  ),
  "history-orege": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_230_34553)">
        <path
          d="M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.25 15.52L17.02 14.24L13.5 12.15V8H12Z"
          fill="#FFA800"
        />
      </g>
      <defs>
        <clipPath id="clip0_230_34553">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "pen-green": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.71 5.03957L14.37 7.36957L10.62 3.61957L12.96 1.28957C13.35 0.89957 14 0.89957 14.37 1.28957L16.71 3.62957C17.1 3.99957 17.1 4.64957 16.71 5.03957ZM0 14.2496L10.06 4.17957L13.81 7.92957L3.75 17.9996H0V14.2496ZM13.62 2.03957L12.08 3.57957L14.42 5.91957L15.96 4.37957L13.62 2.03957ZM12.36 7.99957L10 5.63957L1 14.6596V16.9996H3.34L12.36 7.99957Z"
        fill="#219653"
      />
    </svg>
  ),
  unlock: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 10H4.6C4.44087 10 4.28826 10.0632 4.17574 10.1757C4.06321 10.2883 4 10.4409 4 10.6V17.4C4 17.5591 4.06321 17.7117 4.17574 17.8243C4.28826 17.9368 4.44087 18 4.6 18H15.4C15.5591 18 15.7117 17.9368 15.8243 17.8243C15.9368 17.7117 16 17.5591 16 17.4V16.5M8.131 2.385C8.637 2.145 9.253 2 10 2C13.2 2 14 4.667 14 6V10H15.4C15.5591 10 15.7117 10.0632 15.8243 10.1757C15.9368 10.2883 16 10.4409 16 10.6V11M6 6V10M1 1L19 19"
        stroke="#1574F6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  lock: (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33333 6.47619V5.05952C2.33333 2.3031 4.28011 0 7 0C9.71989 0 11.6667 2.3031 11.6667 5.05952V6.47619H12.0556C12.5713 6.47619 13.0658 6.68941 13.4305 7.06895C13.7951 7.44849 14 7.96325 14 8.5V14.9762C14 15.5129 13.7951 16.0277 13.4305 16.4072C13.0658 16.7868 12.5713 17 12.0556 17H1.94444C1.42875 17 0.934169 16.7868 0.569515 16.4072C0.204861 16.0277 0 15.5129 0 14.9762V8.5C0 7.96325 0.204861 7.44849 0.569515 7.06895C0.934169 6.68941 1.42875 6.47619 1.94444 6.47619H2.33333ZM1.16667 8.5V14.9762C1.16667 15.1909 1.24861 15.3968 1.39447 15.5486C1.54033 15.7004 1.73817 15.7857 1.94444 15.7857H12.0556C12.2618 15.7857 12.4597 15.7004 12.6055 15.5486C12.7514 15.3968 12.8333 15.1909 12.8333 14.9762V8.5C12.8333 8.2853 12.7514 8.0794 12.6055 7.92758C12.4597 7.77577 12.2618 7.69048 12.0556 7.69048H1.94444C1.73817 7.69048 1.54033 7.77577 1.39447 7.92758C1.24861 8.0794 1.16667 8.2853 1.16667 8.5ZM3.5 5.05952V6.47619H10.5V5.05952C10.5 2.8981 9.00511 1.21429 7 1.21429C4.99489 1.21429 3.5 2.8981 3.5 5.05952Z"
        fill="#1574F6"
      />
    </svg>
  ),
  "delete-blue": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50073 6V15C4.50073 15.8284 5.17231 16.5 6.00073 16.5H12.0007C12.8292 16.5 13.5007 15.8284 13.5007 15V6H4.50073Z"
        fill="#3699FF"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5007 3.375V3.25C10.5007 2.69772 10.053 2.25 9.50073 2.25H8.50073C7.94845 2.25 7.50073 2.69772 7.50073 3.25V3.375H4.25073C3.97459 3.375 3.75073 3.59886 3.75073 3.875V4C3.75073 4.27614 3.97459 4.5 4.25073 4.5H13.7507C14.0269 4.5 14.2507 4.27614 14.2507 4V3.875C14.2507 3.59886 14.0269 3.375 13.7507 3.375H10.5007Z"
        fill="#3699FF"
      />
    </svg>
  ),
  "edit-blue": (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0557 3.01857C15.6503 3.57823 15.6601 4.48273 15.0776 5.05362L9.27489 10.7411C8.99139 11.0189 8.6023 11.1796 8.19308 11.1876L5.75527 11.2358L5.80674 8.9266C5.81514 8.55021 5.97833 8.19155 6.26198 7.92611L12.1938 2.37516C12.7975 1.81017 13.7732 1.81148 14.3752 2.37811L15.0557 3.01857Z"
        fill="#3699FF"
      />
      <path
        opacity="0.3"
        d="M9.13752 1.3335C9.52872 1.3335 9.84585 1.63197 9.84585 2.00016C9.84585 2.36835 9.52872 2.66683 9.13752 2.66683H4.25002C3.46762 2.66683 2.83335 3.26378 2.83335 4.00016V12.0002C2.83335 12.7365 3.46762 13.3335 4.25002 13.3335H12.75C13.5324 13.3335 14.1667 12.7365 14.1667 12.0002V8.66683C14.1667 8.29864 14.4838 8.00016 14.875 8.00016C15.2662 8.00016 15.5834 8.29864 15.5834 8.66683V12.0002C15.5834 13.4729 14.3148 14.6668 12.75 14.6668H4.25002C2.68521 14.6668 1.41669 13.4729 1.41669 12.0002V4.00016C1.41669 2.5274 2.68521 1.3335 4.25002 1.3335H9.13752Z"
        fill="#3699FF"
      />
    </svg>
  ),
  "add-blue-circle": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1C6.15042 1.02231 4.38287 1.76698 3.07493 3.07493C1.76698 4.38287 1.02231 6.15042 1 8C1.02231 9.84958 1.76698 11.6171 3.07493 12.9251C4.38287 14.233 6.15042 14.9777 8 15C9.84958 14.9777 11.6171 14.233 12.9251 12.9251C14.233 11.6171 14.9777 9.84958 15 8C14.9777 6.15042 14.233 4.38287 12.9251 3.07493C11.6171 1.76698 9.84958 1.02231 8 1ZM12 8.5H8.5V12H7.5V8.5H4V7.5H7.5V4H8.5V7.5H12V8.5Z"
        fill="#3699FF"
      />
    </svg>
  ),
  "add-blue-square": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.18126 1.0217C9.04858 0.593027 12.9514 0.593027 16.8188 1.0217C18.96 1.2617 20.6875 2.94795 20.9388 5.0967C21.3974 9.01875 21.3974 12.9809 20.9388 16.903C20.8116 17.9471 20.3355 18.9176 19.5877 19.6573C18.8399 20.3969 17.8642 20.8623 16.8188 20.978C12.9515 21.408 9.04851 21.408 5.18126 20.978C4.13582 20.8623 3.1601 20.3969 2.41228 19.6573C1.66447 18.9176 1.1884 17.9471 1.06126 16.903C0.602628 12.9813 0.602628 9.01959 1.06126 5.09795C1.18834 4.05404 1.66423 3.08363 2.4118 2.344C3.15936 1.60438 4.1348 1.13888 5.18001 1.02295L5.18126 1.0217ZM11 4.7592C11.2486 4.7592 11.4871 4.85797 11.6629 5.03379C11.8387 5.2096 11.9375 5.44806 11.9375 5.6967V10.0629H16.3038C16.5524 10.0629 16.7909 10.1617 16.9667 10.3375C17.1425 10.5134 17.2413 10.7518 17.2413 11.0005C17.2413 11.2491 17.1425 11.4875 16.9667 11.6634C16.7909 11.8392 16.5524 11.938 16.3038 11.938H11.9375V16.3042C11.9375 16.5528 11.8387 16.7913 11.6629 16.9671C11.4871 17.1429 11.2486 17.2417 11 17.2417C10.7514 17.2417 10.5129 17.1429 10.3371 16.9671C10.1613 16.7913 10.0625 16.5528 10.0625 16.3042V11.938H5.69626C5.44762 11.938 5.20916 11.8392 5.03334 11.6634C4.85753 11.4875 4.75876 11.2491 4.75876 11.0005C4.75876 10.7518 4.85753 10.5134 5.03334 10.3375C5.20916 10.1617 5.44762 10.0629 5.69626 10.0629H10.0625V5.6967C10.0625 5.44806 10.1613 5.2096 10.3371 5.03379C10.5129 4.85797 10.7514 4.7592 11 4.7592Z"
        fill="#01638D"
      />
    </svg>
  ),
  "refresh-blue-square": (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="21" height="21" rx="6" fill="#01638D" />
      <path
        d="M4.66675 15.3337V14.0003H6.50008L6.23342 13.767C5.68897 13.2225 5.29164 12.6308 5.04142 11.9917C4.79119 11.3525 4.6663 10.6999 4.66675 10.0337C4.66675 8.80033 5.0363 7.70299 5.77542 6.74166C6.51453 5.78033 7.4783 5.14433 8.66675 4.83366V6.23366C7.86675 6.52255 7.2223 7.0141 6.73342 7.70833C6.24453 8.40255 6.00008 9.17766 6.00008 10.0337C6.00008 10.5337 6.09453 11.0199 6.28342 11.4923C6.4723 11.9648 6.76675 12.4008 7.16675 12.8003L7.33342 12.967V11.3337H8.66675V15.3337H4.66675ZM11.3334 15.167V13.767C12.1334 13.4781 12.7779 12.9865 13.2667 12.2923C13.7556 11.5981 14.0001 10.823 14.0001 9.96699C14.0001 9.46699 13.9056 8.98099 13.7167 8.50899C13.5279 8.03699 13.2334 7.60077 12.8334 7.20033L12.6667 7.03366V8.66699H11.3334V4.66699H15.3334V6.00033H13.5001L13.7667 6.23366C14.3112 6.7781 14.7085 7.36988 14.9587 8.00899C15.209 8.6481 15.3339 9.30077 15.3334 9.96699C15.3334 11.2003 14.9639 12.2977 14.2247 13.259C13.4856 14.2203 12.5219 14.8563 11.3334 15.167Z"
        fill="white"
      />
    </svg>
  ),
  "File-black": (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.60449C9.2198 3.60447 9.43348 3.67687 9.608 3.81049L9.708 3.89749L12.414 6.60449H19C19.7652 6.60445 20.5015 6.89682 21.0583 7.42178C21.615 7.94673 21.9501 8.6646 21.995 9.42849L22 9.60449V17.6045C22 18.3697 21.7077 19.106 21.1827 19.6628C20.6578 20.2195 19.9399 20.5546 19.176 20.5995L19 20.6045H5C4.23479 20.6045 3.49849 20.3122 2.94174 19.7872C2.38499 19.2622 2.04989 18.5444 2.005 17.7805L2 17.6045V6.60449C1.99996 5.83928 2.29233 5.10298 2.81728 4.54623C3.34224 3.98949 4.06011 3.65438 4.824 3.60949L5 3.60449H9Z"
        fill="black"
      />
    </svg>
  ),
  "dowload-export": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_230_34667)">
        <path
          d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z"
          fill="#01638D"
        />
      </g>
      <defs>
        <clipPath id="clip0_230_34667">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "import-file": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1667 54.3334L45.5 54.3334L45.5 86.3334L77.5 86.3334L77.5 54.3334L98.8334 54.3334L61.5 17.0001L24.1667 54.3334ZM66.8333 43.6667L66.8333 75.6667L56.1667 75.6667L56.1667 43.6667L49.9267 43.6667L61.5 32.0934L73.0733 43.6667L66.8333 43.6667ZM101.334 110.334L26.6673 110.334L26.6673 99.6671L101.334 99.6671L101.334 110.334Z"
        fill="#01638D"
      />
    </svg>
  ),
  "filter-table": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00006 6H17.0001L11.9901 12.3L7.00006 6ZM4.25006 5.61C6.27006 8.2 10.0001 13 10.0001 13V19C10.0001 19.55 10.4501 20 11.0001 20H13.0001C13.5501 20 14.0001 19.55 14.0001 19V13C14.0001 13 17.7201 8.2 19.7401 5.61C20.2501 4.95 19.7801 4 18.9501 4H5.04006C4.21006 4 3.74006 4.95 4.25006 5.61Z"
        fill="#01638D"
      />
    </svg>
  ),
  "creat-new": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_230_34513)">
        <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#01638D" />
      </g>
      <defs>
        <clipPath id="clip0_230_34513">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "data-box": (
    <svg
      width="50"
      height="65"
      viewBox="0 0 50 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.7637 55.7588H4.23625C1.63125 55.7588 0.652495 52.8956 0.499995 51.3843L0.494995 32.2256C0.495439 32.1245 0.509833 32.0243 0.537495 31.9298L6.36625 12.4493C6.66426 11.4739 7.18696 10.6421 7.86275 10.0678C8.53855 9.49357 9.33438 9.20498 10.1412 9.24156H39.8387C40.6524 9.20367 41.4551 9.4946 42.1363 10.0743C42.8175 10.654 43.3437 11.494 43.6425 12.4786L49.4612 31.9298C49.4889 32.0243 49.5033 32.1245 49.5037 32.2256V51.2787C49.3475 52.8972 48.37 55.7588 45.7637 55.7588ZM1.745 32.3783V51.2787C1.77125 51.4721 2.12125 54.1354 4.23625 54.1354H45.7637C47.9362 54.1354 48.2462 51.2949 48.2587 51.1747L48.2537 32.3799L42.4687 13.0424C42.4375 12.9303 41.8412 10.8698 39.86 10.8698H10.1637C8.12749 10.8698 7.54625 12.9888 7.54 13.0099L1.745 32.3783Z"
        fill="#01638D"
      />
      <path
        d="M33.9575 36.7546H16.045C15.9574 36.754 15.871 36.7297 15.7911 36.6831C15.7113 36.6365 15.6398 36.5687 15.5813 36.4841C15.5228 36.3995 15.4785 36.2999 15.4514 36.1917C15.4243 36.0835 15.4148 35.9691 15.4237 35.8559C15.5762 33.9856 15.3837 32.5978 14.8625 31.8454C14.3475 31.1012 13.5575 31.1581 13.4862 31.1646L6.51997 31.1727C6.41828 31.1723 6.31819 31.1397 6.22838 31.0777C6.13858 31.0157 6.06177 30.9261 6.00462 30.8168C5.94748 30.7074 5.91172 30.5816 5.90045 30.4502C5.88919 30.3188 5.90275 30.1858 5.93997 30.0628L10.3012 15.7401C10.3473 15.5886 10.4274 15.4586 10.5311 15.3671C10.6347 15.2755 10.7572 15.2265 10.8825 15.2266H39.1175C39.2428 15.2265 39.3652 15.2755 39.4689 15.3671C39.5725 15.4586 39.6526 15.5886 39.6987 15.7401L44 29.8694C44.0706 29.9899 44.1139 30.1336 44.125 30.2844C44.1361 30.4352 44.1145 30.5869 44.0628 30.7226C44.0111 30.8583 43.9312 30.9725 43.8322 31.0523C43.7332 31.1321 43.619 31.1744 43.5025 31.1743H36.5975C36.5012 31.1646 36.4537 31.1597 36.3837 31.1597C36.095 31.1597 35.5512 31.2491 35.1375 31.8471C34.6175 32.6011 34.4237 33.9856 34.5775 35.8576C34.5874 35.9708 34.5787 36.0855 34.552 36.194C34.5253 36.3026 34.4812 36.4025 34.4226 36.4873C34.364 36.5721 34.2923 36.6397 34.2121 36.6858C34.1319 36.7318 34.0451 36.7553 33.9575 36.7546ZM16.7175 35.1296H33.2837C33.2237 33.2023 33.5337 31.7349 34.2075 30.7616C35.2262 29.2893 36.6875 29.5591 36.6862 29.5574L42.5575 29.5509L38.6912 16.8516H11.3075L7.44122 29.5509H13.3775C13.3962 29.5461 13.49 29.5363 13.6175 29.5363C14.1137 29.5363 15.0537 29.6956 15.7925 30.7616C16.4662 31.7349 16.7775 33.2023 16.7175 35.1296Z"
        fill="#01638D"
      />
    </svg>
  ),
  "refresh-black": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4V10H7"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 20V14H17"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.49 8.99959C19.9828 7.56637 19.1209 6.28499 17.9845 5.27501C16.8482 4.26502 15.4745 3.55935 13.9917 3.22385C12.5089 2.88834 10.9652 2.93393 9.50481 3.35636C8.04437 3.77879 6.71475 4.5643 5.64 5.63959L1 9.99959M23 13.9996L18.36 18.3596C17.2853 19.4349 15.9556 20.2204 14.4952 20.6428C13.0348 21.0652 11.4911 21.1108 10.0083 20.7753C8.52547 20.4398 7.1518 19.7342 6.01547 18.7242C4.87913 17.7142 4.01717 16.4328 3.51 14.9996"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "bell-blue": (
    <svg
      width="16"
      height="22"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00006 23.667C10.2834 23.667 11.3334 22.617 11.3334 21.3337H6.66673C6.66673 22.617 7.70506 23.667 9.00006 23.667ZM16.0001 16.667V10.8337C16.0001 7.25199 14.0867 4.25366 10.7501 3.46033V2.66699C10.7501 1.69866 9.96839 0.916992 9.00006 0.916992C8.03173 0.916992 7.25006 1.69866 7.25006 2.66699V3.46033C3.90173 4.25366 2.00006 7.24033 2.00006 10.8337V16.667L0.49506 18.172C-0.23994 18.907 0.273393 20.167 1.31173 20.167H16.6767C17.7151 20.167 18.2401 18.907 17.5051 18.172L16.0001 16.667Z"
        fill="#01638D"
      />
    </svg>
  ),
  "post-blog": (
    <svg
      fill="#000000"
      height="20px"
      width="20px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <g>
              <path d="M93.238,220.968h172.463c4.466,0,8.084-3.619,8.084-8.084s-3.618-8.084-8.084-8.084H93.238 c-4.466,0-8.084,3.619-8.084,8.084S88.772,220.968,93.238,220.968z"></path>{" "}
              <path d="M93.238,177.853h97.01c4.466,0,8.084-3.619,8.084-8.084s-3.618-8.084-8.084-8.084h-97.01 c-4.466,0-8.084,3.619-8.084,8.084S88.772,177.853,93.238,177.853z"></path>{" "}
              <path d="M114.796,398.282h280.253c16.344,0,29.642-13.298,29.642-29.642v-91.082c0-5.206-1.371-10.333-3.968-14.822 c-2.233-3.865-7.179-5.189-11.044-2.953c-3.866,2.233-5.188,7.179-2.953,11.044c1.176,2.034,1.797,4.362,1.797,6.732v91.082 c0,7.43-6.044,13.474-13.474,13.474H114.796c-7.43,0-13.474-6.044-13.474-13.474v-91.082c0-7.43,6.044-13.474,13.474-13.474 h150.905c4.466,0,8.084-3.619,8.084-8.084c0-4.466-3.618-8.084-8.084-8.084H114.796c-16.344,0-29.642,13.298-29.642,29.642 v91.082C85.154,384.984,98.452,398.282,114.796,398.282z"></path>{" "}
              <path d="M477.068,412.237c1.684-5.067,2.596-10.484,2.596-16.11V158.989c0-28.231-22.969-51.2-51.2-51.2h-45.81V29.642 C382.653,13.298,369.355,0,353.01,0h-21.558c-16.344,0-29.642,13.298-29.642,29.642v78.147H83.537 c-28.231,0-51.2,22.969-51.2,51.2v237.137c0,5.627,0.912,11.043,2.596,16.11C14.43,419.065,0,438.368,0,460.8 C0,489.031,22.969,512,51.2,512h409.6c28.231,0,51.2-22.969,51.2-51.2C512,438.368,497.57,419.065,477.068,412.237z M317.979,29.642c0-7.43,6.044-13.474,13.474-13.474h21.558c7.43,0,13.474,6.044,13.474,13.474v13.474h-48.505V29.642z M366.484,59.284v188.632h-16.168V59.284H366.484z M317.979,59.284h16.168v188.632h-16.168V59.284z M317.979,264.084h48.505 v20.66c0,0.579-0.192,1.153-0.539,1.617l-21.558,28.743c-0.704,0.938-1.652,1.078-2.156,1.078c-0.503,0-1.452-0.14-2.156-1.078 l-21.557-28.741c-0.348-0.466-0.54-1.04-0.54-1.619V264.084z M48.505,158.989c0-19.317,15.715-35.032,35.032-35.032h218.274 v37.726h-57.667c-4.466,0-8.084,3.619-8.084,8.084s3.618,8.084,8.084,8.084h57.667v106.892c0,4.053,1.339,8.071,3.773,11.318 l21.558,28.743c3.596,4.796,9.096,7.545,15.091,7.545c5.994,0,11.495-2.75,15.091-7.545l21.559-28.745 c2.433-3.244,3.772-7.263,3.772-11.316v-63.776h33.954c4.466,0,8.084-3.619,8.084-8.084s-3.619-8.084-8.084-8.084h-33.954 v-26.947h33.954c4.466,0,8.084-3.619,8.084-8.084s-3.619-8.084-8.084-8.084h-33.954v-37.726h45.81 c19.317,0,35.032,15.715,35.032,35.032v237.137c0,19.317-15.715,35.032-35.032,35.032H83.537 c-19.317,0-35.032-15.715-35.032-35.032V158.989z M460.8,495.832H51.2c-19.317,0-35.032-15.715-35.032-35.032 c0-16.257,11.071-30.113,26.426-33.963c9.349,12.434,24.222,20.49,40.943,20.49h344.926c16.72,0,31.594-8.056,40.943-20.49 c15.355,3.85,26.426,17.707,26.426,33.963C495.832,480.117,480.117,495.832,460.8,495.832z"></path>{" "}
              <path d="M235.52,463.495h-1.078c-4.466,0-8.084,3.618-8.084,8.084c0,4.466,3.618,8.084,8.084,8.084h1.078 c4.466,0,8.084-3.618,8.084-8.084C243.604,467.113,239.986,463.495,235.52,463.495z"></path>{" "}
              <path d="M433.853,463.495H272.168c-4.466,0-8.084,3.618-8.084,8.084c0,4.466,3.618,8.084,8.084,8.084h161.684 c4.466,0,8.084-3.618,8.084-8.084C441.937,467.113,438.318,463.495,433.853,463.495z"></path>{" "}
              <path d="M202.105,463.495h-1.078c-4.466,0-8.084,3.618-8.084,8.084c0,4.466,3.618,8.084,8.084,8.084h1.078 c4.466,0,8.084-3.618,8.084-8.084C210.189,467.113,206.571,463.495,202.105,463.495z"></path>{" "}
              <path d="M164.379,463.495H78.147c-4.466,0-8.084,3.618-8.084,8.084c0,4.466,3.618,8.084,8.084,8.084h86.232 c4.466,0,8.084-3.618,8.084-8.084C172.463,467.113,168.845,463.495,164.379,463.495z"></path>{" "}
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  headphone: (
    <svg
      fill="#000000"
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g id="Icon">
          <path d="M5.003,15.386c-0.776,0.808 -1.253,1.906 -1.253,3.114c-0,2.353 1.809,4.286 4.111,4.483l0,0.017c0,0.552 0.448,1 1,1l3.139,0c0.552,0 1,-0.448 1,-1l0,-9c0,-0.552 -0.448,-1 -1,-1l-3.139,0c-0.552,0 -1,0.448 -1,1l0,0.017c-0.276,0.023 -0.546,0.072 -0.806,0.144c0.221,-3.123 1.105,-5.455 2.52,-7.049c1.588,-1.79 3.834,-2.605 6.425,-2.605c2.594,-0 4.844,0.765 6.434,2.51c1.433,1.574 2.319,3.907 2.521,7.085c-0.264,-0.057 -0.537,-0.091 -0.816,-0.1l-0,-0.002c-0,-0.552 -0.448,-1 -1,-1l-3.139,0c-0.552,0 -1,0.448 -1,1l-0,9c-0,0.552 0.448,1 1,1l3.139,0c0.552,0 1,-0.448 1,-1l-0,-0.002c0.381,-0.012 0.75,-0.071 1.101,-0.171l0,2.923c0,0.138 -0.112,0.25 -0.25,0.25l-3.37,0l0,-0.414c0,-0.552 -0.447,-1 -1,-1l-5.24,0c-0.553,0 -1,0.448 -1,1l-0,2.828c-0,0.552 0.447,1 1,1l5.24,-0c0.553,-0 1,-0.448 1,-1l0,-0.414l3.37,0c1.242,0 2.25,-1.008 2.25,-2.25l0,-4.129c0.78,-0.809 1.26,-1.909 1.26,-3.121c0,-1.333 -0.581,-2.531 -1.503,-3.356c-0.068,-4.349 -1.233,-7.441 -3.085,-9.473c-1.961,-2.154 -4.711,-3.164 -7.912,-3.164c-3.204,-0 -5.958,1.064 -7.921,3.278c-1.853,2.088 -3.014,5.24 -3.076,9.601Zm11.377,11.2l3.24,0c0,0 0,0.828 0,0.828c0,-0 -3.24,-0 -3.24,-0l-0,-0.828Zm5.759,-11.586l-0,7c-0,0 -1.139,0 -1.139,0c-0,-0 -0,-7 -0,-7l1.139,0Zm-11.139,0l-0,7c0,0 -1.139,0 -1.139,0c0,-0 0,-7 0,-7l1.139,0Zm13.139,1.004l-0,4.992c1.315,-0.072 2.361,-1.163 2.361,-2.496c-0,-1.333 -1.046,-2.424 -2.361,-2.496Zm-16.278,0.026c-1.195,0.187 -2.111,1.222 -2.111,2.47c-0,1.248 0.916,2.283 2.111,2.47l0,-4.94Z"></path>{" "}
        </g>
      </g>
    </svg>
  ),
  rounded: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM16.92 6H13.97C13.65 4.75 13.19 3.55 12.59 2.44C14.43 3.07 15.96 4.35 16.92 6ZM10 2.04C10.83 3.24 11.48 4.57 11.91 6H8.09C8.52 4.57 9.17 3.24 10 2.04ZM2.26 12C2.1 11.36 2 10.69 2 10C2 9.31 2.1 8.64 2.26 8H5.64C5.56 8.66 5.5 9.32 5.5 10C5.5 10.68 5.56 11.34 5.64 12H2.26ZM3.08 14H6.03C6.35 15.25 6.81 16.45 7.41 17.56C5.57 16.93 4.04 15.66 3.08 14ZM6.03 6H3.08C4.04 4.34 5.57 3.07 7.41 2.44C6.81 3.55 6.35 4.75 6.03 6ZM10 17.96C9.17 16.76 8.52 15.43 8.09 14H11.91C11.48 15.43 10.83 16.76 10 17.96ZM12.34 12H7.66C7.57 11.34 7.5 10.68 7.5 10C7.5 9.32 7.57 8.65 7.66 8H12.34C12.43 8.65 12.5 9.32 12.5 10C12.5 10.68 12.43 11.34 12.34 12ZM12.59 17.56C13.19 16.45 13.65 15.25 13.97 14H16.92C15.96 15.65 14.43 16.93 12.59 17.56ZM14.36 12C14.44 11.34 14.5 10.68 14.5 10C14.5 9.32 14.44 8.66 14.36 8H17.74C17.9 8.64 18 9.31 18 10C18 10.69 17.9 11.36 17.74 12H14.36Z"
        fill="black"
      />
    </svg>
  ),
  "word-update-green": (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 800 800"
      enableBackground="new 0 0 800 800"
      id="GUIDE"
      version="1.1"
      space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      cc="http://creativecommons.org/ns#"
      dc="http://purl.org/dc/elements/1.1/"
      inkscape="http://www.inkscape.org/namespaces/inkscape"
      rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      svg="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="#00C590"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M774.721,110.344c4.668-10.011,0.337-21.91-9.674-26.578L649.241,29.765c-4.807-2.242-10.309-2.482-15.292-0.668 c-4.985,1.814-9.045,5.534-11.287,10.342l-59.898,128.455l-29.281-86.015c-2.76-8.104-10.372-13.555-18.934-13.555H121.323 c-6.015,0-11.71,2.707-15.508,7.37l-77.922,95.678c-4.352,5.344-5.646,12.551-3.425,19.075L217.865,758.55 c2.759,8.104,10.371,13.555,18.933,13.555H659.33c11.047,0,20-8.954,20-20s-8.953-20-20-20H251.116L71.339,204.007l94.295,0.02 c0.001,0,0.003,0,0.004,0c6.824,0,13.178-3.479,16.853-9.229c3.676-5.751,4.164-12.98,1.296-19.174l-31.162-67.3H500.23 l38.11,111.947L405.278,505.625c-1.536,3.292-2.108,6.908-1.749,10.463c-0.008,0.002-0.015,0.003-0.023,0.005l12.581,124.188 c0.711,7.012,5.059,13.132,11.446,16.11c2.69,1.255,5.576,1.874,8.45,1.874c3.948,0,7.875-1.168,11.247-3.461l103.225-70.188 c-0.002-0.003-0.003-0.006-0.004-0.009c2.886-1.958,5.303-4.688,6.884-8.078l59.123-126.789l105.126,308.81 c2.833,8.321,10.605,13.56,18.932,13.56c2.137,0,4.312-0.345,6.447-1.072c10.457-3.559,16.047-14.922,12.488-25.378 L640.883,397.363L774.721,110.344z M85.477,164.01l31.145-38.242l17.713,38.252L85.477,164.01z M650.463,74.47l79.554,37.096 l-18.285,39.214l-79.554-37.097L650.463,74.47z M446.85,547.077l52.008,24.251L452.5,602.85L446.85,547.077z M529.535,541.499 l-79.553-37.096l165.291-354.468l79.553,37.097L529.535,541.499z"></path>
          <path d="M608.921,220.086L528.08,393.45c-4.668,10.011-0.338,21.91,9.674,26.578c2.734,1.275,5.609,1.879,8.438,1.879 c7.532,0,14.747-4.275,18.14-11.553l80.841-173.364c4.669-10.011,0.337-21.91-9.674-26.578 C625.49,205.743,613.589,210.075,608.921,220.086z"></path>
          <path d="M528.939,438.928c-10.01-4.668-21.91-0.336-26.578,9.675l-2.725,5.843c-4.667,10.012-0.336,21.911,9.676,26.578 c2.734,1.275,5.607,1.879,8.438,1.879c7.533,0,14.748-4.277,18.141-11.553l2.725-5.844 C543.283,455.494,538.951,443.595,528.939,438.928z"></path>
          <path d="M176.516,244.257c-11.046,0-20,8.954-20,20s8.954,20,20,20h3.322c11.046,0,20-8.954,20-20s-8.954-20-20-20H176.516z"></path>
          <path d="M443.271,284.257c11.046,0,20-8.954,20-20s-8.954-20-20-20H240.67c-11.045,0-20,8.954-20,20s8.955,20,20,20H443.271z"></path>
          <path d="M418.624,420.214c0-11.046-8.954-20-20-20H229.608c-11.046,0-20,8.954-20,20s8.954,20,20,20h169.016 C409.67,440.214,418.624,431.26,418.624,420.214z"></path>
          <path d="M282.698,556.171c-11.046,0-20,8.954-20,20s8.954,20,20,20h80.904c11.046,0,20-8.954,20-20s-8.954-20-20-20H282.698z"></path>
        </g>
      </g>
    </svg>
  ),
  more: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="90"
      height="90"
      viewBox="0 0 64 64"
    >
      <path fill="#85cbf8" d="M31 3A28 28 0 1 0 31 59A28 28 0 1 0 31 3Z"></path>
      <path
        fill="#c2cde7"
        d="M31,3A28,28,0,1,0,59,31,28,28,0,0,0,31,3Zm0,50A22,22,0,1,1,46.17,15.07l.68.67q.39.4.75.82A22,22,0,0,1,31,53Z"
      ></path>
      <path
        fill="#acb7d0"
        d="M31,53A22,22,0,0,1,9,31H7.34a4,4,0,0,0-3.95,4.71,28,28,0,0,0,55.21,0A4,4,0,0,0,54.66,31H53A22,22,0,0,1,31,53Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M31,2A29,29,0,1,0,60,31,29,29,0,0,0,31,2Zm0,56A27,27,0,1,1,58,31,27,27,0,0,1,31,58Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M31 50a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V51A1 1 0 0 0 31 50zM37 50.08a1 1 0 0 0-1.93.52l.52 1.93A1 1 0 0 0 37.53 52zM21.75 47.52a1 1 0 0 0-1.37.37l-1 1.73a1 1 0 1 0 1.73 1l1-1.73A1 1 0 0 0 21.75 47.52zM41.62 47.89a1 1 0 1 0-1.73 1l1 1.73a1 1 0 1 0 1.73-1zM26.21 49.37a1 1 0 0 0-1.22.71L24.47 52a1 1 0 1 0 1.93.52l.52-1.93A1 1 0 0 0 26.21 49.37z"
      ></path>
      <path
        fill="#faefde"
        d="M43,30H32V19a1,1,0,0,0-2,0V30H19a1,1,0,0,0,0,2H30V43a1,1,0,0,0,2,0V32H43a1,1,0,0,0,0-2Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M38.35 11.32a21 21 0 0 1 2.1.92 1 1 0 0 0 .9-1.79 23 23 0 0 0-2.3-1 1 1 0 1 0-.7 1.87zM16.15 16.15a21.08 21.08 0 0 1 18.19-5.88 1 1 0 1 0 .32-2 23 23 0 0 0-19.92 39 1 1 0 0 0 1.41-1.41A21 21 0 0 1 16.15 16.15zM47.26 14.74a23.19 23.19 0 0 0-2.09-1.86 1 1 0 0 0-1.23 1.57 21.26 21.26 0 0 1 1.91 1.7 21 21 0 0 1 0 29.7 1 1 0 1 0 1.41 1.41A23 23 0 0 0 47.26 14.74z"
      ></path>
    </svg>
  ),
  new: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="90"
      height="90"
      viewBox="0 0 64 64"
    >
      <path
        fill="#f9e3ae"
        d="M47,57H17c-5.523,0-10-4.477-10-10V17c0-5.523,4.477-10,10-10h30c5.523,0,10,4.477,10,10v30	C57,52.523,52.523,57,47,57z"
      ></path>
      <path
        fill="#efc88e"
        d="M30.996,12.278c-0.354-0.422-0.983-0.479-1.408-0.124l-1.498,1.257	c-3.24-3.303-8.54-3.614-12.141-0.592c-1.832,1.538-2.956,3.696-3.165,6.079c-0.188,2.149,0.396,4.246,1.639,5.981l-1.316,1.104	c-0.423,0.355-0.479,0.986-0.123,1.409c0.197,0.236,0.48,0.357,0.767,0.357c0.227,0,0.454-0.077,0.642-0.234l16.48-13.829	C31.296,13.332,31.352,12.701,30.996,12.278z"
      ></path>
      <path
        fill="#b5c4e0"
        d="M13.361,24.292l12.188-10.227l0,0c-2.824-3.366-7.842-3.804-11.207-0.98l0,0	C10.976,15.909,10.537,20.927,13.361,24.292L13.361,24.292z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M28.496,11.778c-0.354-0.422-0.983-0.479-1.408-0.124l-1.358,1.139	c-3.249-3.197-8.473-3.462-12.031-0.475c-1.832,1.538-2.956,3.696-3.165,6.079c-0.183,2.096,0.362,4.143,1.542,5.853l-1.469,1.233	c-0.423,0.355-0.479,0.986-0.123,1.409c0.197,0.236,0.48,0.357,0.767,0.357c0.227,0,0.454-0.077,0.642-0.234l16.48-13.829	C28.796,12.832,28.852,12.201,28.496,11.778z M14.984,13.851c1.301-1.091,2.887-1.624,4.465-1.624c1.671,0,3.332,0.597,4.636,1.761	l-10.546,8.849C11.75,19.949,12.307,16.098,14.984,13.851z"
      ></path>
      <path
        fill="#f9dd8f"
        d="M51,46.347c-14-2.779-27.403-2.428-38,0c0,0-0.862,3.602-0.985,9.314C13.484,56.508,15.183,57,17,57	h30c1.824,0,3.529-0.496,5.001-1.349C51.941,49.946,51,46.347,51,46.347z"
      ></path>
      <path
        fill="#efc88e"
        d="M53.267,46.067c-0.179-0.58-0.522-0.973-0.768-1.244c0.124-2.566-1.676-3.612-1.676-3.612	s0.928-1.766,0.928-5.605c0-3.789-2.251-11.074-8.409-13.647l2.363,23.483c-11.684-1.692-22.737-1.24-31.83,0.718	c-0.053,0.217-0.078,0.448-0.063,0.697c0.127,2.046,0.871,3.626,2.46,3.726c1.79,0.113,3.18-0.749,4.246-3.284	c7.351-0.954,17.937-0.954,22.928,0.551c2.717,0.819,2.258,2.846,1.57,3.67c3.206,0.634,4.483,2.891,4.734,5.096l4.177-2.523	C53.929,51.312,53.849,47.949,53.267,46.067z"
      ></path>
      <path
        fill="#acb7d0"
        d="M48.649,42.342c-0.373-0.121-0.755-0.158-1.141-0.16C48.502,40.655,49.025,38.33,49,36	c-0.109-10.049-7.542-17-16.5-17C23.534,19,15,26.94,15,35.5c0,2.913,0.5,5.514,1.472,7.394c-0.008,0-0.015,0-0.023,0	c-1.695,0.074-2.985,0.884-2.948,2.248c0.037,1.363,0.747,3.832,2.469,3.832c1.327,0,2.356-1.683,2.117-3.268l3.815-0.788	c-0.008-0.006-0.015-0.01-0.023-0.016c6.022-0.64,12.605-0.676,19.48,0.022c-0.019,0.013-0.037,0.024-0.056,0.037	c2.726,0.252,3.495,0.479,4.402,0.626c0.153,1.839,0.795,2.678,2.084,2.679C49.535,48.267,52.672,43.647,48.649,42.342z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M28.442,37.571c0.438-1.946,4.326-0.587,6.46-0.723c0.975-0.062,1.712-1.807,2.898-1.651	c1.186,0.156,1.993,3.975-2.125,4.798C32.399,40.65,28.2,38.646,28.442,37.571z"
      ></path>
      <ellipse
        cx="39.788"
        cy="31.516"
        fill="#8d6c9f"
        rx=".972"
        ry="1.748"
        transform="rotate(-13.468 39.791 31.512)"
      ></ellipse>
      <ellipse
        cx="24.906"
        cy="34.307"
        fill="#8d6c9f"
        rx=".972"
        ry="1.738"
        transform="rotate(-13.468 24.91 34.304)"
      ></ellipse>
      <path
        fill="#8d6c9f"
        d="M47,58H17c-6.065,0-11-4.935-11-11V17c0-6.065,4.935-11,11-11h30c6.065,0,11,4.935,11,11v30	C58,53.065,53.065,58,47,58z M17,8c-4.963,0-9,4.038-9,9v30c0,4.962,4.037,9,9,9h30c4.963,0,9-4.038,9-9V17c0-4.962-4.037-9-9-9H17z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M22.431,53.181c-0.514,0-0.951-0.394-0.995-0.915l-0.17-1.993c-0.047-0.55,0.361-1.034,0.911-1.082	s1.035,0.361,1.081,0.912l0.17,1.993c0.047,0.55-0.361,1.034-0.911,1.082C22.487,53.18,22.459,53.181,22.431,53.181z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M27.257,52.868c-0.531,0-0.974-0.418-0.998-0.955l-0.09-1.998c-0.024-0.552,0.402-1.019,0.954-1.044	c0.533-0.019,1.019,0.402,1.044,0.954l0.09,1.998c0.024,0.552-0.402,1.019-0.954,1.044C27.287,52.868,27.272,52.868,27.257,52.868z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M32.093,52.747c-0.55,0-0.997-0.444-1-0.995l-0.01-2c-0.003-0.552,0.442-1.002,0.995-1.005	c0.002,0,0.003,0,0.005,0c0.55,0,0.997,0.444,1,0.995l0.01,2c0.003,0.552-0.442,1.002-0.995,1.005	C32.096,52.747,32.095,52.747,32.093,52.747z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M36.927,52.826c-0.013,0-0.026,0-0.039,0c-0.552-0.021-0.982-0.486-0.961-1.038l0.076-1.999	c0.021-0.552,0.485-0.978,1.037-0.961c0.552,0.021,0.982,0.486,0.961,1.038l-0.076,1.999C37.904,52.403,37.461,52.826,36.927,52.826	z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M41.741,53.131c-0.03,0-0.061-0.001-0.091-0.004c-0.551-0.05-0.956-0.537-0.906-1.086l0.181-1.992	c0.05-0.55,0.542-0.945,1.086-0.906c0.551,0.05,0.956,0.537,0.906,1.086l-0.181,1.992C42.689,52.741,42.253,53.131,41.741,53.131z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M51.962,46.228c-0.012-0.042-0.026-0.083-0.043-0.123c-0.059-0.136-0.144-0.252-0.248-0.347	c-0.059-0.053-0.137-0.082-0.208-0.121c0.033-0.131,0.077-0.26,0.098-0.391c0.282-1.774-0.671-3.201-2.545-3.832	c0.643-1.513,1.006-3.398,0.985-5.424C49.89,25.734,42.366,18,32.5,18C22.99,18,14,26.505,14,35.5c0,2.542,0.37,4.798,1.05,6.62	c-1.598,0.457-2.589,1.577-2.549,3.049c0.004,0.144,0.016,0.297,0.031,0.453c-0.096,0.051-0.185,0.113-0.258,0.19	c-0.086,0.09-0.155,0.196-0.203,0.317c-0.016,0.04-0.029,0.08-0.04,0.121c-0.09,0.327-0.906,3.441-1.019,9.392	c-0.01,0.552,0.429,1.008,0.981,1.019c0.006,0,0.013,0,0.019,0c0.544,0,0.989-0.436,1-0.981c0.06-3.213,0.336-5.555,0.575-7.032	c0.552,0.775,1.332,1.326,2.382,1.326c0.806,0,1.574-0.377,2.164-1.063c0.558-0.648,0.9-1.512,0.973-2.394l2.606-0.539	c6.191-0.737,12.767-0.759,19.42-0.042c0.027,0.005,0.051,0.017,0.079,0.02c0.243,0.022,0.468,0.045,0.68,0.067	c0.691,0.08,1.383,0.172,2.075,0.268c0.326,0.053,0.597,0.103,0.842,0.149c0.345,1.874,1.344,2.823,2.979,2.825	c0.001,0,0.001,0,0.002,0c0.849,0,1.774-0.583,2.504-1.429c0.273,1.33,0.677,3.938,0.709,7.83c0.005,0.549,0.451,0.992,1,0.992	c0.003,0,0.006,0,0.009,0c0.552-0.004,0.996-0.456,0.991-1.008C52.954,49.689,52.063,46.561,51.962,46.228z M17.885,44.727	c-0.521,0.108-0.866,0.604-0.787,1.129c0.094,0.616-0.095,1.303-0.48,1.751c-0.118,0.137-0.359,0.368-0.647,0.368	c-0.85,0-1.438-1.694-1.469-2.86c-0.023-0.836,1.058-1.181,1.99-1.221c0.184-0.008,0.359-0.014,0.532-0.014	c0.704,0,1.363,0.098,2.275,0.555L17.885,44.727z M41.053,43.924c-6.45-0.677-12.836-0.696-18.876-0.037	c-2.161-1.553-3.498-1.98-5.071-2.003C16.398,40.234,16,38.011,16,35.5C16,27.533,24.019,20,32.5,20	c8.738,0,15.401,6.883,15.5,16.011c0.021,2.011-0.405,3.895-1.098,5.191C44.857,41.426,42.813,42.739,41.053,43.924z M47.79,47.266	c-0.397,0-0.941-0.001-1.087-1.761c-0.038-0.458-0.384-0.832-0.838-0.905c-0.205-0.033-0.403-0.071-0.621-0.112	c-0.288-0.055-0.62-0.117-1.048-0.186c1.582-0.909,2.954-1.396,4.145-1.009c1.264,0.41,1.33,1.087,1.246,1.631	C49.398,46.146,48.192,47.263,47.79,47.266z"
      ></path>
    </svg>
  ),
  idic: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="90"
      height="90"
      viewBox="0 0 64 64"
    >
      <path
        fill="#f9dd8f"
        d="M51,7H13c-3.3,0-6,2.7-6,6v38c0,3.3,2.7,6,6,6h38c3.3,0,6-2.7,6-6V13C57,9.7,54.3,7,51,7z"
      ></path>
      <path
        fill="#ffeb9b"
        d="M54,50H10c-1.7,0-3,1.3-3,3l0,0c0,2.2,1.8,4,4,4h42c2.2,0,4-1.8,4-4l0,0C57,51.3,55.7,50,54,50z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M51,6H13c-3.9,0-7,3.1-7,7v38c0,3.9,3.1,7,7,7h38c3.9,0,7-3.1,7-7V13C58,9.1,54.9,6,51,6z M56,51	c0,2.8-2.2,5-5,5H13c-2.8,0-5-2.2-5-5V13c0-2.8,2.2-5,5-5h38c2.8,0,5,2.2,5,5V51z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M17,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C18,48.4,17.6,48,17,48z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M12,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C13,48.4,12.6,48,12,48z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M32,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-2C33,48.4,32.6,48,32,48z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M37,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C38,48.4,37.6,48,37,48z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M42,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C43,48.4,42.6,48,42,48z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M47,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C48,48.4,47.6,48,47,48z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M52,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C53,48.4,52.6,48,52,48z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M22,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C23,48.4,22.6,48,22,48z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M27,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C28,48.4,27.6,48,27,48z"
      ></path>
      <path
        fill="#fff8ee"
        stroke="#8d6c9f"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M20,44h37v-4H20c-1.1,0-2,0.9-2,2v0C18,43.1,18.9,44,20,44z"
      ></path>
      <rect
        width="4"
        height="21"
        x="32.4"
        y="15.1"
        fill="#fff8ee"
        stroke="#8d6c9f"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        transform="rotate(45.001 34.375 25.567)"
      ></rect>
      <path
        fill="#fff8ee"
        stroke="#8d6c9f"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M45.4,17.4l-2.8-2.8l2.1-2.1c0.8-0.8,2-0.8,2.8,0l0,0c0.8,0.8,0.8,2,0,2.8L45.4,17.4z"
      ></path>
      <polygon
        fill="#fff8ee"
        stroke="#8d6c9f"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        points="20.5,39.4 20.5,39.4 23.4,33.7 26.3,36.5"
      ></polygon>
    </svg>
  ),
  fileClole: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="90"
      height="90"
      viewBox="0 0 64 64"
    >
      <path
        fill="#cda1a7"
        d="M53,53H4a3,3,0,0,1-3-3V10A3,3,0,0,1,4,7H17l9,6H50a3,3,0,0,1,3,3Z"
      ></path>
      <path
        fill="#faefde"
        d="M53.44,53H8.56a2,2,0,0,1-1.94-2.49l7-28A2,2,0,0,1,15.56,21H60.44a2,2,0,0,1,1.94,2.49l-7,28A2,2,0,0,1,53.44,53Z"
      ></path>
      <path
        fill="#fff7f0"
        d="M62.25,24l.13-.51A2,2,0,0,0,60.44,21H15.56a2,2,0,0,0-1.94,1.51L13.25,24Z"
      ></path>
      <path
        fill="#efd8be"
        d="M8.5,43,6.62,50.51A2,2,0,0,0,8.56,53H53.44a2,2,0,0,0,1.94-1.51L57.5,43Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M53 42H49a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zM11.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 11.74 46zM16.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 16.74 46zM21.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 21.74 46zM26.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 26.74 46zM31.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 31.74 46zM36.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 36.74 46zM41.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 41.74 46zM46.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 46.74 46zM51.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 51.74 46z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M62.81,21.15A3,3,0,0,0,60.44,20H54V15a3,3,0,0,0-3-3H25.71a3,3,0,0,1-2.11-.87L19.87,7.45A5,5,0,0,0,16.36,6H3A3,3,0,0,0,0,9V50a4,4,0,0,0,4,4H52.7a4,4,0,0,0,3.87-3l6.79-27.29A3,3,0,0,0,62.81,21.15ZM4,52a2,2,0,0,1-2-2V9A1,1,0,0,1,3,8H16.36a3,3,0,0,1,2.11.87l3.72,3.68A5,5,0,0,0,25.71,14H51a1,1,0,0,1,1,1v5H16.51a4,4,0,0,0-3.88,3L6,49.7S5.46,52,4,52ZM61.41,23.24,54.63,50.52A2,2,0,0,1,52.7,52H7.21A6.28,6.28,0,0,0,8,50.15L9.49,44H45a1,1,0,0,0,0-2H10l4.59-18.48A2,2,0,0,1,16.51,22H60.44a1,1,0,0,1,1,1.24Z"
      ></path>
    </svg>
  ),
  fileRecovery: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="90"
      height="90"
      viewBox="0 0 64 64"
    >
      <path
        fill="#85cbf8"
        d="M51,43.77v5.82a2,2,0,0,1-1,1.72L33,61.39a2,2,0,0,1-2,0L14,51.31a2,2,0,0,1-1-1.72V43l16-5.61,3.08-1.08,3,1.16Z"
      ></path>
      <path
        fill="#9fddff"
        d="M13.72 24.89L27.02 9.06 50.41 24.89 31.09 36.97 13.72 24.89z"
      ></path>
      <path
        fill="#7bbeeb"
        d="M51,44.77v2.17l-5.58,3.67a1,1,0,0,1-1.19-.07L32.71,40.85a1,1,0,0,0-1.29,0L19.9,50.54a1,1,0,0,1-1.19.07L13,46.85V44l16-7.61h6.16Z"
      ></path>
      <path
        fill="#85cbf8"
        d="M61.86 14L45.42 3.16a1 1 0 0 0-1.19.07L32.07 13.47 50.42 24.89l11.52-9.3A1 1 0 0 0 61.86 14zM32.07 13.47L19.9 3.23a1 1 0 0 0-1.19-.07L2.28 14a1 1 0 0 0-.08 1.61l11.52 9.3 10.36-6.44"
      ></path>
      <path
        fill="#85cbf8"
        d="M32.07,36.31,19.9,46.54a1,1,0,0,1-1.19.07L2.28,35.8a1,1,0,0,1-.08-1.61l11.52-9.3L32.07,36.31,50.42,24.89l11.52,9.3a1,1,0,0,1-.08,1.61L45.42,46.61a1,1,0,0,1-1.19-.07L32.07,36.31Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M27.35,17.4a1,1,0,0,0,.53-.15l1.35-.84a1,1,0,1,0-1.06-1.7l-1.35.84a1,1,0,0,0,.53,1.85Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M52,24.89l10.55-8.52a2,2,0,0,0-.16-3.23L46,2.33a2,2,0,0,0-2.39.14L32.07,12.16,20.55,2.47a2,2,0,0,0-2.39-.14L1.73,13.14a2,2,0,0,0-.16,3.23l10.55,8.52L1.57,33.41a2,2,0,0,0,.16,3.23L12,43.39v6.2a3,3,0,0,0,1.47,2.58l17,10.08a3,3,0,0,0,3.06,0l17-10.08A3,3,0,0,0,52,49.59V43.77a1,1,0,0,0-.05-.25L62.4,36.63a2,2,0,0,0,.16-3.23ZM44.87,4,61.31,14.81l-11,8.85L33.76,13.35ZM19.26,4,31.42,14.23l.07,0,0,0,17,10.57L32.15,35.08,32.07,35l-.09.07L15.61,24.89l9-5.6a1,1,0,1,0-1.06-1.7l-9.75,6.07-11-8.85ZM13.79,26.11,30.37,36.43,19.26,45.78,2.83,35ZM50,49.59a1,1,0,0,1-.49.86l-17,10.08a1,1,0,0,1-1,0l-17-10.08a1,1,0,0,1-.49-.86V44.71l4.16,2.74a2,2,0,0,0,2.39-.14l11.52-9.69,11.52,9.69a2,2,0,0,0,2.39.14l4-2.65Zm-5.13-3.81L33.76,36.43,50.34,26.11l11,8.85Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M33 41H31a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM33 46H31a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM33 51H31a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM33 56H31a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
      ></path>
    </svg>
  ),
  "user-info": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM5.07 16.28C5.5 15.38 8.12 14.5 10 14.5C11.88 14.5 14.51 15.38 14.93 16.28C13.57 17.36 11.86 18 10 18C8.14 18 6.43 17.36 5.07 16.28ZM16.36 14.83C14.93 13.09 11.46 12.5 10 12.5C8.54 12.5 5.07 13.09 3.64 14.83C2.62 13.49 2 11.82 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 11.82 17.38 13.49 16.36 14.83ZM10 4C8.06 4 6.5 5.56 6.5 7.5C6.5 9.44 8.06 11 10 11C11.94 11 13.5 9.44 13.5 7.5C13.5 5.56 11.94 4 10 4ZM10 9C9.17 9 8.5 8.33 8.5 7.5C8.5 6.67 9.17 6 10 6C10.83 6 11.5 6.67 11.5 7.5C11.5 8.33 10.83 9 10 9Z"
        fill="black"
      />
    </svg>
  ),
  pendding: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="90"
      height="90"
      viewBox="0 0 64 64"
    >
      <path fill="#c5e4fa" d="M31 3A28 28 0 1 0 31 59A28 28 0 1 0 31 3Z"></path>
      <path
        fill="#e3f2ff"
        d="M12.71 52.29a28 28 0 0 0 9.18 5.82L56 24V17.57a28.1 28.1 0 0 0-3.71-4.86zM10.76 50.24L50 11H44L8.22 46.78A28.08 28.08 0 0 0 10.76 50.24zM7.79 43.21L41 10 38 8 6.36 39.64A27.81 27.81 0 0 0 7.79 43.21z"
      ></path>
      <path
        fill="#72caaf"
        d="M31,3A28,28,0,1,0,59,31,28,28,0,0,0,31,3Zm0,50A22,22,0,1,1,46.17,15.07l.68.67q.39.4.75.82A22,22,0,0,1,31,53Z"
      ></path>
      <path
        fill="#66bfa1"
        d="M31,53A22,22,0,0,1,9,31H7.34a4,4,0,0,0-3.95,4.71,28,28,0,0,0,55.21,0A4,4,0,0,0,54.66,31H53A22,22,0,0,1,31,53Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M31,2A29,29,0,1,0,60,31,29,29,0,0,0,31,2Zm0,56A27,27,0,1,1,58,31,27,27,0,0,1,31,58Z"
      ></path>
      <path
        fill="#ed7899"
        d="M31,18a1,1,0,0,0,1-1V15a1,1,0,0,0-2,0v2A1,1,0,0,0,31,18Z"
      ></path>
      <path fill="#8d6c9f" d="M15,30a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>
      <path
        fill="#ed7899"
        d="M48,31a1,1,0,0,0-1-1H45a1,1,0,0,0,0,2h2A1,1,0,0,0,48,31Z"
      ></path>
      <path fill="#8d6c9f" d="M30,45v2a1,1,0,0,0,2,0V45a1,1,0,0,0-2,0Z"></path>
      <path
        fill="#ed7899"
        d="M35.87 18.95a1 1 0 0 0 1.3-.55l.75-1.85a1 1 0 0 0-1.85-.75l-.75 1.85A1 1 0 0 0 35.87 18.95zM45.46 37.92a1 1 0 0 0 .75-1.85l-1.85-.75a1 1 0 0 0-.75 1.85zM40 20.23a1 1 0 0 0 1.44 1.39l1.39-1.44A1 1 0 0 0 41.4 18.8zM41.77 40a1 1 0 0 0-1.41 0 1 1 0 0 0-.25.56 1 1 0 0 0 .19 1.12L41.61 43A1 1 0 0 0 43 43a.39.39 0 0 1 .21-.21 1 1 0 0 0 0-1.41zM45.21 23.58l-1.83.81a1 1 0 1 0 .81 1.83L46 25.41a1 1 0 1 0-.81-1.83z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M38.5,39.5a1,1,0,0,0,.71-1.71l-6.28-6.28A1.94,1.94,0,0,0,32,29.28V21a1,1,0,0,0-2,0v8.28a2,2,0,0,0,1.51,3.65l6.28,6.28A1,1,0,0,0,38.5,39.5Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M31,54A23,23,0,1,1,34.36,8.24a1,1,0,0,1-.29,2A21.28,21.28,0,0,0,31,10a21,21,0,1,0,13,4.48,1,1,0,0,1,1.24-1.57A23,23,0,0,1,31,54Z"
      ></path>
      <path
        fill="#8d6c9f"
        d="M41,12.4a1,1,0,0,1-.45-.11,21,21,0,0,0-2.31-1,1,1,0,0,1,.69-1.88,23,23,0,0,1,2.53,1.11A1,1,0,0,1,41,12.4Z"
      ></path>
    </svg>
  ),
  "word-update": (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 800 800"
      enableBackground="new 0 0 800 800"
      id="GUIDE"
      version="1.1"
      space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      cc="http://creativecommons.org/ns#"
      dc="http://purl.org/dc/elements/1.1/"
      inkscape="http://www.inkscape.org/namespaces/inkscape"
      rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      svg="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M774.721,110.344c4.668-10.011,0.337-21.91-9.674-26.578L649.241,29.765c-4.807-2.242-10.309-2.482-15.292-0.668 c-4.985,1.814-9.045,5.534-11.287,10.342l-59.898,128.455l-29.281-86.015c-2.76-8.104-10.372-13.555-18.934-13.555H121.323 c-6.015,0-11.71,2.707-15.508,7.37l-77.922,95.678c-4.352,5.344-5.646,12.551-3.425,19.075L217.865,758.55 c2.759,8.104,10.371,13.555,18.933,13.555H659.33c11.047,0,20-8.954,20-20s-8.953-20-20-20H251.116L71.339,204.007l94.295,0.02 c0.001,0,0.003,0,0.004,0c6.824,0,13.178-3.479,16.853-9.229c3.676-5.751,4.164-12.98,1.296-19.174l-31.162-67.3H500.23 l38.11,111.947L405.278,505.625c-1.536,3.292-2.108,6.908-1.749,10.463c-0.008,0.002-0.015,0.003-0.023,0.005l12.581,124.188 c0.711,7.012,5.059,13.132,11.446,16.11c2.69,1.255,5.576,1.874,8.45,1.874c3.948,0,7.875-1.168,11.247-3.461l103.225-70.188 c-0.002-0.003-0.003-0.006-0.004-0.009c2.886-1.958,5.303-4.688,6.884-8.078l59.123-126.789l105.126,308.81 c2.833,8.321,10.605,13.56,18.932,13.56c2.137,0,4.312-0.345,6.447-1.072c10.457-3.559,16.047-14.922,12.488-25.378 L640.883,397.363L774.721,110.344z M85.477,164.01l31.145-38.242l17.713,38.252L85.477,164.01z M650.463,74.47l79.554,37.096 l-18.285,39.214l-79.554-37.097L650.463,74.47z M446.85,547.077l52.008,24.251L452.5,602.85L446.85,547.077z M529.535,541.499 l-79.553-37.096l165.291-354.468l79.553,37.097L529.535,541.499z"></path>
          <path d="M608.921,220.086L528.08,393.45c-4.668,10.011-0.338,21.91,9.674,26.578c2.734,1.275,5.609,1.879,8.438,1.879 c7.532,0,14.747-4.275,18.14-11.553l80.841-173.364c4.669-10.011,0.337-21.91-9.674-26.578 C625.49,205.743,613.589,210.075,608.921,220.086z"></path>
          <path d="M528.939,438.928c-10.01-4.668-21.91-0.336-26.578,9.675l-2.725,5.843c-4.667,10.012-0.336,21.911,9.676,26.578 c2.734,1.275,5.607,1.879,8.438,1.879c7.533,0,14.748-4.277,18.141-11.553l2.725-5.844 C543.283,455.494,538.951,443.595,528.939,438.928z"></path>
          <path d="M176.516,244.257c-11.046,0-20,8.954-20,20s8.954,20,20,20h3.322c11.046,0,20-8.954,20-20s-8.954-20-20-20H176.516z"></path>
          <path d="M443.271,284.257c11.046,0,20-8.954,20-20s-8.954-20-20-20H240.67c-11.045,0-20,8.954-20,20s8.955,20,20,20H443.271z"></path>
          <path d="M418.624,420.214c0-11.046-8.954-20-20-20H229.608c-11.046,0-20,8.954-20,20s8.954,20,20,20h169.016 C409.67,440.214,418.624,431.26,418.624,420.214z"></path>
          <path d="M282.698,556.171c-11.046,0-20,8.954-20,20s8.954,20,20,20h80.904c11.046,0,20-8.954,20-20s-8.954-20-20-20H282.698z"></path>
        </g>
      </g>
    </svg>
  ),
  "copy-black": (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 21C11.8954 21 11 20.1046 11 19V3H20L25 8V19C25 20.1046 24.1046 21 23 21H13Z"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 3V9H25"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M7 26C5.89543 26 5 25.1046 5 24V8H14L19 13V24C19 25.1046 18.1046 26 17 26H7Z"
        fill="white"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 8V14H19"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "delete-red-row": (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M7 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-1.069l-.867 12.142A2 2 0 0 1 17.069 22H6.93a2 2 0 0 1-1.995-1.858L4.07 8H3a1 1 0 0 1 0-2h4V4zm2 2h6V4H9v2zM6.074 8l.857 12H17.07l.857-12H6.074zM10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1z"
          fill="#fa0000"
        ></path>
      </g>
    </svg>
  ),
  "arrow-back-sign": (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      transform="matrix(-1, 0, 0, -1, 0, 0)"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          stroke="#154398"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M11 18h3.75a5.25 5.25 0 100-10.5H5M7.5 4L4 7.5 7.5 11"
        ></path>{" "}
      </g>
    </svg>
  ),
  notepad: (
    <svg
      fill="#154398"
      width="18px"
      height="18px"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="">
        {" "}
        <g fillRule="evenodd">
          {" "}
          <path d="M106.667 267H320v213.333h853.33V267h213.34v160h106.66V160.333h-329.1C1142.26 98.19 1083 53.667 1013.33 53.667H480c-69.665 0-128.931 44.523-150.896 106.666H0V1867h1493.33v-320h-106.66v213.33H106.667V267Zm320 106.667v-160c0-29.456 23.878-53.334 53.333-53.334h533.33c29.46 0 53.34 23.878 53.34 53.334v160H426.667Z"></path>{" "}
          <path d="m1677.57 528.309 225.88 225.883c22.02 22.023 22.02 57.713 0 79.849L1225.8 1511.69c-10.62 10.5-24.96 16.49-39.98 16.49H959.937c-31.171 0-56.47-25.3-56.47-56.47v-225.89c0-15.02 5.986-29.36 16.489-39.86L1597.6 528.309c22.14-22.136 57.83-22.136 79.97 0Zm-155.41 235.144 146.03 146.033 115.43-115.426-146.04-146.033-115.42 115.426Zm-505.75 651.787h146.03l425.9-425.9-146.03-146.038-425.9 425.898v146.04Z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  ),
  "delete-black-row": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 11V17"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11V17"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V7"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 7H20"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7L9 3H15L17 7"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "pne-black-arrow": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3V2C2.44772 2 2 2.44772 2 3H3ZM18.293 14.293L17.3818 13.8809C17.2104 14.2601 17.2916 14.7058 17.5859 15.0001L18.293 14.293ZM21 17L21.7071 17.7071C22.0976 17.3166 22.0976 16.6834 21.7071 16.2929L21 17ZM17 21L16.2929 21.7071C16.6834 22.0976 17.3166 22.0976 17.7071 21.7071L17 21ZM14.293 18.293L15.0001 17.5859C14.7058 17.2916 14.2601 17.2104 13.8809 17.3818L14.293 18.293ZM11 2H3V4H11V2ZM20 11C20 6.02944 15.9706 2 11 2V4C14.866 4 18 7.13401 18 11H20ZM19.2041 14.7051C19.7157 13.5738 20 12.3188 20 11H18C18 12.029 17.7786 13.0036 17.3818 13.8809L19.2041 14.7051ZM17.5859 15.0001L20.2929 17.7071L21.7071 16.2929L19.0001 13.5859L17.5859 15.0001ZM20.2929 16.2929L16.2929 20.2929L17.7071 21.7071L21.7071 17.7071L20.2929 16.2929ZM17.7071 20.2929L15.0001 17.5859L13.5859 19.0001L16.2929 21.7071L17.7071 20.2929ZM11 20C12.3188 20 13.5738 19.7157 14.7051 19.2041L13.8809 17.3818C13.0036 17.7786 12.029 18 11 18V20ZM2 11C2 15.9706 6.02944 20 11 20V18C7.13401 18 4 14.866 4 11H2ZM2 3V11H4V3H2Z"
        fill="#343A42"
      />
      <ellipse
        cx="11"
        cy="11"
        rx="2"
        ry="2"
        transform="rotate(-180 11 11)"
        fill="#343A42"
      />
      <path
        d="M3 3L11 11"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "eye-black": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12C3.60014 7.90264 7.33603 5 12 5C16.664 5 20.3999 7.90264 22 12C20.3999 16.0974 16.664 19 12 19C7.33603 19 3.60014 16.0974 2 12Z"
        stroke="#343A42"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "search-company-new": (
    <svg
      width="21px"
      height="21px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.25 5.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM7 6a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H7zm0 5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H7zm-1 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1zm-4-5a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 2 12zm1.25 3.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  "user-company-new": (
    <svg
      width="21px"
      height="21px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M12 12.75C11.2583 12.75 10.5333 12.5301 9.91661 12.118C9.29993 11.706 8.81928 11.1203 8.53545 10.4351C8.25163 9.74984 8.17736 8.99584 8.32206 8.26841C8.46675 7.54098 8.8239 6.8728 9.34835 6.34835C9.8728 5.8239 10.541 5.46675 11.2684 5.32206C11.9958 5.17736 12.7498 5.25162 13.4351 5.53545C14.1203 5.81928 14.706 6.29993 15.118 6.91661C15.5301 7.5333 15.75 8.25832 15.75 9C15.75 9.99456 15.3549 10.9484 14.6517 11.6517C13.9484 12.3549 12.9946 12.75 12 12.75ZM12 6.75C11.555 6.75 11.12 6.88196 10.75 7.12919C10.38 7.37643 10.0916 7.72783 9.92127 8.13896C9.75098 8.5501 9.70642 9.0025 9.79323 9.43895C9.88005 9.87541 10.0943 10.2763 10.409 10.591C10.7237 10.9057 11.1246 11.12 11.561 11.2068C11.9975 11.2936 12.4499 11.249 12.861 11.0787C13.2722 10.9084 13.6236 10.62 13.8708 10.25C14.118 9.88002 14.25 9.44501 14.25 9C14.25 8.40326 14.0129 7.83097 13.591 7.40901C13.169 6.98705 12.5967 6.75 12 6.75Z"
          fill="#000000"
        ></path>{" "}
        <path
          d="M19 19.75C18.8019 19.7474 18.6126 19.6676 18.4725 19.5275C18.3324 19.3874 18.2526 19.1981 18.25 19C18.25 17.05 17.19 15.75 12 15.75C6.81 15.75 5.75 17.05 5.75 19C5.75 19.1989 5.67098 19.3897 5.53033 19.5303C5.38968 19.671 5.19891 19.75 5 19.75C4.80109 19.75 4.61032 19.671 4.46967 19.5303C4.32902 19.3897 4.25 19.1989 4.25 19C4.25 14.25 9.68 14.25 12 14.25C14.32 14.25 19.75 14.25 19.75 19C19.7474 19.1981 19.6676 19.3874 19.5275 19.5275C19.3874 19.6676 19.1981 19.7474 19 19.75Z"
          fill="#000000"
        ></path>{" "}
        <path
          d="M19 14.5C18.8019 14.4974 18.6126 14.4176 18.4725 14.2775C18.3324 14.1374 18.2526 13.9481 18.25 13.75V10.25C18.25 10.0511 18.329 9.86032 18.4697 9.71967C18.6103 9.57902 18.8011 9.5 19 9.5C19.1989 9.5 19.3897 9.57902 19.5303 9.71967C19.671 9.86032 19.75 10.0511 19.75 10.25V13.75C19.7474 13.9481 19.6676 14.1374 19.5275 14.2775C19.3874 14.4176 19.1981 14.4974 19 14.5Z"
          fill="#000000"
        ></path>{" "}
        <path
          d="M20.75 12.75H17.25C17.0511 12.75 16.8603 12.671 16.7197 12.5303C16.579 12.3897 16.5 12.1989 16.5 12C16.5 11.8011 16.579 11.6103 16.7197 11.4697C16.8603 11.329 17.0511 11.25 17.25 11.25H20.75C20.9489 11.25 21.1397 11.329 21.2803 11.4697C21.421 11.6103 21.5 11.8011 21.5 12C21.5 12.1989 21.421 12.3897 21.2803 12.5303C21.1397 12.671 20.9489 12.75 20.75 12.75Z"
          fill="#000000"
        ></path>{" "}
      </g>
    </svg>
  ),
  "calender-company": (
    <svg
      width="21px"
      height="21px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2V3H9V2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2V3H5C3.34315 3 2 4.34315 2 6V20C2 21.6569 3.34315 23 5 23H19C20.6569 23 22 21.6569 22 20V6C22 4.34315 20.6569 3 19 3H17V2ZM20 9V6C20 5.44772 19.5523 5 19 5H17V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V5H9V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V5H5C4.44772 5 4 5.44772 4 6V9H20ZM4 11H20V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11Z"
          fill="#000000"
        ></path>{" "}
      </g>
    </svg>
  ),
  "user-company": (
    <svg
      width="21px"
      height="21px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9ZM15.8243 13.6235C17.1533 12.523 18 10.8604 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 10.8604 6.84668 12.523 8.17572 13.6235C4.98421 14.7459 3 17.2474 3 20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20C5 17.7306 7.3553 15 12 15C16.6447 15 19 17.7306 19 20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20C21 17.2474 19.0158 14.7459 15.8243 13.6235Z"
          fill="#000000"
        ></path>{" "}
      </g>
    </svg>
  ),
  "history-company": (
    <svg
      width="21px"
      height="21px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g fill="#000000">
          {" "}
          <path d="M1.5 1.25a.75.75 0 011.5 0v1.851A7 7 0 111 8a.75.75 0 011.5 0 5.5 5.5 0 101.725-4H5.75a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75v-3.5z"></path>{" "}
          <path d="M8.25 4a.75.75 0 01.75.75v3.763l1.805.802a.75.75 0 01-.61 1.37l-2.25-1A.75.75 0 017.5 9V4.75A.75.75 0 018.25 4z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  ),
  "service-company": (
    <svg
      fill="#000000"
      width="21px"
      height="21px"
      viewBox="0 0 24.00 24.00"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      stroke="#000000"
      strokeWidth="0.00024000000000000003"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="0.048"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M22,16H19.82A3,3,0,0,0,20,15V10a3,3,0,0,0-3-3H11a3,3,0,0,0-3,3v5a3,3,0,0,0,.18,1H7a1,1,0,0,1-1-1V5A3,3,0,0,0,3,2H2A1,1,0,0,0,2,4H3A1,1,0,0,1,4,5V15a3,3,0,0,0,2.22,2.88,3,3,0,1,0,5.6.12h3.36a3,3,0,1,0,5.64,0H22a1,1,0,0,0,0-2ZM9,20a1,1,0,1,1,1-1A1,1,0,0,1,9,20Zm2-4a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v5a1,1,0,0,1-1,1Zm7,4a1,1,0,1,1,1-1A1,1,0,0,1,18,20Z"></path>
      </g>
    </svg>
  ),
  Star: (
    <svg
      data-v-2f8a5019=""
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-filled"
    >
      <path
        data-v-2f8a5019=""
        stroke="none"
        d="M0 0h24v24H0z"
        fill="none"
      ></path>{" "}
      <path
        data-v-2f8a5019=""
        d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
      ></path>
    </svg>
  ),
  "blue-mark": (
    <svg
      style={{ color: "#2fb344" }}
      data-v-2f8a5019=""
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon me-1 text-success"
    >
      <path
        data-v-2f8a5019=""
        stroke="none"
        d="M0 0h24v24H0z"
        fill="none"
      ></path>{" "}
      <path data-v-2f8a5019="" d="M5 12l5 5l10 -10"></path>
    </svg>
  ),
  "red-mark": (
    <svg
      style={{ color: "#d63939" }}
      data-v-2f8a5019=""
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon me-1 text-danger"
    >
      <path
        data-v-2f8a5019=""
        stroke="none"
        d="M0 0h24v24H0z"
        fill="none"
      ></path>
      <line data-v-2f8a5019="" x1="18" y1="6" x2="6" y2="18"></line>{" "}
      <line data-v-2f8a5019="" x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  ),
  "user-outline": (
    <svg
      fill="#333"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#333"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9.641,9.641,0,0,1-5.209-1.674,7,7,0,0,1,10.418,0A9.167,9.167,0,0,1,12,21Zm6.694-3.006a8.98,8.98,0,0,0-13.388,0,9,9,0,1,1,13.388,0ZM12,6a4,4,0,1,0,4,4A4,4,0,0,0,12,6Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,12Z"></path>
      </g>
    </svg>
  ),
  starvn: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 576 512"
      fill="#686868"
    >
      <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
    </svg>
  ),
  "whatsapp-header": (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      id="meteor-icon-kit__regular-whatsapp"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="0.048"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5129 3.4866C18.2882 1.24722 15.2597 -0.00837473 12.1032 4.20445e-05C5.54964 4.20445e-05 0.216056 5.33306 0.213776 11.8883C0.210977 13.9746 0.75841 16.0247 1.80085 17.8319L0.114014 23.9932L6.41672 22.34C8.15975 23.2898 10.1131 23.7874 12.0981 23.7874H12.1032C18.6556 23.7874 23.9897 18.4538 23.992 11.8986C24.0022 8.74248 22.7494 5.71347 20.5129 3.4866ZM12.1032 21.7768H12.0992C10.3294 21.7776 8.59195 21.3025 7.06888 20.4012L6.70803 20.1874L2.96836 21.1685L3.96713 17.52L3.73169 17.1461C2.74331 15.5709 2.22039 13.7484 2.22328 11.8889C2.22328 6.44185 6.65615 2.00783 12.1072 2.00783C14.7284 2.00934 17.2417 3.05207 19.0941 4.90662C20.9465 6.76117 21.9863 9.27564 21.9848 11.8969C21.9825 17.3456 17.5496 21.7768 12.1032 21.7768ZM17.5234 14.3755C17.2264 14.2267 15.7659 13.5085 15.4934 13.4064C15.2209 13.3044 15.0231 13.2576 14.8253 13.5552C14.6275 13.8528 14.058 14.5215 13.8847 14.7199C13.7114 14.9182 13.5381 14.9427 13.241 14.794C12.944 14.6452 11.9869 14.3316 10.8519 13.3198C9.96884 12.5319 9.36969 11.5594 9.19867 11.2618C9.02765 10.9642 9.18043 10.8057 9.32922 10.6552C9.46261 10.5224 9.62622 10.3086 9.77444 10.1348C9.92266 9.9609 9.97283 9.83776 10.0714 9.63938C10.1701 9.44099 10.121 9.26769 10.0469 9.1189C9.97283 8.97011 9.37824 7.50788 9.13083 6.9133C8.88969 6.3341 8.64513 6.4122 8.46271 6.40023C8.29169 6.39168 8.09102 6.38997 7.89264 6.38997C7.58822 6.39793 7.30097 6.53267 7.10024 6.76166C6.82831 7.05923 6.061 7.77752 6.061 9.23976C6.061 10.702 7.12532 12.1146 7.27354 12.313C7.42176 12.5114 9.36855 15.5117 12.3472 16.7989C12.9004 17.0375 13.4657 17.2468 14.0409 17.426C14.7523 17.654 15.3999 17.6204 15.9118 17.544C16.4819 17.4585 17.6694 16.8251 17.9173 16.1313C18.1653 15.4376 18.1648 14.8424 18.0884 14.7187C18.012 14.595 17.8204 14.5266 17.5234 14.3778V14.3755Z"
          fill="#989898"
        ></path>
      </g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5129 3.4866C18.2882 1.24722 15.2597 -0.00837473 12.1032 4.20445e-05C5.54964 4.20445e-05 0.216056 5.33306 0.213776 11.8883C0.210977 13.9746 0.75841 16.0247 1.80085 17.8319L0.114014 23.9932L6.41672 22.34C8.15975 23.2898 10.1131 23.7874 12.0981 23.7874H12.1032C18.6556 23.7874 23.9897 18.4538 23.992 11.8986C24.0022 8.74248 22.7494 5.71347 20.5129 3.4866ZM12.1032 21.7768H12.0992C10.3294 21.7776 8.59195 21.3025 7.06888 20.4012L6.70803 20.1874L2.96836 21.1685L3.96713 17.52L3.73169 17.1461C2.74331 15.5709 2.22039 13.7484 2.22328 11.8889C2.22328 6.44185 6.65615 2.00783 12.1072 2.00783C14.7284 2.00934 17.2417 3.05207 19.0941 4.90662C20.9465 6.76117 21.9863 9.27564 21.9848 11.8969C21.9825 17.3456 17.5496 21.7768 12.1032 21.7768ZM17.5234 14.3755C17.2264 14.2267 15.7659 13.5085 15.4934 13.4064C15.2209 13.3044 15.0231 13.2576 14.8253 13.5552C14.6275 13.8528 14.058 14.5215 13.8847 14.7199C13.7114 14.9182 13.5381 14.9427 13.241 14.794C12.944 14.6452 11.9869 14.3316 10.8519 13.3198C9.96884 12.5319 9.36969 11.5594 9.19867 11.2618C9.02765 10.9642 9.18043 10.8057 9.32922 10.6552C9.46261 10.5224 9.62622 10.3086 9.77444 10.1348C9.92266 9.9609 9.97283 9.83776 10.0714 9.63938C10.1701 9.44099 10.121 9.26769 10.0469 9.1189C9.97283 8.97011 9.37824 7.50788 9.13083 6.9133C8.88969 6.3341 8.64513 6.4122 8.46271 6.40023C8.29169 6.39168 8.09102 6.38997 7.89264 6.38997C7.58822 6.39793 7.30097 6.53267 7.10024 6.76166C6.82831 7.05923 6.061 7.77752 6.061 9.23976C6.061 10.702 7.12532 12.1146 7.27354 12.313C7.42176 12.5114 9.36855 15.5117 12.3472 16.7989C12.9004 17.0375 13.4657 17.2468 14.0409 17.426C14.7523 17.654 15.3999 17.6204 15.9118 17.544C16.4819 17.4585 17.6694 16.8251 17.9173 16.1313C18.1653 15.4376 18.1648 14.8424 18.0884 14.7187C18.012 14.595 17.8204 14.5266 17.5234 14.3778V14.3755Z"
          fill="#989898"
        ></path>
      </g>
    </svg>
  ),
  "note-header": (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="#989898"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="0.16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2l1-1h9l1 1v12l-1 1H3l-1-1V2zm1 0v12h9V2H3zm1 2l1-1h5l1 1v1l-1 1H5L4 5V4zm1 0v1h5V4H5zm10 1h-1v2h1V5zm-1 3h1v2h-1V8zm1 3h-1v2h1v-2z"
        ></path>
      </g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2l1-1h9l1 1v12l-1 1H3l-1-1V2zm1 0v12h9V2H3zm1 2l1-1h5l1 1v1l-1 1H5L4 5V4zm1 0v1h5V4H5zm10 1h-1v2h1V5zm-1 3h1v2h-1V8zm1 3h-1v2h1v-2z"
        ></path>
      </g>
    </svg>
  ),
  "briefcase-header": (
    <svg
      fill="#424242"
      height="20px"
      width="20px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 297.001 297.001"
      stroke="#424242"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <g>
              {" "}
              <path d="M257.424,46.164h-50.117V33.563c0-16.984-13.819-30.803-30.804-30.803h-56.007c-16.984,0-30.803,13.819-30.803,30.803 v12.601H39.576C17.754,46.164,0,63.918,0,85.74v168.925c0,21.822,17.754,39.576,39.576,39.576h217.849 c21.822,0,39.576-17.754,39.576-39.576V85.74C297,63.918,279.246,46.164,257.424,46.164z M109.46,33.563 c0-6.086,4.95-11.036,11.036-11.036h56.007c6.086,0,11.037,4.95,11.037,11.036v12.601h-78.08V33.563z M277.231,254.664 c0.002,10.923-8.885,19.809-19.807,19.809H39.576c-10.922,0-19.809-8.887-19.809-19.809V175.34 c5.463,3.02,11.737,4.745,18.408,4.745h2.594v6.424c0,14.442,11.749,26.191,26.191,26.191s26.191-11.749,26.191-26.191v-6.424 h110.696v6.424c0,14.442,11.749,26.191,26.191,26.191s26.191-11.749,26.191-26.191v-6.424h2.594 c6.671,0,12.945-1.725,18.408-4.745V254.664z M60.537,186.51v-32.616c0-3.542,2.882-6.424,6.424-6.424s6.424,2.882,6.424,6.424 v32.616c0,3.542-2.882,6.424-6.424,6.424S60.537,190.052,60.537,186.51z M223.615,186.51v-32.616 c0-3.542,2.882-6.424,6.424-6.424s6.424,2.882,6.424,6.424v32.616c0,3.542-2.882,6.424-6.424,6.424 S223.615,190.052,223.615,186.51z M277.234,141.911c0,10.15-8.258,18.408-18.408,18.408h-2.594v-6.424 c0-14.442-11.749-26.191-26.191-26.191s-26.191,11.749-26.191,26.191v6.424H93.152v-6.424c0-14.442-11.749-26.191-26.191-26.191 s-26.191,11.748-26.191,26.19v6.424h-2.594c-10.15,0-18.408-8.258-18.408-18.408V85.74h-0.001 c0-10.922,8.886-19.809,19.809-19.809h217.849c10.922,0,19.809,8.886,19.809,19.809V141.911z"></path>{" "}
              <path d="M181.116,194.911h-65.231c-4.367,0-7.907,3.54-7.907,7.907s3.54,7.907,7.907,7.907h65.231 c4.367,0,7.907-3.54,7.907-7.907C189.022,198.451,185.482,194.911,181.116,194.911z"></path>{" "}
            </g>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  ),
  "share-android": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 13.5L15 16.5M15 7.5L9 10.5M18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21ZM6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15ZM18 9C16.3431 9 15 7.65685 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9Z"
        stroke="#686868"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  specialize: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12L12 18L3 12M21 16L12 22L3 16M21 8L12 14L3 8L12 2L21 8Z"
        stroke="#686868"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "container-d": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 15C13.8954 15 13 15.8954 13 17C13 18.1046 13.8954 19 15 19C16.1046 19 17 18.1046 17 17C17 15.8954 16.1046 15 15 15ZM15 15H7.29395C6.83269 15 6.60197 15 6.41211 14.918C6.24466 14.8456 6.09934 14.7288 5.99349 14.5802C5.87348 14.4118 5.82609 14.1863 5.72945 13.7353L3.27148 2.26477C3.17484 1.81376 3.12587 1.58825 3.00586 1.4198C2.90002 1.27123 2.75525 1.15441 2.5878 1.08205C2.39794 1 2.16779 1 1.70653 1H1M4 4H16.8732C17.595 4 17.9557 4 18.1979 4.15036C18.4101 4.28206 18.5652 4.48838 18.6329 4.72876C18.7102 5.00319 18.611 5.34996 18.411 6.04346L17.0264 10.8435C16.9068 11.2581 16.8469 11.4655 16.7256 11.6193C16.6185 11.7551 16.4772 11.8608 16.3171 11.926C16.1356 12 15.9199 12 15.4883 12H5.73047M6 19C4.89543 19 4 18.1046 4 17C4 15.8954 4.89543 15 6 15C7.10457 15 8 15.8954 8 17C8 18.1046 7.10457 19 6 19Z"
        stroke="#686868"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "chat-conver-d": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8H20C20.5523 8 21 8.44772 21 9V20L17.6665 17.2308C17.487 17.0817 17.2612 17 17.0278 17H9C8.44771 17 8 16.5523 8 16V13M15 4C15.5523 4 16 4.44772 16 5V12C16 12.5523 15.5523 13 15 13H6.97217C6.73875 13 6.51304 13.0817 6.3335 13.2308L3 16V5C3 4.44772 3.44772 4 4 4H15Z"
        stroke="#686868"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "calendar-d": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9V7ZM20 9C20.5523 9 21 8.55228 21 8C21 7.44772 20.5523 7 20 7V9ZM5.0918 19.782L5.54579 18.891H5.54579L5.0918 19.782ZM4.21799 18.908L3.32698 19.362H3.32698L4.21799 18.908ZM19.7822 18.908L18.8912 18.454L19.7822 18.908ZM18.9078 19.782L18.4538 18.891L18.9078 19.782ZM18.9078 4.21799L19.3618 3.32698V3.32698L18.9078 4.21799ZM19.7822 5.09204L18.8912 5.54603L19.7822 5.09204ZM5.0918 4.21799L5.54579 5.10899L5.0918 4.21799ZM4.21799 5.09204L5.10899 5.54603L4.21799 5.09204ZM14.5 15C15.0523 15 15.5 14.5523 15.5 14C15.5 13.4477 15.0523 13 14.5 13V15ZM9.5 13C8.94772 13 8.5 13.4477 8.5 14C8.5 14.5523 8.94772 15 9.5 15V13ZM13 11.5C13 10.9477 12.5523 10.5 12 10.5C11.4477 10.5 11 10.9477 11 11.5H13ZM11 16.5C11 17.0523 11.4477 17.5 12 17.5C12.5523 17.5 13 17.0523 13 16.5H11ZM17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2H17ZM15 4C15 4.55228 15.4477 5 16 5C16.5523 5 17 4.55228 17 4H15ZM9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2H9ZM7 4C7 4.55228 7.44772 5 8 5C8.55228 5 9 4.55228 9 4H7ZM4 9H20V7H4V9ZM7.2002 5H16.8002V3H7.2002V5ZM19 7.19995V16.8H21V7.19995H19ZM16.8002 19H7.2002V21H16.8002V19ZM5 16.8V7.19995H3V16.8H5ZM7.2002 19C6.62367 19 6.25127 18.9992 5.96782 18.9761C5.69598 18.9538 5.59519 18.9161 5.54579 18.891L4.63781 20.673C5.01623 20.8658 5.40959 20.9371 5.80496 20.9694C6.18873 21.0008 6.65662 21 7.2002 21V19ZM3 16.8C3 17.3435 2.99922 17.8113 3.03057 18.195C3.06287 18.5904 3.13418 18.9836 3.32698 19.362L5.10899 18.454C5.08381 18.4046 5.04613 18.3039 5.02393 18.0322C5.00078 17.7488 5 17.3765 5 16.8H3ZM5.54579 18.891C5.35778 18.7952 5.20494 18.6424 5.10899 18.454L3.32698 19.362C3.61452 19.9264 4.07317 20.3853 4.63781 20.673L5.54579 18.891ZM19 16.8C19 17.3766 18.9993 17.7489 18.9762 18.0323C18.954 18.3041 18.9163 18.4047 18.8912 18.454L20.6732 19.362C20.8661 18.9835 20.9373 18.5902 20.9696 18.1949C21.0008 17.8112 21 17.3434 21 16.8H19ZM16.8002 21C17.3438 21 17.8115 21.0008 18.1951 20.9694C18.5904 20.9371 18.9835 20.8657 19.3618 20.673L18.4538 18.891C18.4043 18.9162 18.3036 18.9539 18.0321 18.9761C17.7489 18.9992 17.3767 19 16.8002 19V21ZM18.8912 18.454C18.7956 18.6417 18.6425 18.7948 18.4538 18.891L19.3618 20.673C19.9257 20.3856 20.3853 19.927 20.6732 19.362L18.8912 18.454ZM16.8002 5C17.3768 5 17.7489 5.00078 18.0321 5.02393C18.3036 5.04611 18.4043 5.08377 18.4538 5.10899L19.3618 3.32698C18.9835 3.13421 18.5904 3.06288 18.1951 3.03057C17.8115 2.99922 17.3437 3 16.8002 3V5ZM21 7.19995C21 6.6565 21.0008 6.1887 20.9695 5.80511C20.9373 5.40983 20.8661 5.01653 20.6732 4.63805L18.8912 5.54603C18.9164 5.59537 18.954 5.69598 18.9762 5.96767C18.9993 6.25105 19 6.6233 19 7.19995H21ZM18.4538 5.10899C18.6424 5.20508 18.7956 5.35828 18.8912 5.54603L20.6732 4.63805C20.3854 4.07315 19.9259 3.61439 19.3618 3.32698L18.4538 5.10899ZM7.2002 3C6.65663 3 6.18874 2.99922 5.80498 3.03057C5.40962 3.06286 5.01624 3.13416 4.63781 3.32698L5.54579 5.10899C5.59517 5.08383 5.69595 5.04613 5.9678 5.02393C6.25126 5.00078 6.62365 5 7.2002 5V3ZM5 7.19995C5 6.6234 5.00078 6.25114 5.02393 5.96783C5.04612 5.6962 5.0838 5.59549 5.10899 5.54603L3.32698 4.63805C3.13419 5.01642 3.06287 5.40961 3.03057 5.80495C2.99922 6.18861 3 6.6564 3 7.19995H5ZM4.63781 3.32698C4.07306 3.61473 3.61447 4.07382 3.32698 4.63805L5.10899 5.54603C5.205 5.35761 5.35788 5.20474 5.54579 5.10899L4.63781 3.32698ZM14.5 13H9.5V15H14.5V13ZM11 11.5V16.5H13V11.5H11ZM15 2V4H17V2H15ZM7 2V4H9V2H7Z"
        fill="#686868"
      />
    </svg>
  ),
  "link-d": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.17185 14.8285L14.8287 9.17166M7.0509 11.2929L5.63669 12.7071C4.07459 14.2692 4.07429 16.8018 5.63639 18.3639C7.19848 19.926 9.73145 19.926 11.2935 18.3639L12.7072 16.9497M11.2929 7.05011L12.7072 5.6359C14.2693 4.0738 16.8018 4.07386 18.3639 5.63596C19.926 7.19806 19.9263 9.73065 18.3642 11.2928L16.9502 12.707"
        stroke="#686868"
        strokeOpacity="0.7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "clock-company": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7H13ZM12 12H11C11 12.5523 11.4477 13 12 13V12ZM17 13C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11V13ZM20.3608 5.33719C20.7839 5.6922 21.4147 5.63701 21.7697 5.21394C22.1247 4.79086 22.0695 4.16011 21.6464 3.80511L20.3608 5.33719ZM18.5822 1.23396C18.1592 0.878954 17.5284 0.934138 17.1734 1.35721C16.8184 1.78029 16.8736 2.41104 17.2967 2.76604L18.5822 1.23396ZM6.70697 2.76617C7.13004 2.41116 7.18522 1.78041 6.83022 1.35733C6.47522 0.93426 5.84446 0.879076 5.42139 1.23408L6.70697 2.76617ZM2.35721 3.80523C1.93414 4.16023 1.87895 4.79099 2.23396 5.21406C2.58896 5.63713 3.21971 5.69232 3.64279 5.33732L2.35721 3.80523ZM11 7V12H13V7H11ZM12 13H17V11H12V13ZM12 19C8.13401 19 5 15.866 5 12H3C3 16.9706 7.02944 21 12 21V19ZM5 12C5 8.13401 8.13401 5 12 5V3C7.02944 3 3 7.02944 3 12H5ZM12 5C15.866 5 19 8.13401 19 12H21C21 7.02944 16.9706 3 12 3V5ZM19 12C19 15.866 15.866 19 12 19V21C16.9706 21 21 16.9706 21 12H19ZM21.6464 3.80511L18.5822 1.23396L17.2967 2.76604L20.3608 5.33719L21.6464 3.80511ZM5.42139 1.23408L2.35721 3.80523L3.64279 5.33732L6.70697 2.76617L5.42139 1.23408Z"
        fill="#686868"
        fillOpacity="0.68"
      />
    </svg>
  ),
  "user-plus": (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512">
      <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
    </svg>
  ),
  "chevron-left": (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512">
      <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
    </svg>
  ),
  "chevron-right": (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512">
      <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
    </svg>
  ),
  bookmark: (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
      <path d="M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z" />
    </svg>
  ),
  "user-check": (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512">
      <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
    </svg>
  ),
  briefcase: (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
      <path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z" />
    </svg>
  ),
  "experience-company": (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 5C14 2.79086 12.2091 1 10 1C7.79086 1 6 2.79086 6 5M19 8.19995V13.8C19 14.9201 19.0002 15.4802 18.7822 15.908C18.5905 16.2844 18.2841 16.5902 17.9078 16.782C17.48 17 16.9203 17 15.8002 17H4.2002C3.08009 17 2.51962 17 2.0918 16.782C1.71547 16.5902 1.40973 16.2844 1.21799 15.908C1 15.4802 1 14.9201 1 13.8V8.19995C1 7.07985 1 6.51986 1.21799 6.09204C1.40973 5.71572 1.71547 5.40973 2.0918 5.21799C2.51962 5 3.08009 5 4.2002 5H15.8002C16.9203 5 17.48 5 17.9078 5.21799C18.2841 5.40973 18.5905 5.71572 18.7822 6.09204C19.0002 6.51986 19 7.07985 19 8.19995Z"
        stroke="#686868"
        strokeOpacity="0.68"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "map-company": (
    <svg
      width="24px"
      height="20px"
      viewBox="-20.48 -20.48 1064.96 1064.96"
      xmlns="http://www.w3.org/2000/svg"
      fill="#959698"
      stroke="#959698"
      strokeWidth="26.624000000000002"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="4.096"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#959698"
          d="M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416zM512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544z"
        ></path>
        <path
          fill="#959698"
          d="M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192zm0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320z"
        ></path>
      </g>
    </svg>
  ),
  "job-company": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 20H22M7 10H11M14 20H20V12C20 11.0681 19.9999 10.6022 19.8477 10.2346C19.6447 9.74456 19.2554 9.35523 18.7654 9.15224C18.3978 9 17.9321 9 17.0002 9C16.0683 9 15.6024 9 15.2349 9.15224C14.7448 9.35523 14.3552 9.74456 14.1522 10.2346C14 10.6022 14 11.0681 14 12V20ZM14 20V6.19995C14 5.07985 14.0002 4.51986 13.7822 4.09204C13.5905 3.71572 13.2841 3.40973 12.9078 3.21799C12.48 3 11.9203 3 10.8002 3H7.2002C6.08009 3 5.51962 3 5.0918 3.21799C4.71547 3.40973 4.40973 3.71572 4.21799 4.09204C4 4.51986 4 5.07985 4 6.19995V20H14ZM7 7L11 7"
        stroke="#686868"
        strokeOpacity="0.68"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "save-gray": (
    <svg
      data-v-0db2ad03=""
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icon-tabler-bookmark m-0"
    >
      <path
        data-v-0db2ad03=""
        stroke="none"
        d="M0 0h24v24H0z"
        fill="none"
      ></path>
      <path
        data-v-0db2ad03=""
        d="M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2"
      ></path>
    </svg>
  ),
  "job-building": (
    <svg
      data-v-0db2ad03=""
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
      className="bi bi-building me-1"
    >
      <path
        data-v-0db2ad03=""
        fillRule="evenodd"
        d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"
      ></path>
      <path
        data-v-0db2ad03=""
        d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"
      ></path>
    </svg>
  ),
}
